var L = "Roboto", b = "regular", T = "normal";
function F(e) {
  return `${e.family}|${e.weight}|${e.style}`;
}
function D(e, t, n) {
  const s = F(t), i = e.get(s);
  if (i) return i;
  const r = [
    {
      family: t.family,
      weight: t.weight,
      style: T
    },
    {
      family: t.family,
      weight: b,
      style: T
    },
    {
      family: L,
      weight: t.weight,
      style: t.style
    },
    {
      family: L,
      weight: t.weight,
      style: T
    },
    {
      family: L,
      weight: b,
      style: T
    }
  ];
  for (const a of r) {
    const o = e.get(F(a));
    if (o)
      return n?.(s, a), o;
  }
  throw new Error(`[Text] No fallback available for "${t.family} ${t.weight} ${t.style}"; the default "${L} ${b} ${T}" must be bundled.`);
}
var _ = {
  "Bungee|regular|normal": {
    emSize: 80,
    commonLineHeight: 106,
    capTop: 24,
    advances: [
      18,
      34,
      52,
      60,
      52,
      82,
      61,
      28,
      34,
      34,
      57,
      59,
      31,
      34,
      31,
      28,
      58,
      48,
      51,
      51,
      57,
      52,
      55,
      50,
      57,
      55,
      31,
      31,
      57,
      59,
      57,
      52,
      69,
      58,
      58,
      50,
      60,
      52,
      49,
      57,
      61,
      48,
      55,
      60,
      56,
      68,
      60,
      59,
      55,
      59,
      59,
      52,
      52,
      60,
      58,
      66,
      59,
      56,
      53,
      34,
      28,
      34,
      57,
      59,
      40,
      58,
      58,
      50,
      60,
      52,
      49,
      57,
      61,
      48,
      55,
      60,
      56,
      68,
      60,
      59,
      55,
      59,
      59,
      52,
      52,
      60,
      58,
      66,
      59,
      56,
      53,
      36,
      28,
      36,
      59
    ],
    extraAdvances: [
      162,
      50,
      163,
      56,
      165,
      56,
      176,
      39,
      183,
      29,
      215,
      59,
      8211,
      59,
      8212,
      91,
      8216,
      31,
      8217,
      31,
      8220,
      55,
      8221,
      55,
      8230,
      89,
      8364,
      52,
      8377,
      49
    ],
    kernings: [
      32,
      74,
      -1,
      32,
      84,
      -1,
      32,
      89,
      -1,
      32,
      106,
      -1,
      32,
      116,
      -1,
      32,
      121,
      -1,
      34,
      56,
      -1,
      34,
      65,
      -1,
      34,
      74,
      -2,
      34,
      88,
      -1,
      34,
      97,
      -1,
      34,
      106,
      -2,
      34,
      120,
      -1,
      38,
      84,
      -4,
      38,
      89,
      -2,
      38,
      116,
      -4,
      38,
      121,
      -2,
      39,
      56,
      -1,
      39,
      65,
      -1,
      39,
      74,
      -2,
      39,
      88,
      -1,
      39,
      97,
      -1,
      39,
      106,
      -2,
      39,
      120,
      -1,
      42,
      44,
      -4,
      42,
      46,
      -4,
      42,
      65,
      -1,
      42,
      74,
      -1,
      42,
      84,
      -1,
      42,
      88,
      -1,
      42,
      97,
      -1,
      42,
      106,
      -1,
      42,
      116,
      -1,
      42,
      120,
      -1,
      43,
      49,
      -2,
      43,
      51,
      -1,
      43,
      55,
      -2,
      43,
      56,
      -1,
      44,
      32,
      -1,
      44,
      52,
      -2,
      44,
      55,
      -2,
      44,
      57,
      -2,
      45,
      49,
      -2,
      45,
      51,
      -2,
      45,
      55,
      -2,
      45,
      73,
      -2,
      45,
      84,
      -3,
      45,
      89,
      -1,
      45,
      90,
      -2,
      45,
      105,
      -2,
      45,
      116,
      -3,
      45,
      121,
      -1,
      45,
      122,
      -2,
      46,
      32,
      -1,
      46,
      52,
      -2,
      46,
      55,
      -2,
      46,
      57,
      -2,
      47,
      56,
      -2,
      47,
      65,
      -1,
      47,
      67,
      -1,
      47,
      71,
      -1,
      47,
      74,
      -2,
      47,
      79,
      -1,
      47,
      81,
      -1,
      47,
      88,
      -1,
      47,
      97,
      -1,
      47,
      99,
      -1,
      47,
      103,
      -1,
      47,
      106,
      -2,
      47,
      111,
      -1,
      47,
      113,
      -1,
      47,
      120,
      -1,
      49,
      34,
      -4,
      49,
      37,
      -5,
      49,
      39,
      -4,
      49,
      42,
      -2,
      49,
      43,
      -2,
      49,
      45,
      -3,
      49,
      52,
      -2,
      49,
      60,
      -2,
      49,
      61,
      -2,
      50,
      60,
      -1,
      51,
      34,
      -2,
      51,
      37,
      -2,
      51,
      39,
      -2,
      51,
      52,
      -1,
      51,
      55,
      -1,
      51,
      60,
      -2,
      53,
      55,
      -1,
      54,
      34,
      -1,
      54,
      37,
      -2,
      54,
      39,
      -1,
      54,
      52,
      -1,
      54,
      55,
      -1,
      54,
      63,
      -1,
      55,
      44,
      -3,
      55,
      46,
      -3,
      55,
      47,
      -2,
      55,
      60,
      -1,
      55,
      62,
      -1,
      56,
      34,
      -1,
      56,
      37,
      -2,
      56,
      39,
      -1,
      56,
      43,
      -1,
      56,
      51,
      -1,
      56,
      52,
      -1,
      56,
      55,
      -1,
      56,
      61,
      -1,
      56,
      63,
      -1,
      56,
      92,
      -2,
      61,
      49,
      -2,
      61,
      51,
      -1,
      61,
      55,
      -2,
      61,
      56,
      -1,
      62,
      49,
      -2,
      62,
      52,
      -1,
      62,
      55,
      -2,
      65,
      34,
      -1,
      65,
      39,
      -1,
      65,
      42,
      -1,
      65,
      63,
      -1,
      65,
      84,
      -3,
      65,
      86,
      -1,
      65,
      89,
      -2,
      65,
      92,
      -1,
      65,
      116,
      -3,
      65,
      118,
      -1,
      65,
      121,
      -2,
      66,
      34,
      -1,
      66,
      39,
      -1,
      66,
      42,
      -1,
      66,
      63,
      -1,
      66,
      84,
      -2,
      66,
      89,
      -2,
      66,
      92,
      -2,
      66,
      116,
      -2,
      66,
      121,
      -2,
      67,
      42,
      -1,
      67,
      45,
      -2,
      68,
      47,
      -1,
      68,
      92,
      -1,
      69,
      42,
      -1,
      69,
      45,
      -2,
      70,
      32,
      -1,
      70,
      38,
      -2,
      70,
      44,
      -2,
      70,
      45,
      -2,
      70,
      46,
      -2,
      70,
      47,
      -3,
      70,
      65,
      -3,
      70,
      74,
      -5,
      70,
      88,
      -2,
      70,
      97,
      -3,
      70,
      106,
      -5,
      70,
      120,
      -2,
      71,
      34,
      -1,
      71,
      39,
      -1,
      71,
      42,
      -1,
      71,
      63,
      -2,
      71,
      89,
      -2,
      71,
      92,
      -1,
      71,
      121,
      -2,
      73,
      45,
      -2,
      74,
      47,
      -1,
      75,
      34,
      -1,
      75,
      39,
      -1,
      75,
      42,
      -1,
      75,
      63,
      -1,
      75,
      84,
      -2,
      75,
      89,
      -2,
      75,
      92,
      -1,
      75,
      116,
      -2,
      75,
      121,
      -2,
      76,
      32,
      -1,
      76,
      34,
      -2,
      76,
      39,
      -2,
      76,
      42,
      -1,
      76,
      63,
      -2,
      76,
      84,
      -6,
      76,
      86,
      -2,
      76,
      87,
      -1,
      76,
      89,
      -4,
      76,
      92,
      -2,
      76,
      116,
      -6,
      76,
      118,
      -2,
      76,
      119,
      -1,
      76,
      121,
      -4,
      79,
      47,
      -1,
      79,
      92,
      -1,
      80,
      32,
      -1,
      80,
      44,
      -2,
      80,
      46,
      -2,
      80,
      47,
      -1,
      80,
      65,
      -1,
      80,
      90,
      -1,
      80,
      97,
      -1,
      80,
      122,
      -1,
      81,
      47,
      -1,
      81,
      92,
      -1,
      82,
      34,
      -1,
      82,
      39,
      -1,
      82,
      42,
      -1,
      82,
      63,
      -1,
      82,
      84,
      -2,
      82,
      86,
      -1,
      82,
      89,
      -2,
      82,
      92,
      -2,
      82,
      116,
      -2,
      82,
      118,
      -1,
      82,
      121,
      -2,
      83,
      84,
      -1,
      83,
      89,
      -1,
      83,
      116,
      -1,
      83,
      121,
      -1,
      84,
      32,
      -1,
      84,
      38,
      -2,
      84,
      42,
      -1,
      84,
      44,
      -6,
      84,
      45,
      -3,
      84,
      46,
      -6,
      84,
      47,
      -3,
      84,
      65,
      -3,
      84,
      74,
      -7,
      84,
      88,
      -1,
      84,
      90,
      -1,
      84,
      97,
      -3,
      84,
      106,
      -7,
      84,
      120,
      -1,
      84,
      122,
      -1,
      85,
      47,
      -1,
      86,
      38,
      -1,
      86,
      44,
      -2,
      86,
      46,
      -2,
      86,
      47,
      -1,
      86,
      65,
      -1,
      86,
      74,
      -2,
      86,
      97,
      -1,
      86,
      106,
      -2,
      87,
      44,
      -1,
      87,
      46,
      -1,
      88,
      34,
      -1,
      88,
      39,
      -1,
      88,
      42,
      -1,
      88,
      63,
      -1,
      88,
      84,
      -1,
      88,
      89,
      -2,
      88,
      92,
      -1,
      88,
      116,
      -1,
      88,
      121,
      -2,
      89,
      32,
      -1,
      89,
      38,
      -2,
      89,
      44,
      -4,
      89,
      45,
      -1,
      89,
      46,
      -4,
      89,
      47,
      -1,
      89,
      65,
      -2,
      89,
      74,
      -4,
      89,
      88,
      -2,
      89,
      90,
      -1,
      89,
      97,
      -2,
      89,
      106,
      -4,
      89,
      120,
      -2,
      89,
      122,
      -1,
      90,
      45,
      -2,
      90,
      74,
      -1,
      90,
      84,
      -1,
      90,
      89,
      -1,
      90,
      106,
      -1,
      90,
      116,
      -1,
      90,
      121,
      -1,
      92,
      52,
      -3,
      92,
      55,
      -2,
      92,
      57,
      -2,
      92,
      67,
      -1,
      92,
      71,
      -1,
      92,
      79,
      -1,
      92,
      81,
      -1,
      92,
      84,
      -3,
      92,
      85,
      -1,
      92,
      86,
      -1,
      92,
      89,
      -1,
      92,
      99,
      -1,
      92,
      103,
      -1,
      92,
      111,
      -1,
      92,
      113,
      -1,
      92,
      116,
      -3,
      92,
      117,
      -1,
      92,
      118,
      -1,
      92,
      121,
      -1,
      97,
      34,
      -1,
      97,
      39,
      -1,
      97,
      42,
      -1,
      97,
      63,
      -1,
      97,
      84,
      -3,
      97,
      86,
      -1,
      97,
      89,
      -2,
      97,
      92,
      -1,
      97,
      116,
      -3,
      97,
      118,
      -1,
      97,
      121,
      -2,
      98,
      34,
      -1,
      98,
      39,
      -1,
      98,
      42,
      -1,
      98,
      63,
      -1,
      98,
      84,
      -2,
      98,
      89,
      -2,
      98,
      92,
      -2,
      98,
      116,
      -2,
      98,
      121,
      -2,
      99,
      42,
      -1,
      99,
      45,
      -2,
      100,
      47,
      -1,
      100,
      92,
      -1,
      101,
      42,
      -1,
      101,
      45,
      -2,
      102,
      32,
      -1,
      102,
      38,
      -2,
      102,
      44,
      -2,
      102,
      45,
      -2,
      102,
      46,
      -2,
      102,
      47,
      -3,
      102,
      65,
      -3,
      102,
      74,
      -5,
      102,
      88,
      -2,
      102,
      97,
      -3,
      102,
      106,
      -5,
      102,
      120,
      -2,
      103,
      34,
      -1,
      103,
      39,
      -1,
      103,
      42,
      -1,
      103,
      63,
      -2,
      103,
      89,
      -2,
      103,
      92,
      -1,
      103,
      121,
      -2,
      105,
      45,
      -2,
      106,
      47,
      -1,
      107,
      34,
      -1,
      107,
      39,
      -1,
      107,
      42,
      -1,
      107,
      63,
      -1,
      107,
      84,
      -2,
      107,
      89,
      -2,
      107,
      92,
      -1,
      107,
      116,
      -2,
      107,
      121,
      -2,
      108,
      32,
      -1,
      108,
      34,
      -2,
      108,
      39,
      -2,
      108,
      42,
      -1,
      108,
      63,
      -2,
      108,
      84,
      -6,
      108,
      86,
      -2,
      108,
      87,
      -1,
      108,
      89,
      -4,
      108,
      92,
      -2,
      108,
      116,
      -6,
      108,
      118,
      -2,
      108,
      119,
      -1,
      108,
      121,
      -4,
      111,
      47,
      -1,
      111,
      92,
      -1,
      112,
      32,
      -1,
      112,
      44,
      -2,
      112,
      46,
      -2,
      112,
      47,
      -1,
      112,
      65,
      -1,
      112,
      90,
      -1,
      112,
      97,
      -1,
      112,
      122,
      -1,
      113,
      47,
      -1,
      113,
      92,
      -1,
      114,
      34,
      -1,
      114,
      39,
      -1,
      114,
      42,
      -1,
      114,
      63,
      -1,
      114,
      84,
      -2,
      114,
      86,
      -1,
      114,
      89,
      -2,
      114,
      92,
      -2,
      114,
      116,
      -2,
      114,
      118,
      -1,
      114,
      121,
      -2,
      115,
      84,
      -1,
      115,
      89,
      -1,
      115,
      116,
      -1,
      115,
      121,
      -1,
      116,
      32,
      -1,
      116,
      38,
      -2,
      116,
      42,
      -1,
      116,
      44,
      -6,
      116,
      45,
      -3,
      116,
      46,
      -6,
      116,
      47,
      -3,
      116,
      65,
      -3,
      116,
      74,
      -7,
      116,
      88,
      -1,
      116,
      90,
      -1,
      116,
      97,
      -3,
      116,
      106,
      -7,
      116,
      120,
      -1,
      116,
      122,
      -1,
      117,
      47,
      -1,
      118,
      38,
      -1,
      118,
      44,
      -2,
      118,
      46,
      -2,
      118,
      47,
      -1,
      118,
      65,
      -1,
      118,
      74,
      -2,
      118,
      97,
      -1,
      118,
      106,
      -2,
      119,
      44,
      -1,
      119,
      46,
      -1,
      120,
      34,
      -1,
      120,
      39,
      -1,
      120,
      42,
      -1,
      120,
      63,
      -1,
      120,
      84,
      -1,
      120,
      89,
      -2,
      120,
      92,
      -1,
      120,
      116,
      -1,
      120,
      121,
      -2,
      121,
      32,
      -1,
      121,
      38,
      -2,
      121,
      44,
      -4,
      121,
      45,
      -1,
      121,
      46,
      -4,
      121,
      47,
      -1,
      121,
      65,
      -2,
      121,
      74,
      -4,
      121,
      88,
      -2,
      121,
      90,
      -1,
      121,
      97,
      -2,
      121,
      106,
      -4,
      121,
      120,
      -2,
      121,
      122,
      -1,
      122,
      45,
      -2,
      122,
      74,
      -1,
      122,
      84,
      -1,
      122,
      89,
      -1,
      122,
      106,
      -1,
      122,
      116,
      -1,
      122,
      121,
      -1,
      32,
      8216,
      -1,
      32,
      8220,
      -1,
      44,
      8216,
      -4,
      44,
      8217,
      -6,
      44,
      8220,
      -4,
      44,
      8221,
      -6,
      46,
      8216,
      -4,
      46,
      8217,
      -6,
      46,
      8220,
      -4,
      46,
      8221,
      -6,
      49,
      8216,
      -4,
      49,
      8217,
      -4,
      49,
      8220,
      -4,
      49,
      8221,
      -4,
      49,
      8211,
      -3,
      49,
      8212,
      -3,
      51,
      8216,
      -2,
      51,
      8217,
      -2,
      51,
      8220,
      -2,
      51,
      8221,
      -2,
      54,
      8216,
      -1,
      54,
      8217,
      -1,
      54,
      8220,
      -1,
      54,
      8221,
      -1,
      56,
      8216,
      -1,
      56,
      8217,
      -1,
      56,
      8220,
      -1,
      56,
      8221,
      -1,
      65,
      8216,
      -1,
      65,
      8217,
      -1,
      65,
      8220,
      -1,
      65,
      8221,
      -1,
      66,
      8216,
      -1,
      66,
      8217,
      -1,
      66,
      8220,
      -1,
      66,
      8221,
      -1,
      67,
      8211,
      -2,
      67,
      8212,
      -2,
      69,
      8211,
      -2,
      69,
      8212,
      -2,
      70,
      8211,
      -2,
      70,
      8212,
      -2,
      71,
      8216,
      -1,
      71,
      8217,
      -1,
      71,
      8220,
      -1,
      71,
      8221,
      -1,
      73,
      8211,
      -2,
      73,
      8212,
      -2,
      75,
      8216,
      -1,
      75,
      8217,
      -1,
      75,
      8220,
      -1,
      75,
      8221,
      -1,
      76,
      8216,
      -2,
      76,
      8217,
      -2,
      76,
      8220,
      -2,
      76,
      8221,
      -2,
      82,
      8216,
      -1,
      82,
      8217,
      -2,
      82,
      8220,
      -1,
      82,
      8221,
      -2,
      83,
      8216,
      -1,
      83,
      8217,
      -1,
      83,
      8220,
      -1,
      83,
      8221,
      -1,
      84,
      8211,
      -3,
      84,
      8212,
      -3,
      88,
      8216,
      -1,
      88,
      8217,
      -1,
      88,
      8220,
      -1,
      88,
      8221,
      -1,
      89,
      8211,
      -1,
      89,
      8212,
      -1,
      90,
      8217,
      -1,
      90,
      8221,
      -1,
      90,
      8211,
      -2,
      90,
      8212,
      -2,
      97,
      8216,
      -1,
      97,
      8217,
      -1,
      97,
      8220,
      -1,
      97,
      8221,
      -1,
      98,
      8216,
      -1,
      98,
      8217,
      -1,
      98,
      8220,
      -1,
      98,
      8221,
      -1,
      99,
      8211,
      -2,
      99,
      8212,
      -2,
      101,
      8211,
      -2,
      101,
      8212,
      -2,
      102,
      8211,
      -2,
      102,
      8212,
      -2,
      103,
      8216,
      -1,
      103,
      8217,
      -1,
      103,
      8220,
      -1,
      103,
      8221,
      -1,
      105,
      8211,
      -2,
      105,
      8212,
      -2,
      107,
      8216,
      -1,
      107,
      8217,
      -1,
      107,
      8220,
      -1,
      107,
      8221,
      -1,
      108,
      8216,
      -2,
      108,
      8217,
      -2,
      108,
      8220,
      -2,
      108,
      8221,
      -2,
      114,
      8216,
      -1,
      114,
      8217,
      -2,
      114,
      8220,
      -1,
      114,
      8221,
      -2,
      115,
      8216,
      -1,
      115,
      8217,
      -1,
      115,
      8220,
      -1,
      115,
      8221,
      -1,
      116,
      8211,
      -3,
      116,
      8212,
      -3,
      120,
      8216,
      -1,
      120,
      8217,
      -1,
      120,
      8220,
      -1,
      120,
      8221,
      -1,
      121,
      8211,
      -1,
      121,
      8212,
      -1,
      122,
      8217,
      -1,
      122,
      8221,
      -1,
      122,
      8211,
      -2,
      122,
      8212,
      -2,
      8216,
      44,
      -4,
      8216,
      46,
      -4,
      8216,
      49,
      -1,
      8216,
      56,
      -1,
      8217,
      32,
      -1,
      8217,
      44,
      -6,
      8217,
      46,
      -6,
      8217,
      49,
      -1,
      8217,
      56,
      -1,
      8220,
      44,
      -4,
      8220,
      46,
      -4,
      8220,
      49,
      -1,
      8220,
      56,
      -1,
      8221,
      32,
      -1,
      8221,
      44,
      -6,
      8221,
      46,
      -6,
      8221,
      49,
      -1,
      8221,
      56,
      -1,
      8211,
      49,
      -2,
      8211,
      51,
      -2,
      8211,
      55,
      -2,
      8211,
      73,
      -2,
      8211,
      84,
      -3,
      8211,
      89,
      -1,
      8211,
      90,
      -2,
      8211,
      105,
      -2,
      8211,
      116,
      -3,
      8211,
      121,
      -1,
      8211,
      122,
      -2,
      8212,
      49,
      -2,
      8212,
      51,
      -2,
      8212,
      55,
      -2,
      8212,
      73,
      -2,
      8212,
      84,
      -3,
      8212,
      89,
      -1,
      8212,
      90,
      -2,
      8212,
      105,
      -2,
      8212,
      116,
      -3,
      8212,
      121,
      -1,
      8212,
      122,
      -2,
      49,
      176,
      -5,
      49,
      215,
      -2,
      49,
      183,
      -2,
      51,
      176,
      -2,
      56,
      176,
      -2,
      56,
      215,
      -1,
      67,
      183,
      -2,
      69,
      183,
      -2,
      70,
      183,
      -2,
      73,
      183,
      -2,
      84,
      183,
      -2,
      90,
      183,
      -1,
      99,
      183,
      -2,
      101,
      183,
      -2,
      102,
      183,
      -2,
      105,
      183,
      -2,
      116,
      183,
      -2,
      122,
      183,
      -1,
      8364,
      52,
      -2,
      176,
      44,
      -4,
      176,
      46,
      -4,
      176,
      49,
      -2,
      176,
      56,
      -2,
      215,
      49,
      -2,
      215,
      51,
      -1,
      215,
      55,
      -2,
      215,
      56,
      -1,
      183,
      49,
      -2,
      183,
      55,
      -2,
      183,
      73,
      -2,
      183,
      84,
      -2,
      183,
      90,
      -1,
      183,
      105,
      -2,
      183,
      116,
      -2,
      183,
      122,
      -1
    ]
  },
  "Caveat|bold|normal": {
    emSize: 80,
    commonLineHeight: 101,
    capTop: 19,
    advances: [
      19,
      17,
      19,
      45,
      36,
      48,
      45,
      9,
      26,
      26,
      29,
      36,
      16,
      26,
      16,
      26,
      36,
      36,
      36,
      36,
      36,
      35,
      38,
      36,
      36,
      35,
      16,
      16,
      36,
      36,
      36,
      30,
      51,
      41,
      42,
      38,
      47,
      43,
      37,
      40,
      46,
      33,
      25,
      41,
      34,
      58,
      50,
      40,
      37,
      39,
      44,
      40,
      37,
      39,
      39,
      58,
      42,
      40,
      42,
      26,
      26,
      26,
      36,
      36,
      28,
      36,
      36,
      29,
      32,
      27,
      24,
      29,
      38,
      16,
      17,
      30,
      14,
      46,
      37,
      29,
      30,
      30,
      29,
      28,
      26,
      30,
      26,
      41,
      27,
      27,
      25,
      26,
      26,
      26,
      36
    ],
    extraAdvances: [
      162,
      36,
      163,
      36,
      165,
      36,
      176,
      23,
      183,
      15,
      215,
      36,
      8211,
      36,
      8212,
      45,
      8216,
      9,
      8217,
      9,
      8220,
      21,
      8221,
      21,
      8230,
      48,
      8364,
      36,
      8377,
      36
    ],
    kernings: [
      65,
      67,
      -2,
      65,
      69,
      -1,
      65,
      71,
      -1,
      65,
      72,
      -1,
      65,
      73,
      1,
      65,
      74,
      1,
      65,
      76,
      -1,
      65,
      77,
      1,
      65,
      79,
      -2,
      65,
      80,
      -1,
      65,
      81,
      -2,
      65,
      83,
      -3,
      65,
      84,
      -4,
      65,
      85,
      -2,
      65,
      86,
      -3,
      65,
      87,
      -2,
      65,
      88,
      -1,
      65,
      89,
      -5,
      65,
      90,
      -1,
      65,
      106,
      1,
      65,
      110,
      -1,
      65,
      113,
      -1,
      65,
      114,
      -1,
      65,
      115,
      -1,
      65,
      117,
      -1,
      65,
      120,
      1,
      65,
      121,
      -1,
      65,
      122,
      2,
      66,
      67,
      -2,
      66,
      70,
      -2,
      66,
      73,
      -1,
      66,
      74,
      -1,
      66,
      80,
      -1,
      66,
      82,
      -1,
      66,
      83,
      -2,
      66,
      84,
      -3,
      66,
      85,
      -2,
      66,
      86,
      -4,
      66,
      87,
      -4,
      66,
      88,
      -3,
      66,
      89,
      -5,
      66,
      90,
      -2,
      66,
      102,
      1,
      66,
      103,
      1,
      66,
      105,
      1,
      66,
      106,
      1,
      66,
      107,
      1,
      66,
      108,
      1,
      66,
      109,
      1,
      66,
      120,
      1,
      66,
      122,
      3,
      67,
      65,
      -2,
      67,
      67,
      -1,
      67,
      69,
      -1,
      67,
      71,
      -1,
      67,
      74,
      -1,
      67,
      75,
      -1,
      67,
      79,
      -1,
      67,
      80,
      -1,
      67,
      81,
      -2,
      67,
      83,
      -1,
      67,
      84,
      -2,
      67,
      85,
      -1,
      67,
      86,
      -2,
      67,
      87,
      -2,
      67,
      88,
      -2,
      67,
      89,
      -3,
      67,
      90,
      -3,
      67,
      100,
      -1,
      67,
      106,
      1,
      67,
      115,
      -1,
      67,
      116,
      1,
      67,
      117,
      -1,
      67,
      118,
      -2,
      67,
      119,
      -1,
      67,
      120,
      2,
      67,
      122,
      2,
      68,
      65,
      -1,
      68,
      70,
      -1,
      68,
      73,
      -1,
      68,
      74,
      -1,
      68,
      84,
      -3,
      68,
      86,
      -2,
      68,
      87,
      -1,
      68,
      88,
      -4,
      68,
      89,
      -4,
      68,
      90,
      -2,
      68,
      98,
      1,
      68,
      99,
      1,
      68,
      101,
      1,
      68,
      102,
      2,
      68,
      103,
      1,
      68,
      104,
      1,
      68,
      105,
      1,
      68,
      107,
      1,
      68,
      108,
      1,
      68,
      109,
      2,
      68,
      111,
      1,
      68,
      112,
      1,
      68,
      113,
      1,
      68,
      114,
      1,
      68,
      115,
      1,
      68,
      116,
      2,
      68,
      118,
      2,
      68,
      119,
      2,
      68,
      120,
      2,
      68,
      121,
      1,
      68,
      122,
      2,
      69,
      67,
      -1,
      69,
      68,
      -1,
      69,
      71,
      -1,
      69,
      74,
      -1,
      69,
      79,
      -1,
      69,
      81,
      -2,
      69,
      83,
      -3,
      69,
      84,
      -1,
      69,
      85,
      -2,
      69,
      86,
      -2,
      69,
      87,
      -2,
      69,
      88,
      -3,
      69,
      89,
      -4,
      69,
      90,
      -2,
      69,
      118,
      -1,
      69,
      119,
      -1,
      69,
      120,
      1,
      69,
      121,
      -1,
      69,
      122,
      2,
      70,
      65,
      -3,
      70,
      67,
      -1,
      70,
      68,
      2,
      70,
      70,
      2,
      70,
      73,
      1,
      70,
      74,
      2,
      70,
      76,
      1,
      70,
      77,
      -1,
      70,
      78,
      1,
      70,
      79,
      1,
      70,
      80,
      -1,
      70,
      81,
      1,
      70,
      83,
      1,
      70,
      84,
      -2,
      70,
      86,
      1,
      70,
      87,
      1,
      70,
      89,
      1,
      70,
      90,
      -1,
      70,
      97,
      -2,
      70,
      99,
      -2,
      70,
      100,
      -2,
      70,
      101,
      -1,
      70,
      102,
      1,
      70,
      103,
      -1,
      70,
      104,
      2,
      70,
      105,
      1,
      70,
      106,
      1,
      70,
      107,
      1,
      70,
      108,
      2,
      70,
      110,
      -2,
      70,
      111,
      -2,
      70,
      112,
      -1,
      70,
      113,
      -1,
      70,
      114,
      -1,
      70,
      116,
      1,
      70,
      117,
      -1,
      70,
      118,
      1,
      70,
      122,
      1,
      71,
      65,
      -1,
      71,
      73,
      -1,
      71,
      74,
      -1,
      71,
      77,
      -1,
      71,
      78,
      1,
      71,
      80,
      -2,
      71,
      83,
      -1,
      71,
      85,
      -1,
      71,
      86,
      -1,
      71,
      87,
      -2,
      71,
      88,
      -3,
      71,
      89,
      -3,
      71,
      90,
      -2,
      71,
      102,
      1,
      71,
      104,
      1,
      71,
      105,
      1,
      71,
      106,
      1,
      71,
      107,
      1,
      71,
      108,
      1,
      71,
      109,
      1,
      71,
      116,
      1,
      71,
      118,
      1,
      71,
      120,
      1,
      71,
      122,
      1,
      72,
      98,
      1,
      72,
      102,
      1,
      72,
      104,
      1,
      72,
      105,
      1,
      72,
      106,
      2,
      72,
      107,
      1,
      72,
      108,
      1,
      72,
      109,
      1,
      72,
      116,
      2,
      72,
      118,
      1,
      72,
      120,
      2,
      72,
      121,
      1,
      72,
      122,
      2,
      73,
      65,
      1,
      73,
      68,
      2,
      73,
      70,
      3,
      73,
      73,
      2,
      73,
      74,
      3,
      73,
      75,
      1,
      73,
      76,
      1,
      73,
      77,
      2,
      73,
      78,
      2,
      73,
      82,
      1,
      73,
      85,
      1,
      73,
      86,
      2,
      73,
      87,
      2,
      73,
      88,
      1,
      73,
      89,
      2,
      73,
      90,
      2,
      73,
      97,
      -1,
      73,
      98,
      1,
      73,
      99,
      -1,
      73,
      100,
      -1,
      73,
      101,
      -1,
      73,
      102,
      2,
      73,
      103,
      -1,
      73,
      104,
      2,
      73,
      105,
      2,
      73,
      106,
      2,
      73,
      107,
      2,
      73,
      108,
      2,
      73,
      110,
      -1,
      73,
      111,
      -1,
      73,
      112,
      1,
      73,
      113,
      -2,
      73,
      114,
      -1,
      73,
      115,
      -1,
      73,
      116,
      1,
      73,
      117,
      -1,
      73,
      118,
      -2,
      73,
      119,
      -2,
      73,
      120,
      1,
      73,
      121,
      -1,
      73,
      122,
      2,
      74,
      73,
      -1,
      74,
      74,
      1,
      74,
      79,
      -1,
      74,
      80,
      -1,
      74,
      81,
      -1,
      74,
      82,
      -1,
      74,
      84,
      1,
      74,
      85,
      -1,
      74,
      88,
      -2,
      74,
      89,
      -2,
      74,
      90,
      -2,
      74,
      97,
      -1,
      74,
      98,
      1,
      74,
      99,
      -1,
      74,
      100,
      -1,
      74,
      101,
      -1,
      74,
      102,
      1,
      74,
      104,
      1,
      74,
      105,
      1,
      74,
      106,
      2,
      74,
      107,
      1,
      74,
      108,
      2,
      74,
      110,
      -1,
      74,
      111,
      -1,
      74,
      112,
      1,
      74,
      113,
      -1,
      74,
      116,
      2,
      74,
      117,
      -2,
      74,
      122,
      1,
      75,
      67,
      -1,
      75,
      68,
      1,
      75,
      70,
      2,
      75,
      71,
      -1,
      75,
      74,
      2,
      75,
      77,
      2,
      75,
      79,
      -1,
      75,
      84,
      -1,
      75,
      88,
      -1,
      75,
      97,
      -3,
      75,
      99,
      -3,
      75,
      100,
      -3,
      75,
      101,
      -3,
      75,
      102,
      1,
      75,
      103,
      -3,
      75,
      104,
      1,
      75,
      105,
      1,
      75,
      106,
      3,
      75,
      107,
      1,
      75,
      108,
      1,
      75,
      110,
      -3,
      75,
      111,
      -4,
      75,
      112,
      1,
      75,
      113,
      -4,
      75,
      115,
      -3,
      75,
      116,
      1,
      75,
      117,
      -5,
      75,
      118,
      -2,
      75,
      119,
      -3,
      75,
      120,
      -1,
      75,
      121,
      -2,
      76,
      67,
      -2,
      76,
      69,
      -2,
      76,
      71,
      -2,
      76,
      73,
      -3,
      76,
      76,
      -2,
      76,
      79,
      -2,
      76,
      81,
      -2,
      76,
      83,
      -5,
      76,
      84,
      -6,
      76,
      85,
      -4,
      76,
      86,
      -6,
      76,
      87,
      -3,
      76,
      89,
      -7,
      76,
      90,
      -1,
      76,
      98,
      -1,
      76,
      102,
      1,
      76,
      103,
      -1,
      76,
      104,
      -1,
      76,
      105,
      1,
      76,
      106,
      2,
      76,
      107,
      1,
      76,
      108,
      1,
      76,
      110,
      -2,
      76,
      112,
      1,
      76,
      113,
      -3,
      76,
      115,
      -1,
      76,
      116,
      -1,
      76,
      117,
      -3,
      76,
      118,
      -5,
      76,
      119,
      -3,
      76,
      120,
      1,
      76,
      121,
      -2,
      76,
      122,
      2,
      77,
      74,
      1,
      77,
      80,
      -1,
      77,
      81,
      -1,
      77,
      83,
      -2,
      77,
      84,
      -2,
      77,
      85,
      -2,
      77,
      86,
      -2,
      77,
      87,
      -2,
      77,
      88,
      -1,
      77,
      89,
      -4,
      77,
      90,
      -1,
      77,
      98,
      1,
      77,
      102,
      1,
      77,
      104,
      1,
      77,
      105,
      1,
      77,
      107,
      1,
      77,
      108,
      1,
      77,
      112,
      1,
      77,
      113,
      -1,
      77,
      116,
      2,
      77,
      117,
      -1,
      77,
      118,
      1,
      77,
      120,
      1,
      77,
      121,
      -1,
      77,
      122,
      1,
      78,
      87,
      -1,
      78,
      88,
      -2,
      78,
      89,
      -2,
      78,
      90,
      -1,
      78,
      98,
      1,
      78,
      101,
      1,
      78,
      102,
      1,
      78,
      103,
      1,
      78,
      104,
      1,
      78,
      105,
      2,
      78,
      106,
      2,
      78,
      107,
      2,
      78,
      108,
      2,
      78,
      109,
      1,
      78,
      113,
      1,
      78,
      116,
      2,
      78,
      118,
      2,
      78,
      120,
      2,
      78,
      121,
      1,
      78,
      122,
      3,
      79,
      65,
      -1,
      79,
      68,
      -1,
      79,
      73,
      -1,
      79,
      76,
      1,
      79,
      81,
      1,
      79,
      84,
      -1,
      79,
      86,
      -1,
      79,
      87,
      -1,
      79,
      88,
      -3,
      79,
      89,
      -3,
      79,
      90,
      -2,
      79,
      102,
      2,
      79,
      103,
      2,
      79,
      104,
      1,
      79,
      105,
      2,
      79,
      106,
      2,
      79,
      107,
      1,
      79,
      108,
      2,
      79,
      109,
      2,
      79,
      111,
      1,
      79,
      112,
      1,
      79,
      113,
      1,
      79,
      115,
      1,
      79,
      116,
      2,
      79,
      118,
      2,
      79,
      119,
      1,
      79,
      120,
      2,
      79,
      121,
      2,
      79,
      122,
      2,
      80,
      65,
      -3,
      80,
      68,
      -1,
      80,
      73,
      -1,
      80,
      74,
      -1,
      80,
      77,
      -2,
      80,
      78,
      -1,
      80,
      83,
      1,
      80,
      88,
      -3,
      80,
      89,
      -2,
      80,
      90,
      -4,
      80,
      97,
      -3,
      80,
      99,
      -2,
      80,
      100,
      -3,
      80,
      101,
      -2,
      80,
      102,
      1,
      80,
      103,
      -1,
      80,
      104,
      1,
      80,
      105,
      1,
      80,
      106,
      2,
      80,
      107,
      1,
      80,
      108,
      1,
      80,
      109,
      1,
      80,
      110,
      -1,
      80,
      111,
      -2,
      80,
      113,
      -2,
      80,
      115,
      -2,
      80,
      116,
      2,
      80,
      117,
      -2,
      80,
      118,
      1,
      80,
      120,
      1,
      80,
      122,
      1,
      81,
      74,
      6,
      81,
      84,
      -1,
      81,
      86,
      -1,
      81,
      87,
      -1,
      81,
      88,
      -2,
      81,
      89,
      -2,
      81,
      90,
      -1,
      81,
      98,
      1,
      81,
      102,
      2,
      81,
      103,
      2,
      81,
      104,
      1,
      81,
      105,
      2,
      81,
      106,
      7,
      81,
      107,
      1,
      81,
      108,
      2,
      81,
      109,
      2,
      81,
      112,
      2,
      81,
      116,
      2,
      81,
      118,
      2,
      81,
      120,
      2,
      81,
      121,
      4,
      81,
      122,
      3,
      82,
      65,
      -2,
      82,
      66,
      -1,
      82,
      67,
      -2,
      82,
      68,
      1,
      82,
      69,
      -2,
      82,
      70,
      1,
      82,
      71,
      -1,
      82,
      73,
      -1,
      82,
      74,
      2,
      82,
      76,
      -1,
      82,
      77,
      -2,
      82,
      78,
      1,
      82,
      79,
      -1,
      82,
      81,
      -1,
      82,
      84,
      -1,
      82,
      85,
      -2,
      82,
      86,
      -1,
      82,
      87,
      -1,
      82,
      88,
      -2,
      82,
      89,
      -2,
      82,
      90,
      -4,
      82,
      97,
      -1,
      82,
      99,
      -1,
      82,
      100,
      -1,
      82,
      101,
      -1,
      82,
      102,
      2,
      82,
      103,
      -1,
      82,
      106,
      2,
      82,
      110,
      -1,
      82,
      111,
      -1,
      82,
      112,
      2,
      82,
      113,
      -2,
      82,
      114,
      -1,
      82,
      115,
      -1,
      82,
      116,
      1,
      82,
      117,
      -2,
      82,
      119,
      -1,
      82,
      120,
      1,
      82,
      121,
      1,
      82,
      122,
      2,
      83,
      68,
      2,
      83,
      69,
      -1,
      83,
      70,
      2,
      83,
      73,
      1,
      83,
      74,
      2,
      83,
      76,
      2,
      83,
      78,
      1,
      83,
      79,
      1,
      83,
      86,
      2,
      83,
      87,
      1,
      83,
      89,
      1,
      83,
      90,
      -1,
      83,
      97,
      -1,
      83,
      98,
      1,
      83,
      99,
      -2,
      83,
      100,
      -2,
      83,
      101,
      -2,
      83,
      102,
      2,
      83,
      103,
      -2,
      83,
      104,
      2,
      83,
      105,
      2,
      83,
      106,
      2,
      83,
      107,
      1,
      83,
      108,
      2,
      83,
      110,
      -2,
      83,
      111,
      -1,
      83,
      113,
      -2,
      83,
      114,
      -1,
      83,
      115,
      -1,
      83,
      116,
      2,
      83,
      117,
      -2,
      83,
      118,
      -4,
      83,
      119,
      -2,
      83,
      120,
      1,
      83,
      121,
      -1,
      83,
      122,
      2,
      84,
      65,
      -4,
      84,
      67,
      -1,
      84,
      68,
      1,
      84,
      69,
      -1,
      84,
      70,
      2,
      84,
      71,
      -1,
      84,
      73,
      1,
      84,
      77,
      -2,
      84,
      84,
      -2,
      84,
      86,
      1,
      84,
      88,
      -1,
      84,
      90,
      -1,
      84,
      97,
      -7,
      84,
      99,
      -6,
      84,
      100,
      -9,
      84,
      101,
      -7,
      84,
      102,
      2,
      84,
      103,
      -6,
      84,
      104,
      2,
      84,
      106,
      2,
      84,
      107,
      1,
      84,
      108,
      2,
      84,
      109,
      -4,
      84,
      110,
      -7,
      84,
      111,
      -7,
      84,
      112,
      -6,
      84,
      113,
      -10,
      84,
      114,
      -6,
      84,
      115,
      -6,
      84,
      116,
      1,
      84,
      117,
      -7,
      84,
      118,
      -6,
      84,
      119,
      -8,
      84,
      120,
      -5,
      84,
      121,
      -4,
      84,
      122,
      -3,
      85,
      69,
      1,
      85,
      70,
      1,
      85,
      81,
      2,
      85,
      82,
      1,
      85,
      84,
      2,
      85,
      85,
      1,
      85,
      86,
      1,
      85,
      88,
      -1,
      85,
      89,
      -1,
      85,
      90,
      -1,
      85,
      98,
      2,
      85,
      102,
      2,
      85,
      103,
      1,
      85,
      104,
      2,
      85,
      105,
      2,
      85,
      106,
      3,
      85,
      107,
      2,
      85,
      108,
      2,
      85,
      109,
      2,
      85,
      112,
      1,
      85,
      114,
      1,
      85,
      115,
      1,
      85,
      116,
      4,
      85,
      117,
      1,
      85,
      118,
      4,
      85,
      119,
      1,
      85,
      120,
      2,
      85,
      121,
      1,
      85,
      122,
      2,
      86,
      65,
      -4,
      86,
      67,
      -2,
      86,
      69,
      -2,
      86,
      70,
      1,
      86,
      71,
      -1,
      86,
      77,
      -2,
      86,
      78,
      -1,
      86,
      79,
      -1,
      86,
      80,
      -2,
      86,
      81,
      -1,
      86,
      84,
      2,
      86,
      85,
      -1,
      86,
      88,
      -2,
      86,
      89,
      -1,
      86,
      90,
      -2,
      86,
      97,
      -4,
      86,
      99,
      -2,
      86,
      100,
      -2,
      86,
      101,
      -2,
      86,
      103,
      -2,
      86,
      109,
      -1,
      86,
      110,
      -2,
      86,
      111,
      -2,
      86,
      112,
      -2,
      86,
      113,
      -2,
      86,
      114,
      -2,
      86,
      115,
      -2,
      86,
      117,
      -2,
      86,
      119,
      -2,
      87,
      65,
      -2,
      87,
      68,
      2,
      87,
      70,
      2,
      87,
      73,
      1,
      87,
      74,
      2,
      87,
      76,
      1,
      87,
      77,
      -1,
      87,
      83,
      1,
      87,
      84,
      2,
      87,
      86,
      1,
      87,
      88,
      -1,
      87,
      89,
      1,
      87,
      90,
      -1,
      87,
      98,
      2,
      87,
      100,
      -1,
      87,
      101,
      1,
      87,
      102,
      2,
      87,
      104,
      2,
      87,
      105,
      2,
      87,
      106,
      3,
      87,
      107,
      2,
      87,
      108,
      3,
      87,
      109,
      1,
      87,
      116,
      3,
      87,
      118,
      2,
      87,
      120,
      2,
      87,
      121,
      2,
      87,
      122,
      2,
      88,
      65,
      -2,
      88,
      67,
      -2,
      88,
      69,
      -1,
      88,
      71,
      -2,
      88,
      73,
      -1,
      88,
      77,
      -2,
      88,
      78,
      -1,
      88,
      79,
      -2,
      88,
      80,
      -1,
      88,
      81,
      -2,
      88,
      83,
      -2,
      88,
      85,
      -2,
      88,
      88,
      -2,
      88,
      89,
      -2,
      88,
      101,
      -1,
      88,
      102,
      1,
      88,
      103,
      -1,
      88,
      105,
      1,
      88,
      106,
      2,
      88,
      107,
      1,
      88,
      108,
      2,
      88,
      109,
      1,
      88,
      111,
      -1,
      88,
      112,
      1,
      88,
      113,
      -3,
      88,
      117,
      -2,
      88,
      118,
      -2,
      88,
      119,
      -2,
      88,
      120,
      1,
      88,
      121,
      -2,
      88,
      122,
      2,
      89,
      65,
      -4,
      89,
      67,
      -2,
      89,
      68,
      1,
      89,
      69,
      -2,
      89,
      70,
      2,
      89,
      71,
      -2,
      89,
      72,
      -1,
      89,
      73,
      1,
      89,
      74,
      1,
      89,
      77,
      -3,
      89,
      79,
      -2,
      89,
      80,
      -1,
      89,
      81,
      -1,
      89,
      82,
      -1,
      89,
      83,
      -1,
      89,
      84,
      -1,
      89,
      88,
      -2,
      89,
      89,
      -1,
      89,
      90,
      -3,
      89,
      97,
      -6,
      89,
      99,
      -5,
      89,
      100,
      -5,
      89,
      101,
      -5,
      89,
      103,
      -5,
      89,
      109,
      -2,
      89,
      110,
      -5,
      89,
      111,
      -5,
      89,
      112,
      -4,
      89,
      113,
      -5,
      89,
      114,
      -5,
      89,
      115,
      -5,
      89,
      117,
      -5,
      89,
      118,
      -2,
      89,
      119,
      -4,
      89,
      120,
      -4,
      89,
      121,
      -3,
      89,
      122,
      -2,
      90,
      65,
      -2,
      90,
      66,
      -1,
      90,
      67,
      -2,
      90,
      68,
      -1,
      90,
      69,
      -2,
      90,
      71,
      -2,
      90,
      76,
      -1,
      90,
      79,
      -2,
      90,
      80,
      -1,
      90,
      81,
      -1,
      90,
      82,
      -1,
      90,
      83,
      -2,
      90,
      85,
      -1,
      90,
      87,
      -1,
      90,
      88,
      -1,
      90,
      89,
      -2,
      90,
      90,
      -1,
      90,
      97,
      -2,
      90,
      98,
      -1,
      90,
      99,
      -1,
      90,
      100,
      -2,
      90,
      101,
      -3,
      90,
      103,
      -3,
      90,
      106,
      1,
      90,
      107,
      1,
      90,
      109,
      -1,
      90,
      110,
      -4,
      90,
      111,
      -2,
      90,
      112,
      -1,
      90,
      113,
      -4,
      90,
      114,
      -3,
      90,
      115,
      -2,
      90,
      116,
      -1,
      90,
      117,
      -2,
      90,
      118,
      -2,
      90,
      119,
      -3,
      90,
      120,
      -1,
      90,
      121,
      -2,
      90,
      122,
      1,
      97,
      118,
      -2,
      97,
      119,
      -1,
      97,
      121,
      -2,
      98,
      97,
      -1,
      98,
      99,
      -1,
      98,
      100,
      -1,
      98,
      117,
      -1,
      98,
      120,
      -1,
      98,
      121,
      -1,
      99,
      108,
      1,
      99,
      119,
      -1,
      100,
      110,
      -1,
      100,
      116,
      1,
      100,
      117,
      -1,
      101,
      108,
      1,
      102,
      97,
      -1,
      102,
      102,
      1,
      102,
      104,
      1,
      102,
      105,
      1,
      102,
      106,
      1,
      102,
      108,
      2,
      102,
      109,
      1,
      102,
      116,
      3,
      102,
      118,
      1,
      102,
      121,
      1,
      103,
      105,
      1,
      103,
      121,
      1,
      104,
      102,
      -1,
      104,
      103,
      -2,
      104,
      113,
      -1,
      104,
      115,
      -1,
      104,
      118,
      -2,
      104,
      119,
      -1,
      104,
      121,
      -2,
      105,
      102,
      1,
      105,
      118,
      1,
      106,
      116,
      1,
      106,
      117,
      -1,
      106,
      120,
      1,
      106,
      121,
      1,
      106,
      122,
      1,
      107,
      99,
      2,
      107,
      101,
      1,
      107,
      102,
      2,
      107,
      104,
      1,
      107,
      105,
      1,
      107,
      107,
      2,
      107,
      108,
      2,
      107,
      109,
      1,
      107,
      111,
      1,
      107,
      114,
      1,
      107,
      116,
      1,
      107,
      117,
      1,
      107,
      118,
      1,
      107,
      121,
      -1,
      107,
      122,
      1,
      108,
      108,
      1,
      108,
      116,
      1,
      108,
      122,
      2,
      109,
      100,
      1,
      109,
      111,
      2,
      109,
      118,
      -1,
      109,
      119,
      -1,
      109,
      121,
      -1,
      110,
      98,
      -1,
      110,
      116,
      -1,
      110,
      117,
      -1,
      110,
      118,
      -2,
      110,
      119,
      -2,
      110,
      121,
      -2,
      111,
      117,
      -1,
      111,
      119,
      -1,
      111,
      121,
      -1,
      112,
      110,
      -1,
      112,
      117,
      -1,
      112,
      121,
      -1,
      113,
      104,
      -1,
      113,
      106,
      1,
      113,
      110,
      -1,
      113,
      111,
      -1,
      113,
      117,
      -1,
      114,
      118,
      2,
      115,
      102,
      1,
      115,
      116,
      1,
      115,
      118,
      2,
      115,
      120,
      1,
      115,
      122,
      2,
      116,
      118,
      1,
      116,
      120,
      2,
      116,
      122,
      2,
      117,
      98,
      -1,
      117,
      102,
      1,
      117,
      105,
      1,
      117,
      107,
      1,
      117,
      108,
      1,
      117,
      120,
      1,
      117,
      122,
      2,
      118,
      97,
      -1,
      118,
      102,
      1,
      118,
      105,
      1,
      118,
      116,
      1,
      118,
      118,
      2,
      118,
      120,
      2,
      118,
      121,
      1,
      118,
      122,
      1,
      119,
      105,
      1,
      119,
      120,
      1,
      120,
      102,
      1,
      120,
      105,
      1,
      120,
      107,
      1,
      120,
      108,
      1,
      120,
      110,
      -1,
      120,
      112,
      1,
      120,
      113,
      -1,
      120,
      118,
      1,
      120,
      120,
      1,
      120,
      121,
      -1,
      120,
      122,
      1,
      121,
      97,
      -1,
      121,
      100,
      -1,
      121,
      101,
      1,
      121,
      110,
      -1,
      121,
      116,
      1,
      121,
      117,
      -1,
      121,
      118,
      1,
      121,
      120,
      1,
      122,
      102,
      1,
      122,
      105,
      1,
      122,
      116,
      1,
      122,
      118,
      1,
      122,
      120,
      1,
      122,
      122,
      2
    ]
  },
  "Caveat|regular|normal": {
    emSize: 80,
    commonLineHeight: 101,
    capTop: 21,
    advances: [
      19,
      17,
      19,
      45,
      36,
      48,
      45,
      9,
      26,
      26,
      29,
      36,
      16,
      26,
      16,
      26,
      36,
      36,
      36,
      36,
      36,
      36,
      36,
      36,
      36,
      36,
      16,
      16,
      36,
      36,
      36,
      30,
      51,
      40,
      42,
      38,
      46,
      42,
      36,
      39,
      45,
      32,
      24,
      40,
      34,
      58,
      48,
      40,
      37,
      40,
      43,
      39,
      37,
      39,
      39,
      58,
      42,
      40,
      42,
      26,
      26,
      26,
      36,
      36,
      28,
      35,
      35,
      28,
      31,
      26,
      23,
      28,
      37,
      15,
      16,
      29,
      14,
      45,
      36,
      28,
      30,
      30,
      29,
      27,
      26,
      30,
      26,
      41,
      27,
      27,
      25,
      26,
      26,
      26,
      36
    ],
    extraAdvances: [
      162,
      36,
      163,
      36,
      165,
      36,
      176,
      23,
      183,
      15,
      215,
      36,
      8211,
      36,
      8212,
      45,
      8216,
      9,
      8217,
      9,
      8220,
      21,
      8221,
      21,
      8230,
      48,
      8364,
      36,
      8377,
      36
    ],
    kernings: [
      65,
      67,
      -2,
      65,
      69,
      -1,
      65,
      71,
      -1,
      65,
      72,
      -1,
      65,
      73,
      1,
      65,
      74,
      1,
      65,
      76,
      -1,
      65,
      77,
      1,
      65,
      79,
      -2,
      65,
      80,
      -1,
      65,
      81,
      -2,
      65,
      83,
      -3,
      65,
      84,
      -4,
      65,
      85,
      -2,
      65,
      86,
      -3,
      65,
      87,
      -2,
      65,
      88,
      -1,
      65,
      89,
      -5,
      65,
      90,
      -1,
      65,
      106,
      1,
      65,
      110,
      -1,
      65,
      113,
      -1,
      65,
      114,
      -1,
      65,
      115,
      -1,
      65,
      117,
      -1,
      65,
      120,
      1,
      65,
      121,
      -1,
      65,
      122,
      2,
      66,
      67,
      -2,
      66,
      70,
      -2,
      66,
      73,
      -1,
      66,
      74,
      -1,
      66,
      80,
      -1,
      66,
      82,
      -1,
      66,
      83,
      -2,
      66,
      84,
      -3,
      66,
      85,
      -2,
      66,
      86,
      -4,
      66,
      87,
      -4,
      66,
      88,
      -3,
      66,
      89,
      -5,
      66,
      90,
      -2,
      66,
      102,
      1,
      66,
      103,
      1,
      66,
      105,
      1,
      66,
      106,
      1,
      66,
      107,
      1,
      66,
      108,
      1,
      66,
      109,
      1,
      66,
      120,
      1,
      66,
      122,
      3,
      67,
      65,
      -2,
      67,
      67,
      -1,
      67,
      69,
      -1,
      67,
      71,
      -1,
      67,
      74,
      -1,
      67,
      75,
      -1,
      67,
      79,
      -1,
      67,
      80,
      -1,
      67,
      81,
      -2,
      67,
      83,
      -1,
      67,
      84,
      -2,
      67,
      85,
      -1,
      67,
      86,
      -2,
      67,
      87,
      -2,
      67,
      88,
      -2,
      67,
      89,
      -3,
      67,
      90,
      -3,
      67,
      100,
      -1,
      67,
      106,
      1,
      67,
      115,
      -1,
      67,
      116,
      1,
      67,
      117,
      -1,
      67,
      118,
      -2,
      67,
      119,
      -1,
      67,
      120,
      2,
      67,
      122,
      2,
      68,
      65,
      -1,
      68,
      70,
      -1,
      68,
      73,
      -1,
      68,
      74,
      -1,
      68,
      84,
      -3,
      68,
      86,
      -2,
      68,
      87,
      -1,
      68,
      88,
      -4,
      68,
      89,
      -4,
      68,
      90,
      -2,
      68,
      98,
      1,
      68,
      99,
      1,
      68,
      101,
      1,
      68,
      102,
      2,
      68,
      103,
      1,
      68,
      104,
      1,
      68,
      105,
      1,
      68,
      107,
      1,
      68,
      108,
      1,
      68,
      109,
      2,
      68,
      111,
      1,
      68,
      112,
      1,
      68,
      113,
      1,
      68,
      114,
      1,
      68,
      115,
      1,
      68,
      116,
      2,
      68,
      118,
      2,
      68,
      119,
      2,
      68,
      120,
      2,
      68,
      121,
      1,
      68,
      122,
      2,
      69,
      67,
      -1,
      69,
      68,
      -1,
      69,
      71,
      -1,
      69,
      74,
      -1,
      69,
      79,
      -1,
      69,
      81,
      -2,
      69,
      83,
      -3,
      69,
      84,
      -1,
      69,
      85,
      -2,
      69,
      86,
      -2,
      69,
      87,
      -2,
      69,
      88,
      -3,
      69,
      89,
      -4,
      69,
      90,
      -2,
      69,
      118,
      -1,
      69,
      119,
      -1,
      69,
      120,
      1,
      69,
      121,
      -1,
      69,
      122,
      2,
      70,
      65,
      -3,
      70,
      67,
      -1,
      70,
      68,
      2,
      70,
      70,
      2,
      70,
      73,
      1,
      70,
      74,
      2,
      70,
      76,
      1,
      70,
      77,
      -1,
      70,
      78,
      1,
      70,
      79,
      1,
      70,
      80,
      -1,
      70,
      81,
      1,
      70,
      83,
      1,
      70,
      84,
      -2,
      70,
      86,
      1,
      70,
      87,
      1,
      70,
      89,
      1,
      70,
      90,
      -1,
      70,
      97,
      -2,
      70,
      99,
      -2,
      70,
      100,
      -2,
      70,
      101,
      -1,
      70,
      102,
      1,
      70,
      103,
      -1,
      70,
      104,
      2,
      70,
      105,
      1,
      70,
      106,
      1,
      70,
      107,
      1,
      70,
      108,
      2,
      70,
      110,
      -2,
      70,
      111,
      -2,
      70,
      112,
      -1,
      70,
      113,
      -1,
      70,
      114,
      -1,
      70,
      116,
      1,
      70,
      117,
      -1,
      70,
      118,
      1,
      70,
      122,
      1,
      71,
      65,
      -1,
      71,
      73,
      -1,
      71,
      74,
      -1,
      71,
      77,
      -1,
      71,
      78,
      1,
      71,
      80,
      -2,
      71,
      83,
      -1,
      71,
      85,
      -1,
      71,
      86,
      -1,
      71,
      87,
      -2,
      71,
      88,
      -3,
      71,
      89,
      -3,
      71,
      90,
      -2,
      71,
      102,
      1,
      71,
      104,
      1,
      71,
      105,
      1,
      71,
      106,
      1,
      71,
      107,
      1,
      71,
      108,
      1,
      71,
      109,
      1,
      71,
      116,
      1,
      71,
      118,
      1,
      71,
      120,
      1,
      71,
      122,
      1,
      72,
      98,
      1,
      72,
      102,
      1,
      72,
      104,
      1,
      72,
      105,
      1,
      72,
      106,
      2,
      72,
      107,
      1,
      72,
      108,
      1,
      72,
      109,
      1,
      72,
      116,
      2,
      72,
      118,
      1,
      72,
      120,
      2,
      72,
      121,
      1,
      72,
      122,
      2,
      73,
      65,
      1,
      73,
      68,
      2,
      73,
      70,
      3,
      73,
      73,
      2,
      73,
      74,
      3,
      73,
      75,
      1,
      73,
      76,
      1,
      73,
      77,
      2,
      73,
      78,
      2,
      73,
      82,
      1,
      73,
      85,
      1,
      73,
      86,
      2,
      73,
      87,
      2,
      73,
      88,
      1,
      73,
      89,
      2,
      73,
      90,
      2,
      73,
      97,
      -1,
      73,
      98,
      1,
      73,
      99,
      -1,
      73,
      100,
      -1,
      73,
      101,
      -1,
      73,
      102,
      2,
      73,
      103,
      -1,
      73,
      104,
      2,
      73,
      105,
      2,
      73,
      106,
      2,
      73,
      107,
      2,
      73,
      108,
      2,
      73,
      110,
      -1,
      73,
      111,
      -1,
      73,
      112,
      1,
      73,
      113,
      -2,
      73,
      114,
      -1,
      73,
      115,
      -1,
      73,
      116,
      1,
      73,
      117,
      -1,
      73,
      118,
      -2,
      73,
      119,
      -2,
      73,
      120,
      1,
      73,
      121,
      -1,
      73,
      122,
      2,
      74,
      73,
      -1,
      74,
      74,
      1,
      74,
      79,
      -1,
      74,
      80,
      -1,
      74,
      81,
      -1,
      74,
      82,
      -1,
      74,
      84,
      1,
      74,
      85,
      -1,
      74,
      88,
      -2,
      74,
      89,
      -2,
      74,
      90,
      -2,
      74,
      97,
      -1,
      74,
      98,
      1,
      74,
      99,
      -1,
      74,
      100,
      -1,
      74,
      101,
      -1,
      74,
      102,
      1,
      74,
      104,
      1,
      74,
      105,
      1,
      74,
      106,
      2,
      74,
      107,
      1,
      74,
      108,
      2,
      74,
      110,
      -1,
      74,
      111,
      -1,
      74,
      112,
      1,
      74,
      113,
      -1,
      74,
      116,
      2,
      74,
      117,
      -2,
      74,
      122,
      1,
      75,
      67,
      -1,
      75,
      68,
      1,
      75,
      70,
      2,
      75,
      71,
      -1,
      75,
      74,
      2,
      75,
      77,
      2,
      75,
      79,
      -1,
      75,
      84,
      -1,
      75,
      88,
      -1,
      75,
      97,
      -3,
      75,
      99,
      -3,
      75,
      100,
      -3,
      75,
      101,
      -3,
      75,
      102,
      1,
      75,
      103,
      -3,
      75,
      104,
      1,
      75,
      105,
      1,
      75,
      106,
      3,
      75,
      107,
      1,
      75,
      108,
      1,
      75,
      110,
      -3,
      75,
      111,
      -4,
      75,
      112,
      1,
      75,
      113,
      -4,
      75,
      115,
      -3,
      75,
      116,
      1,
      75,
      117,
      -5,
      75,
      118,
      -2,
      75,
      119,
      -3,
      75,
      120,
      -1,
      75,
      121,
      -2,
      76,
      67,
      -2,
      76,
      69,
      -2,
      76,
      71,
      -2,
      76,
      73,
      -3,
      76,
      76,
      -2,
      76,
      79,
      -2,
      76,
      81,
      -2,
      76,
      83,
      -5,
      76,
      84,
      -6,
      76,
      85,
      -4,
      76,
      86,
      -6,
      76,
      87,
      -3,
      76,
      89,
      -7,
      76,
      90,
      -1,
      76,
      98,
      -1,
      76,
      102,
      1,
      76,
      103,
      -1,
      76,
      104,
      -1,
      76,
      105,
      1,
      76,
      106,
      2,
      76,
      107,
      1,
      76,
      108,
      1,
      76,
      110,
      -2,
      76,
      112,
      1,
      76,
      113,
      -3,
      76,
      115,
      -1,
      76,
      116,
      -1,
      76,
      117,
      -3,
      76,
      118,
      -5,
      76,
      119,
      -3,
      76,
      120,
      1,
      76,
      121,
      -2,
      76,
      122,
      2,
      77,
      74,
      1,
      77,
      80,
      -1,
      77,
      81,
      -1,
      77,
      83,
      -2,
      77,
      84,
      -2,
      77,
      85,
      -2,
      77,
      86,
      -2,
      77,
      87,
      -2,
      77,
      88,
      -1,
      77,
      89,
      -4,
      77,
      90,
      -1,
      77,
      98,
      1,
      77,
      102,
      1,
      77,
      104,
      1,
      77,
      105,
      1,
      77,
      107,
      1,
      77,
      108,
      1,
      77,
      112,
      1,
      77,
      113,
      -1,
      77,
      116,
      2,
      77,
      117,
      -1,
      77,
      118,
      1,
      77,
      120,
      1,
      77,
      121,
      -1,
      77,
      122,
      1,
      78,
      87,
      -1,
      78,
      88,
      -2,
      78,
      89,
      -2,
      78,
      90,
      -1,
      78,
      98,
      1,
      78,
      101,
      1,
      78,
      102,
      1,
      78,
      103,
      1,
      78,
      104,
      1,
      78,
      105,
      2,
      78,
      106,
      2,
      78,
      107,
      2,
      78,
      108,
      2,
      78,
      109,
      1,
      78,
      113,
      1,
      78,
      116,
      2,
      78,
      118,
      2,
      78,
      120,
      2,
      78,
      121,
      1,
      78,
      122,
      3,
      79,
      65,
      -1,
      79,
      68,
      -1,
      79,
      73,
      -1,
      79,
      76,
      1,
      79,
      81,
      1,
      79,
      84,
      -1,
      79,
      86,
      -1,
      79,
      87,
      -1,
      79,
      88,
      -3,
      79,
      89,
      -3,
      79,
      90,
      -2,
      79,
      102,
      2,
      79,
      103,
      2,
      79,
      104,
      1,
      79,
      105,
      2,
      79,
      106,
      2,
      79,
      107,
      1,
      79,
      108,
      2,
      79,
      109,
      2,
      79,
      111,
      1,
      79,
      112,
      1,
      79,
      113,
      1,
      79,
      115,
      1,
      79,
      116,
      2,
      79,
      118,
      2,
      79,
      119,
      1,
      79,
      120,
      2,
      79,
      121,
      2,
      79,
      122,
      2,
      80,
      65,
      -3,
      80,
      68,
      -1,
      80,
      73,
      -1,
      80,
      74,
      -1,
      80,
      77,
      -2,
      80,
      78,
      -1,
      80,
      83,
      1,
      80,
      88,
      -3,
      80,
      89,
      -2,
      80,
      90,
      -4,
      80,
      97,
      -3,
      80,
      99,
      -2,
      80,
      100,
      -3,
      80,
      101,
      -2,
      80,
      102,
      1,
      80,
      103,
      -1,
      80,
      104,
      1,
      80,
      105,
      1,
      80,
      106,
      2,
      80,
      107,
      1,
      80,
      108,
      1,
      80,
      109,
      1,
      80,
      110,
      -1,
      80,
      111,
      -2,
      80,
      113,
      -2,
      80,
      115,
      -2,
      80,
      116,
      2,
      80,
      117,
      -2,
      80,
      118,
      1,
      80,
      120,
      1,
      80,
      122,
      1,
      81,
      74,
      6,
      81,
      84,
      -1,
      81,
      86,
      -1,
      81,
      87,
      -1,
      81,
      88,
      -2,
      81,
      89,
      -2,
      81,
      90,
      -1,
      81,
      98,
      1,
      81,
      102,
      2,
      81,
      103,
      2,
      81,
      104,
      1,
      81,
      105,
      2,
      81,
      106,
      7,
      81,
      107,
      1,
      81,
      108,
      2,
      81,
      109,
      2,
      81,
      112,
      2,
      81,
      116,
      2,
      81,
      118,
      2,
      81,
      120,
      2,
      81,
      121,
      4,
      81,
      122,
      3,
      82,
      65,
      -2,
      82,
      66,
      -1,
      82,
      67,
      -2,
      82,
      68,
      1,
      82,
      69,
      -2,
      82,
      70,
      1,
      82,
      71,
      -1,
      82,
      73,
      -1,
      82,
      74,
      2,
      82,
      76,
      -1,
      82,
      77,
      -2,
      82,
      78,
      1,
      82,
      79,
      -1,
      82,
      81,
      -1,
      82,
      84,
      -1,
      82,
      85,
      -2,
      82,
      86,
      -1,
      82,
      87,
      -1,
      82,
      88,
      -2,
      82,
      89,
      -2,
      82,
      90,
      -4,
      82,
      97,
      -1,
      82,
      99,
      -1,
      82,
      100,
      -1,
      82,
      101,
      -1,
      82,
      102,
      2,
      82,
      103,
      -1,
      82,
      106,
      2,
      82,
      110,
      -1,
      82,
      111,
      -1,
      82,
      112,
      2,
      82,
      113,
      -2,
      82,
      114,
      -1,
      82,
      115,
      -1,
      82,
      116,
      1,
      82,
      117,
      -2,
      82,
      119,
      -1,
      82,
      120,
      1,
      82,
      121,
      1,
      82,
      122,
      2,
      83,
      68,
      2,
      83,
      69,
      -1,
      83,
      70,
      2,
      83,
      73,
      1,
      83,
      74,
      2,
      83,
      76,
      2,
      83,
      78,
      1,
      83,
      79,
      1,
      83,
      86,
      2,
      83,
      87,
      1,
      83,
      89,
      1,
      83,
      90,
      -1,
      83,
      97,
      -1,
      83,
      98,
      1,
      83,
      99,
      -2,
      83,
      100,
      -2,
      83,
      101,
      -2,
      83,
      102,
      2,
      83,
      103,
      -2,
      83,
      104,
      2,
      83,
      105,
      2,
      83,
      106,
      2,
      83,
      107,
      1,
      83,
      108,
      2,
      83,
      110,
      -2,
      83,
      111,
      -1,
      83,
      113,
      -2,
      83,
      114,
      -1,
      83,
      115,
      -1,
      83,
      116,
      2,
      83,
      117,
      -2,
      83,
      118,
      -4,
      83,
      119,
      -2,
      83,
      120,
      1,
      83,
      121,
      -1,
      83,
      122,
      2,
      84,
      65,
      -4,
      84,
      67,
      -1,
      84,
      68,
      1,
      84,
      69,
      -1,
      84,
      70,
      2,
      84,
      71,
      -1,
      84,
      73,
      1,
      84,
      77,
      -2,
      84,
      84,
      -2,
      84,
      86,
      1,
      84,
      88,
      -1,
      84,
      90,
      -1,
      84,
      97,
      -7,
      84,
      99,
      -6,
      84,
      100,
      -9,
      84,
      101,
      -7,
      84,
      102,
      2,
      84,
      103,
      -6,
      84,
      104,
      2,
      84,
      106,
      2,
      84,
      107,
      1,
      84,
      108,
      2,
      84,
      109,
      -4,
      84,
      110,
      -7,
      84,
      111,
      -7,
      84,
      112,
      -6,
      84,
      113,
      -10,
      84,
      114,
      -6,
      84,
      115,
      -6,
      84,
      116,
      1,
      84,
      117,
      -7,
      84,
      118,
      -6,
      84,
      119,
      -8,
      84,
      120,
      -5,
      84,
      121,
      -4,
      84,
      122,
      -3,
      85,
      69,
      1,
      85,
      70,
      1,
      85,
      81,
      2,
      85,
      82,
      1,
      85,
      84,
      2,
      85,
      85,
      1,
      85,
      86,
      1,
      85,
      88,
      -1,
      85,
      89,
      -1,
      85,
      90,
      -1,
      85,
      98,
      2,
      85,
      102,
      2,
      85,
      103,
      1,
      85,
      104,
      2,
      85,
      105,
      2,
      85,
      106,
      3,
      85,
      107,
      2,
      85,
      108,
      2,
      85,
      109,
      2,
      85,
      112,
      1,
      85,
      114,
      1,
      85,
      115,
      1,
      85,
      116,
      4,
      85,
      117,
      1,
      85,
      118,
      4,
      85,
      119,
      1,
      85,
      120,
      2,
      85,
      121,
      1,
      85,
      122,
      2,
      86,
      65,
      -4,
      86,
      67,
      -2,
      86,
      69,
      -2,
      86,
      70,
      1,
      86,
      71,
      -1,
      86,
      77,
      -2,
      86,
      78,
      -1,
      86,
      79,
      -1,
      86,
      80,
      -2,
      86,
      81,
      -1,
      86,
      84,
      2,
      86,
      85,
      -1,
      86,
      88,
      -2,
      86,
      89,
      -1,
      86,
      90,
      -2,
      86,
      97,
      -4,
      86,
      99,
      -2,
      86,
      100,
      -2,
      86,
      101,
      -2,
      86,
      103,
      -2,
      86,
      109,
      -1,
      86,
      110,
      -2,
      86,
      111,
      -2,
      86,
      112,
      -2,
      86,
      113,
      -2,
      86,
      114,
      -2,
      86,
      115,
      -2,
      86,
      117,
      -2,
      86,
      119,
      -2,
      87,
      65,
      -2,
      87,
      68,
      2,
      87,
      70,
      2,
      87,
      73,
      1,
      87,
      74,
      2,
      87,
      76,
      1,
      87,
      77,
      -1,
      87,
      83,
      1,
      87,
      84,
      2,
      87,
      86,
      1,
      87,
      88,
      -1,
      87,
      89,
      1,
      87,
      90,
      -1,
      87,
      98,
      2,
      87,
      100,
      -1,
      87,
      101,
      1,
      87,
      102,
      2,
      87,
      104,
      2,
      87,
      105,
      2,
      87,
      106,
      3,
      87,
      107,
      2,
      87,
      108,
      3,
      87,
      109,
      1,
      87,
      116,
      3,
      87,
      118,
      2,
      87,
      120,
      2,
      87,
      121,
      2,
      87,
      122,
      2,
      88,
      65,
      -2,
      88,
      67,
      -2,
      88,
      69,
      -1,
      88,
      71,
      -2,
      88,
      73,
      -1,
      88,
      77,
      -2,
      88,
      78,
      -1,
      88,
      79,
      -2,
      88,
      80,
      -1,
      88,
      81,
      -2,
      88,
      83,
      -2,
      88,
      85,
      -2,
      88,
      88,
      -2,
      88,
      89,
      -2,
      88,
      101,
      -1,
      88,
      102,
      1,
      88,
      103,
      -1,
      88,
      105,
      1,
      88,
      106,
      2,
      88,
      107,
      1,
      88,
      108,
      2,
      88,
      109,
      1,
      88,
      111,
      -1,
      88,
      112,
      1,
      88,
      113,
      -3,
      88,
      117,
      -2,
      88,
      118,
      -2,
      88,
      119,
      -2,
      88,
      120,
      1,
      88,
      121,
      -2,
      88,
      122,
      2,
      89,
      65,
      -4,
      89,
      67,
      -2,
      89,
      68,
      1,
      89,
      69,
      -2,
      89,
      70,
      2,
      89,
      71,
      -2,
      89,
      72,
      -1,
      89,
      73,
      1,
      89,
      74,
      1,
      89,
      77,
      -3,
      89,
      79,
      -2,
      89,
      80,
      -1,
      89,
      81,
      -1,
      89,
      82,
      -1,
      89,
      83,
      -1,
      89,
      84,
      -1,
      89,
      88,
      -2,
      89,
      89,
      -1,
      89,
      90,
      -3,
      89,
      97,
      -6,
      89,
      99,
      -5,
      89,
      100,
      -5,
      89,
      101,
      -5,
      89,
      103,
      -5,
      89,
      109,
      -2,
      89,
      110,
      -5,
      89,
      111,
      -5,
      89,
      112,
      -4,
      89,
      113,
      -5,
      89,
      114,
      -5,
      89,
      115,
      -5,
      89,
      117,
      -5,
      89,
      118,
      -2,
      89,
      119,
      -4,
      89,
      120,
      -4,
      89,
      121,
      -3,
      89,
      122,
      -2,
      90,
      65,
      -2,
      90,
      66,
      -1,
      90,
      67,
      -2,
      90,
      68,
      -1,
      90,
      69,
      -2,
      90,
      71,
      -2,
      90,
      76,
      -1,
      90,
      79,
      -2,
      90,
      80,
      -1,
      90,
      81,
      -1,
      90,
      82,
      -1,
      90,
      83,
      -2,
      90,
      85,
      -1,
      90,
      87,
      -1,
      90,
      88,
      -1,
      90,
      89,
      -2,
      90,
      90,
      -1,
      90,
      97,
      -2,
      90,
      98,
      -1,
      90,
      99,
      -1,
      90,
      100,
      -2,
      90,
      101,
      -3,
      90,
      103,
      -3,
      90,
      106,
      1,
      90,
      107,
      1,
      90,
      109,
      -1,
      90,
      110,
      -4,
      90,
      111,
      -2,
      90,
      112,
      -1,
      90,
      113,
      -4,
      90,
      114,
      -3,
      90,
      115,
      -2,
      90,
      116,
      -1,
      90,
      117,
      -2,
      90,
      118,
      -2,
      90,
      119,
      -3,
      90,
      120,
      -1,
      90,
      121,
      -2,
      90,
      122,
      1,
      97,
      118,
      -2,
      97,
      119,
      -1,
      97,
      121,
      -2,
      98,
      97,
      -1,
      98,
      99,
      -1,
      98,
      100,
      -1,
      98,
      117,
      -1,
      98,
      120,
      -1,
      98,
      121,
      -1,
      99,
      108,
      1,
      99,
      119,
      -1,
      100,
      110,
      -1,
      100,
      116,
      1,
      100,
      117,
      -1,
      101,
      108,
      1,
      102,
      97,
      -1,
      102,
      102,
      1,
      102,
      104,
      1,
      102,
      105,
      1,
      102,
      106,
      1,
      102,
      108,
      2,
      102,
      109,
      1,
      102,
      116,
      3,
      102,
      118,
      1,
      102,
      121,
      1,
      103,
      105,
      1,
      103,
      121,
      1,
      104,
      102,
      -1,
      104,
      103,
      -2,
      104,
      113,
      -1,
      104,
      115,
      -1,
      104,
      118,
      -2,
      104,
      119,
      -1,
      104,
      121,
      -2,
      105,
      102,
      1,
      105,
      118,
      1,
      106,
      116,
      1,
      106,
      117,
      -1,
      106,
      120,
      1,
      106,
      121,
      1,
      106,
      122,
      1,
      107,
      99,
      2,
      107,
      101,
      1,
      107,
      102,
      2,
      107,
      104,
      1,
      107,
      105,
      1,
      107,
      107,
      2,
      107,
      108,
      2,
      107,
      109,
      1,
      107,
      111,
      1,
      107,
      114,
      1,
      107,
      116,
      1,
      107,
      117,
      1,
      107,
      118,
      1,
      107,
      121,
      -1,
      107,
      122,
      1,
      108,
      108,
      1,
      108,
      116,
      1,
      108,
      122,
      2,
      109,
      100,
      1,
      109,
      111,
      2,
      109,
      118,
      -1,
      109,
      119,
      -1,
      109,
      121,
      -1,
      110,
      98,
      -1,
      110,
      116,
      -1,
      110,
      117,
      -1,
      110,
      118,
      -2,
      110,
      119,
      -2,
      110,
      121,
      -2,
      111,
      117,
      -1,
      111,
      119,
      -1,
      111,
      121,
      -1,
      112,
      110,
      -1,
      112,
      117,
      -1,
      112,
      121,
      -1,
      113,
      104,
      -1,
      113,
      106,
      1,
      113,
      110,
      -1,
      113,
      111,
      -1,
      113,
      117,
      -1,
      114,
      118,
      2,
      115,
      102,
      1,
      115,
      116,
      1,
      115,
      118,
      2,
      115,
      120,
      1,
      115,
      122,
      2,
      116,
      118,
      1,
      116,
      120,
      2,
      116,
      122,
      2,
      117,
      98,
      -1,
      117,
      102,
      1,
      117,
      105,
      1,
      117,
      107,
      1,
      117,
      108,
      1,
      117,
      120,
      1,
      117,
      122,
      2,
      118,
      97,
      -1,
      118,
      102,
      1,
      118,
      105,
      1,
      118,
      116,
      1,
      118,
      118,
      2,
      118,
      120,
      2,
      118,
      121,
      1,
      118,
      122,
      1,
      119,
      105,
      1,
      119,
      120,
      1,
      120,
      102,
      1,
      120,
      105,
      1,
      120,
      107,
      1,
      120,
      108,
      1,
      120,
      110,
      -1,
      120,
      112,
      1,
      120,
      113,
      -1,
      120,
      118,
      1,
      120,
      120,
      1,
      120,
      121,
      -1,
      120,
      122,
      1,
      121,
      97,
      -1,
      121,
      100,
      -1,
      121,
      101,
      1,
      121,
      110,
      -1,
      121,
      116,
      1,
      121,
      117,
      -1,
      121,
      118,
      1,
      121,
      120,
      1,
      122,
      102,
      1,
      122,
      105,
      1,
      122,
      116,
      1,
      122,
      118,
      1,
      122,
      120,
      1,
      122,
      122,
      2
    ]
  },
  "Inter|bold|italic": {
    emSize: 80,
    commonLineHeight: 97,
    capTop: 20,
    advances: [
      19,
      27,
      44,
      52,
      52,
      81,
      55,
      27,
      30,
      30,
      45,
      54,
      27,
      37,
      27,
      31,
      54,
      35,
      50,
      52,
      54,
      50,
      52,
      47,
      52,
      52,
      27,
      27,
      54,
      54,
      54,
      45,
      81,
      60,
      53,
      59,
      58,
      49,
      47,
      60,
      60,
      22,
      47,
      58,
      45,
      75,
      61,
      62,
      52,
      62,
      53,
      52,
      53,
      59,
      60,
      83,
      59,
      58,
      53,
      30,
      31,
      30,
      39,
      38,
      29,
      50,
      50,
      47,
      50,
      47,
      33,
      51,
      50,
      22,
      22,
      46,
      22,
      73,
      50,
      49,
      50,
      50,
      33,
      45,
      29,
      50,
      48,
      68,
      46,
      48,
      46,
      38,
      30,
      38,
      54
    ],
    extraAdvances: [
      162,
      47,
      163,
      51,
      165,
      46,
      176,
      37,
      183,
      27,
      215,
      54,
      8211,
      40,
      8212,
      80,
      8216,
      28,
      8217,
      28,
      8220,
      46,
      8221,
      46,
      8226,
      38,
      8230,
      80,
      8249,
      34,
      8250,
      35,
      8364,
      55,
      8377,
      46,
      8593,
      72,
      8595,
      72,
      8635,
      76,
      9632,
      73,
      9633,
      73,
      9650,
      84,
      9654,
      76,
      9664,
      76,
      9679,
      73,
      9733,
      84
    ],
    kernings: [
      34,
      38,
      -3,
      34,
      44,
      -7,
      34,
      46,
      -7,
      34,
      52,
      -5,
      38,
      34,
      -3,
      38,
      39,
      -3,
      38,
      92,
      -5,
      39,
      38,
      -3,
      39,
      44,
      -7,
      39,
      46,
      -7,
      39,
      52,
      -5,
      40,
      124,
      1,
      42,
      38,
      -3,
      42,
      44,
      -11,
      42,
      46,
      -11,
      42,
      52,
      -4,
      42,
      64,
      -1,
      42,
      95,
      -5,
      43,
      50,
      -2,
      43,
      55,
      -2,
      43,
      92,
      -4,
      44,
      32,
      -2,
      44,
      33,
      -1,
      44,
      34,
      -8,
      44,
      39,
      -8,
      44,
      48,
      -2,
      44,
      49,
      -7,
      44,
      51,
      -2,
      44,
      53,
      -1,
      44,
      54,
      -2,
      44,
      55,
      -2,
      44,
      56,
      -2,
      44,
      57,
      -1,
      44,
      63,
      -7,
      44,
      64,
      -4,
      45,
      50,
      -2,
      45,
      55,
      -2,
      45,
      92,
      -4,
      46,
      32,
      -2,
      46,
      33,
      -1,
      46,
      34,
      -8,
      46,
      39,
      -8,
      46,
      48,
      -2,
      46,
      49,
      -7,
      46,
      51,
      -2,
      46,
      53,
      -1,
      46,
      54,
      -2,
      46,
      55,
      -2,
      46,
      56,
      -2,
      46,
      57,
      -1,
      46,
      63,
      -7,
      46,
      64,
      -4,
      47,
      44,
      -3,
      47,
      46,
      -3,
      47,
      92,
      1,
      48,
      44,
      -2,
      48,
      46,
      -2,
      48,
      55,
      -2,
      48,
      92,
      -2,
      48,
      95,
      -4,
      49,
      41,
      1,
      49,
      93,
      1,
      49,
      95,
      1,
      49,
      125,
      1,
      50,
      52,
      -1,
      51,
      42,
      -1,
      51,
      44,
      -2,
      51,
      46,
      -2,
      51,
      94,
      -1,
      52,
      42,
      -3,
      52,
      44,
      -3,
      52,
      46,
      -3,
      52,
      49,
      -3,
      52,
      94,
      -3,
      53,
      44,
      -2,
      53,
      46,
      -2,
      54,
      44,
      -2,
      54,
      46,
      -2,
      54,
      95,
      -4,
      55,
      35,
      -5,
      55,
      38,
      -4,
      55,
      44,
      -10,
      55,
      46,
      -10,
      55,
      48,
      -1,
      55,
      51,
      -1,
      55,
      52,
      -5,
      55,
      53,
      -1,
      55,
      54,
      -1,
      55,
      55,
      2,
      55,
      56,
      -1,
      55,
      57,
      -1,
      55,
      58,
      -3,
      55,
      59,
      -3,
      55,
      60,
      -7,
      55,
      95,
      -13,
      56,
      42,
      -1,
      56,
      44,
      -2,
      56,
      46,
      -2,
      56,
      94,
      -1,
      57,
      44,
      -2,
      57,
      46,
      -2,
      57,
      55,
      -2,
      57,
      92,
      -2,
      57,
      95,
      -4,
      58,
      92,
      -5,
      59,
      92,
      -5,
      61,
      92,
      -5,
      62,
      55,
      -6,
      62,
      92,
      -6,
      64,
      44,
      -4,
      64,
      46,
      -4,
      64,
      47,
      -3,
      64,
      92,
      -3,
      64,
      95,
      -3,
      91,
      124,
      1,
      92,
      34,
      -6,
      92,
      36,
      -1,
      92,
      39,
      -6,
      92,
      42,
      -8,
      92,
      43,
      -3,
      92,
      45,
      -3,
      92,
      47,
      1,
      92,
      49,
      -4,
      92,
      60,
      -3,
      92,
      61,
      -4,
      92,
      63,
      -5,
      92,
      64,
      -3,
      92,
      92,
      -4,
      92,
      94,
      -8,
      92,
      126,
      -3,
      94,
      38,
      -3,
      94,
      44,
      -11,
      94,
      46,
      -11,
      94,
      52,
      -4,
      94,
      64,
      -1,
      94,
      95,
      -5,
      95,
      42,
      -5,
      95,
      48,
      -4,
      95,
      49,
      -9,
      95,
      51,
      -4,
      95,
      52,
      -5,
      95,
      53,
      -4,
      95,
      54,
      -4,
      95,
      56,
      -4,
      95,
      57,
      -4,
      95,
      64,
      -3,
      95,
      92,
      -6,
      95,
      94,
      -5,
      95,
      124,
      3,
      123,
      124,
      1,
      124,
      41,
      1,
      124,
      93,
      1,
      124,
      95,
      1,
      124,
      125,
      1,
      126,
      50,
      -2,
      126,
      55,
      -2,
      126,
      92,
      -4,
      34,
      8230,
      -7,
      37,
      8216,
      -5,
      37,
      8217,
      -5,
      37,
      8220,
      -5,
      37,
      8221,
      -5,
      38,
      8216,
      -7,
      38,
      8220,
      -7,
      39,
      8230,
      -7,
      41,
      8216,
      -3,
      41,
      8220,
      -3,
      42,
      8230,
      -11,
      43,
      8216,
      -2,
      43,
      8220,
      -2,
      44,
      8217,
      -8,
      44,
      8221,
      -8,
      45,
      8216,
      -2,
      45,
      8220,
      -2,
      46,
      8217,
      -8,
      46,
      8221,
      -8,
      47,
      8230,
      -3,
      48,
      8216,
      -4,
      48,
      8220,
      -4,
      48,
      8230,
      -2,
      51,
      8230,
      -2,
      52,
      8230,
      -3,
      53,
      8230,
      -2,
      54,
      8230,
      -2,
      55,
      8230,
      -10,
      56,
      8230,
      -2,
      57,
      8216,
      -4,
      57,
      8220,
      -4,
      57,
      8230,
      -2,
      58,
      8216,
      -4,
      58,
      8220,
      -4,
      59,
      8216,
      -4,
      59,
      8220,
      -4,
      61,
      8216,
      -5,
      61,
      8220,
      -5,
      62,
      8216,
      -8,
      62,
      8220,
      -8,
      64,
      8216,
      -3,
      64,
      8220,
      -3,
      64,
      8230,
      -4,
      92,
      8216,
      -3,
      92,
      8217,
      -5,
      92,
      8220,
      -3,
      92,
      8221,
      -5,
      93,
      8216,
      -3,
      93,
      8220,
      -3,
      94,
      8230,
      -11,
      95,
      8216,
      -3,
      95,
      8220,
      -3,
      125,
      8216,
      -3,
      125,
      8220,
      -3,
      126,
      8216,
      -2,
      126,
      8220,
      -2,
      8216,
      38,
      -5,
      8216,
      44,
      -9,
      8216,
      46,
      -9,
      8216,
      47,
      -8,
      8216,
      52,
      -5,
      8216,
      8230,
      -9,
      8217,
      35,
      -10,
      8217,
      38,
      -5,
      8217,
      43,
      -4,
      8217,
      44,
      -10,
      8217,
      45,
      -4,
      8217,
      46,
      -10,
      8217,
      47,
      -11,
      8217,
      48,
      -4,
      8217,
      52,
      -8,
      8217,
      54,
      -4,
      8217,
      55,
      -5,
      8217,
      56,
      -3,
      8217,
      58,
      -5,
      8217,
      59,
      -5,
      8217,
      60,
      -8,
      8217,
      61,
      -5,
      8217,
      64,
      -5,
      8217,
      95,
      -3,
      8217,
      126,
      -4,
      8217,
      8230,
      -10,
      8220,
      38,
      -5,
      8220,
      44,
      -9,
      8220,
      46,
      -9,
      8220,
      47,
      -8,
      8220,
      52,
      -5,
      8220,
      8230,
      -9,
      8221,
      35,
      -10,
      8221,
      38,
      -5,
      8221,
      43,
      -4,
      8221,
      44,
      -10,
      8221,
      45,
      -4,
      8221,
      46,
      -10,
      8221,
      47,
      -11,
      8221,
      48,
      -4,
      8221,
      52,
      -8,
      8221,
      54,
      -4,
      8221,
      55,
      -5,
      8221,
      56,
      -3,
      8221,
      58,
      -5,
      8221,
      59,
      -5,
      8221,
      60,
      -8,
      8221,
      61,
      -5,
      8221,
      64,
      -5,
      8221,
      95,
      -3,
      8221,
      126,
      -4,
      8221,
      8230,
      -10,
      8230,
      32,
      -2,
      8230,
      33,
      -1,
      8230,
      34,
      -8,
      8230,
      39,
      -8,
      8230,
      48,
      -2,
      8230,
      49,
      -7,
      8230,
      51,
      -2,
      8230,
      53,
      -1,
      8230,
      54,
      -2,
      8230,
      55,
      -2,
      8230,
      56,
      -2,
      8230,
      57,
      -1,
      8230,
      63,
      -7,
      8230,
      64,
      -4,
      8230,
      8217,
      -8,
      8230,
      8221,
      -8,
      34,
      162,
      -2,
      39,
      162,
      -2,
      51,
      176,
      -1,
      52,
      176,
      -3,
      55,
      162,
      -4,
      56,
      176,
      -1,
      92,
      162,
      -2,
      92,
      176,
      -8,
      92,
      215,
      -3,
      92,
      183,
      -3,
      95,
      176,
      -5,
      8216,
      162,
      -3,
      8217,
      162,
      -5,
      8217,
      183,
      -4,
      8220,
      162,
      -3,
      8221,
      162,
      -5,
      8221,
      183,
      -4,
      162,
      34,
      -2,
      162,
      39,
      -2,
      162,
      41,
      -1,
      162,
      49,
      -3,
      162,
      92,
      -5,
      162,
      93,
      -1,
      162,
      125,
      -1,
      162,
      8216,
      -5,
      162,
      8217,
      -2,
      162,
      8220,
      -5,
      162,
      8221,
      -2,
      176,
      38,
      -3,
      176,
      44,
      -11,
      176,
      46,
      -11,
      176,
      52,
      -4,
      176,
      64,
      -1,
      176,
      95,
      -5,
      176,
      8230,
      -11,
      215,
      92,
      -3,
      183,
      50,
      -2,
      183,
      55,
      -2,
      183,
      92,
      -3,
      183,
      8216,
      -2,
      183,
      8220,
      -2,
      34,
      9650,
      -6,
      36,
      9650,
      -1,
      39,
      9650,
      -6,
      40,
      9632,
      1,
      40,
      9633,
      1,
      42,
      9679,
      -1,
      42,
      9650,
      -8,
      43,
      9650,
      -3,
      44,
      9679,
      -4,
      45,
      9650,
      -3,
      46,
      9679,
      -4,
      47,
      9650,
      -2,
      51,
      8249,
      -3,
      55,
      8249,
      -5,
      55,
      9650,
      -9,
      56,
      8249,
      -3,
      61,
      9650,
      -4,
      62,
      9650,
      -3,
      63,
      9650,
      -5,
      64,
      9650,
      -3,
      91,
      9632,
      1,
      91,
      9633,
      1,
      92,
      8226,
      -3,
      92,
      8249,
      -3,
      92,
      8250,
      -3,
      92,
      9679,
      -3,
      92,
      9650,
      1,
      94,
      9679,
      -1,
      94,
      9650,
      -8,
      95,
      9679,
      -3,
      95,
      9632,
      3,
      95,
      9633,
      3,
      123,
      9632,
      1,
      123,
      9633,
      1,
      126,
      9650,
      -3,
      8216,
      9650,
      -8,
      8217,
      8249,
      -7,
      8217,
      9679,
      -5,
      8217,
      9650,
      -11,
      8220,
      9650,
      -8,
      8221,
      8249,
      -7,
      8221,
      9679,
      -5,
      8221,
      9650,
      -11,
      8230,
      9679,
      -4,
      162,
      9650,
      -3,
      176,
      9679,
      -1,
      176,
      9650,
      -8,
      215,
      9650,
      -3,
      183,
      9650,
      -3,
      8226,
      92,
      -3,
      8226,
      9650,
      -3,
      8249,
      9650,
      -3,
      8250,
      49,
      -3,
      8250,
      50,
      -4,
      8250,
      51,
      -4,
      8250,
      55,
      -4,
      8250,
      56,
      -3,
      8250,
      92,
      -5,
      8250,
      8216,
      -7,
      8250,
      8220,
      -7,
      8250,
      9650,
      -3,
      9679,
      44,
      -4,
      9679,
      46,
      -4,
      9679,
      47,
      -3,
      9679,
      92,
      -3,
      9679,
      95,
      -3,
      9679,
      8216,
      -3,
      9679,
      8220,
      -3,
      9679,
      8230,
      -4,
      9679,
      9650,
      -3,
      9632,
      41,
      1,
      9632,
      93,
      1,
      9632,
      95,
      1,
      9632,
      125,
      1,
      9633,
      41,
      1,
      9633,
      93,
      1,
      9633,
      95,
      1,
      9633,
      125,
      1,
      9650,
      34,
      -6,
      9650,
      36,
      -1,
      9650,
      39,
      -6,
      9650,
      42,
      -8,
      9650,
      43,
      -3,
      9650,
      45,
      -3,
      9650,
      47,
      1,
      9650,
      49,
      -4,
      9650,
      60,
      -3,
      9650,
      61,
      -4,
      9650,
      63,
      -5,
      9650,
      64,
      -3,
      9650,
      92,
      -6,
      9650,
      94,
      -8,
      9650,
      126,
      -3,
      9650,
      8216,
      -10,
      9650,
      8217,
      -8,
      9650,
      8220,
      -10,
      9650,
      8221,
      -8,
      9650,
      162,
      -2,
      9650,
      176,
      -8,
      9650,
      215,
      -3,
      9650,
      183,
      -3,
      9650,
      8226,
      -3,
      9650,
      8249,
      -3,
      9650,
      8250,
      -3,
      9650,
      9679,
      -3,
      9650,
      9650,
      1
    ]
  },
  "Inter|bold|normal": {
    emSize: 80,
    commonLineHeight: 97,
    capTop: 20,
    advances: [
      19,
      27,
      44,
      52,
      52,
      81,
      54,
      27,
      30,
      30,
      45,
      54,
      27,
      37,
      27,
      31,
      54,
      34,
      50,
      52,
      54,
      50,
      52,
      47,
      52,
      52,
      27,
      27,
      54,
      54,
      54,
      45,
      81,
      60,
      53,
      59,
      58,
      49,
      47,
      60,
      60,
      22,
      47,
      58,
      45,
      75,
      61,
      62,
      52,
      62,
      53,
      52,
      53,
      59,
      60,
      83,
      59,
      58,
      53,
      30,
      31,
      30,
      39,
      38,
      29,
      46,
      50,
      47,
      50,
      48,
      32,
      51,
      50,
      22,
      22,
      46,
      22,
      73,
      50,
      49,
      50,
      50,
      33,
      45,
      29,
      50,
      48,
      68,
      46,
      48,
      46,
      38,
      30,
      38,
      54
    ],
    extraAdvances: [
      162,
      47,
      163,
      51,
      165,
      46,
      176,
      37,
      183,
      27,
      215,
      54,
      8211,
      40,
      8212,
      80,
      8216,
      25,
      8217,
      25,
      8220,
      43,
      8221,
      43,
      8226,
      38,
      8230,
      80,
      8249,
      34,
      8250,
      34,
      8364,
      55,
      8377,
      46,
      8593,
      72,
      8595,
      72,
      8635,
      76,
      9632,
      73,
      9633,
      73,
      9650,
      84,
      9654,
      76,
      9664,
      76,
      9679,
      73,
      9733,
      84
    ],
    kernings: [
      34,
      38,
      -3,
      34,
      44,
      -7,
      34,
      46,
      -7,
      34,
      52,
      -5,
      38,
      34,
      -3,
      38,
      39,
      -3,
      38,
      92,
      -5,
      39,
      38,
      -3,
      39,
      44,
      -7,
      39,
      46,
      -7,
      39,
      52,
      -5,
      40,
      124,
      1,
      42,
      38,
      -3,
      42,
      44,
      -11,
      42,
      46,
      -11,
      42,
      52,
      -4,
      42,
      64,
      -1,
      42,
      95,
      -5,
      43,
      50,
      -2,
      43,
      55,
      -2,
      43,
      92,
      -4,
      44,
      32,
      -2,
      44,
      33,
      -1,
      44,
      34,
      -8,
      44,
      39,
      -8,
      44,
      48,
      -2,
      44,
      49,
      -7,
      44,
      51,
      -2,
      44,
      53,
      -1,
      44,
      54,
      -2,
      44,
      55,
      -2,
      44,
      56,
      -2,
      44,
      57,
      -1,
      44,
      63,
      -7,
      44,
      64,
      -4,
      45,
      50,
      -2,
      45,
      55,
      -2,
      45,
      92,
      -4,
      46,
      32,
      -2,
      46,
      33,
      -1,
      46,
      34,
      -8,
      46,
      39,
      -8,
      46,
      48,
      -2,
      46,
      49,
      -7,
      46,
      51,
      -2,
      46,
      53,
      -1,
      46,
      54,
      -2,
      46,
      55,
      -2,
      46,
      56,
      -2,
      46,
      57,
      -1,
      46,
      63,
      -7,
      46,
      64,
      -4,
      47,
      44,
      -3,
      47,
      46,
      -3,
      47,
      92,
      1,
      48,
      44,
      -2,
      48,
      46,
      -2,
      48,
      55,
      -2,
      48,
      92,
      -2,
      48,
      95,
      -4,
      49,
      41,
      1,
      49,
      93,
      1,
      49,
      95,
      1,
      49,
      125,
      1,
      50,
      52,
      -1,
      51,
      42,
      -1,
      51,
      44,
      -2,
      51,
      46,
      -2,
      51,
      94,
      -1,
      52,
      42,
      -3,
      52,
      44,
      -3,
      52,
      46,
      -3,
      52,
      49,
      -3,
      52,
      94,
      -3,
      53,
      44,
      -2,
      53,
      46,
      -2,
      54,
      44,
      -2,
      54,
      46,
      -2,
      54,
      95,
      -4,
      55,
      35,
      -5,
      55,
      38,
      -4,
      55,
      44,
      -10,
      55,
      46,
      -10,
      55,
      48,
      -1,
      55,
      51,
      -1,
      55,
      52,
      -5,
      55,
      53,
      -1,
      55,
      54,
      -1,
      55,
      55,
      2,
      55,
      56,
      -1,
      55,
      57,
      -1,
      55,
      58,
      -3,
      55,
      59,
      -3,
      55,
      60,
      -7,
      55,
      95,
      -13,
      56,
      42,
      -1,
      56,
      44,
      -2,
      56,
      46,
      -2,
      56,
      94,
      -1,
      57,
      44,
      -2,
      57,
      46,
      -2,
      57,
      55,
      -2,
      57,
      92,
      -2,
      57,
      95,
      -4,
      58,
      92,
      -5,
      59,
      92,
      -5,
      61,
      92,
      -5,
      62,
      55,
      -6,
      62,
      92,
      -6,
      64,
      44,
      -4,
      64,
      46,
      -4,
      64,
      47,
      -3,
      64,
      92,
      -3,
      64,
      95,
      -3,
      91,
      124,
      1,
      92,
      34,
      -6,
      92,
      36,
      -1,
      92,
      39,
      -6,
      92,
      42,
      -8,
      92,
      43,
      -3,
      92,
      45,
      -3,
      92,
      47,
      1,
      92,
      49,
      -4,
      92,
      60,
      -3,
      92,
      61,
      -4,
      92,
      63,
      -5,
      92,
      64,
      -3,
      92,
      92,
      -4,
      92,
      94,
      -8,
      92,
      126,
      -3,
      94,
      38,
      -3,
      94,
      44,
      -11,
      94,
      46,
      -11,
      94,
      52,
      -4,
      94,
      64,
      -1,
      94,
      95,
      -5,
      95,
      42,
      -5,
      95,
      48,
      -4,
      95,
      49,
      -9,
      95,
      51,
      -4,
      95,
      52,
      -5,
      95,
      53,
      -4,
      95,
      54,
      -4,
      95,
      56,
      -4,
      95,
      57,
      -4,
      95,
      64,
      -3,
      95,
      92,
      -6,
      95,
      94,
      -5,
      95,
      124,
      3,
      123,
      124,
      1,
      124,
      41,
      1,
      124,
      93,
      1,
      124,
      95,
      1,
      124,
      125,
      1,
      126,
      50,
      -2,
      126,
      55,
      -2,
      126,
      92,
      -4,
      34,
      8230,
      -7,
      37,
      8216,
      -5,
      37,
      8217,
      -5,
      37,
      8220,
      -5,
      37,
      8221,
      -5,
      38,
      8216,
      -7,
      38,
      8220,
      -7,
      39,
      8230,
      -7,
      41,
      8216,
      -3,
      41,
      8220,
      -3,
      42,
      8230,
      -11,
      43,
      8216,
      -2,
      43,
      8220,
      -2,
      44,
      8217,
      -8,
      44,
      8221,
      -8,
      45,
      8216,
      -2,
      45,
      8220,
      -2,
      46,
      8217,
      -8,
      46,
      8221,
      -8,
      47,
      8230,
      -3,
      48,
      8216,
      -4,
      48,
      8220,
      -4,
      48,
      8230,
      -2,
      51,
      8230,
      -2,
      52,
      8230,
      -3,
      53,
      8230,
      -2,
      54,
      8230,
      -2,
      55,
      8230,
      -10,
      56,
      8230,
      -2,
      57,
      8216,
      -4,
      57,
      8220,
      -4,
      57,
      8230,
      -2,
      58,
      8216,
      -4,
      58,
      8220,
      -4,
      59,
      8216,
      -4,
      59,
      8220,
      -4,
      61,
      8216,
      -5,
      61,
      8220,
      -5,
      62,
      8216,
      -8,
      62,
      8220,
      -8,
      64,
      8216,
      -3,
      64,
      8220,
      -3,
      64,
      8230,
      -4,
      92,
      8216,
      -3,
      92,
      8217,
      -5,
      92,
      8220,
      -3,
      92,
      8221,
      -5,
      93,
      8216,
      -3,
      93,
      8220,
      -3,
      94,
      8230,
      -11,
      95,
      8216,
      -3,
      95,
      8220,
      -3,
      125,
      8216,
      -3,
      125,
      8220,
      -3,
      126,
      8216,
      -2,
      126,
      8220,
      -2,
      8216,
      38,
      -5,
      8216,
      44,
      -9,
      8216,
      46,
      -9,
      8216,
      47,
      -8,
      8216,
      52,
      -5,
      8216,
      8230,
      -9,
      8217,
      35,
      -10,
      8217,
      38,
      -5,
      8217,
      43,
      -4,
      8217,
      44,
      -10,
      8217,
      45,
      -4,
      8217,
      46,
      -10,
      8217,
      47,
      -11,
      8217,
      48,
      -4,
      8217,
      52,
      -8,
      8217,
      54,
      -4,
      8217,
      55,
      -5,
      8217,
      56,
      -3,
      8217,
      58,
      -5,
      8217,
      59,
      -5,
      8217,
      60,
      -8,
      8217,
      61,
      -5,
      8217,
      64,
      -5,
      8217,
      95,
      -3,
      8217,
      126,
      -4,
      8217,
      8230,
      -10,
      8220,
      38,
      -5,
      8220,
      44,
      -9,
      8220,
      46,
      -9,
      8220,
      47,
      -8,
      8220,
      52,
      -5,
      8220,
      8230,
      -9,
      8221,
      35,
      -10,
      8221,
      38,
      -5,
      8221,
      43,
      -4,
      8221,
      44,
      -10,
      8221,
      45,
      -4,
      8221,
      46,
      -10,
      8221,
      47,
      -11,
      8221,
      48,
      -4,
      8221,
      52,
      -8,
      8221,
      54,
      -4,
      8221,
      55,
      -5,
      8221,
      56,
      -3,
      8221,
      58,
      -5,
      8221,
      59,
      -5,
      8221,
      60,
      -8,
      8221,
      61,
      -5,
      8221,
      64,
      -5,
      8221,
      95,
      -3,
      8221,
      126,
      -4,
      8221,
      8230,
      -10,
      8230,
      32,
      -2,
      8230,
      33,
      -1,
      8230,
      34,
      -8,
      8230,
      39,
      -8,
      8230,
      48,
      -2,
      8230,
      49,
      -7,
      8230,
      51,
      -2,
      8230,
      53,
      -1,
      8230,
      54,
      -2,
      8230,
      55,
      -2,
      8230,
      56,
      -2,
      8230,
      57,
      -1,
      8230,
      63,
      -7,
      8230,
      64,
      -4,
      8230,
      8217,
      -8,
      8230,
      8221,
      -8,
      34,
      162,
      -2,
      39,
      162,
      -2,
      51,
      176,
      -1,
      52,
      176,
      -3,
      55,
      162,
      -4,
      56,
      176,
      -1,
      92,
      162,
      -2,
      92,
      176,
      -8,
      92,
      215,
      -3,
      92,
      183,
      -3,
      95,
      176,
      -5,
      8216,
      162,
      -3,
      8217,
      162,
      -5,
      8217,
      183,
      -4,
      8220,
      162,
      -3,
      8221,
      162,
      -5,
      8221,
      183,
      -4,
      162,
      34,
      -2,
      162,
      39,
      -2,
      162,
      41,
      -1,
      162,
      49,
      -3,
      162,
      92,
      -5,
      162,
      93,
      -1,
      162,
      125,
      -1,
      162,
      8216,
      -5,
      162,
      8217,
      -2,
      162,
      8220,
      -5,
      162,
      8221,
      -2,
      176,
      38,
      -3,
      176,
      44,
      -11,
      176,
      46,
      -11,
      176,
      52,
      -4,
      176,
      64,
      -1,
      176,
      95,
      -5,
      176,
      8230,
      -11,
      215,
      92,
      -3,
      183,
      50,
      -2,
      183,
      55,
      -2,
      183,
      92,
      -3,
      183,
      8216,
      -2,
      183,
      8220,
      -2,
      34,
      9650,
      -6,
      36,
      9650,
      -1,
      39,
      9650,
      -6,
      40,
      9632,
      1,
      40,
      9633,
      1,
      42,
      9679,
      -1,
      42,
      9650,
      -8,
      43,
      9650,
      -3,
      44,
      9679,
      -4,
      45,
      9650,
      -3,
      46,
      9679,
      -4,
      47,
      9650,
      -2,
      51,
      8249,
      -3,
      55,
      8249,
      -5,
      55,
      9650,
      -9,
      56,
      8249,
      -3,
      61,
      9650,
      -4,
      62,
      9650,
      -3,
      63,
      9650,
      -5,
      64,
      9650,
      -3,
      91,
      9632,
      1,
      91,
      9633,
      1,
      92,
      8226,
      -3,
      92,
      8249,
      -3,
      92,
      8250,
      -3,
      92,
      9679,
      -3,
      92,
      9650,
      1,
      94,
      9679,
      -1,
      94,
      9650,
      -8,
      95,
      9679,
      -3,
      95,
      9632,
      3,
      95,
      9633,
      3,
      123,
      9632,
      1,
      123,
      9633,
      1,
      126,
      9650,
      -3,
      8216,
      9650,
      -8,
      8217,
      8249,
      -7,
      8217,
      9679,
      -5,
      8217,
      9650,
      -11,
      8220,
      9650,
      -8,
      8221,
      8249,
      -7,
      8221,
      9679,
      -5,
      8221,
      9650,
      -11,
      8230,
      9679,
      -4,
      162,
      9650,
      -3,
      176,
      9679,
      -1,
      176,
      9650,
      -8,
      215,
      9650,
      -3,
      183,
      9650,
      -3,
      8226,
      92,
      -3,
      8226,
      9650,
      -3,
      8249,
      9650,
      -3,
      8250,
      49,
      -3,
      8250,
      50,
      -4,
      8250,
      51,
      -4,
      8250,
      55,
      -4,
      8250,
      56,
      -3,
      8250,
      92,
      -5,
      8250,
      8216,
      -7,
      8250,
      8220,
      -7,
      8250,
      9650,
      -3,
      9679,
      44,
      -4,
      9679,
      46,
      -4,
      9679,
      47,
      -3,
      9679,
      92,
      -3,
      9679,
      95,
      -3,
      9679,
      8216,
      -3,
      9679,
      8220,
      -3,
      9679,
      8230,
      -4,
      9679,
      9650,
      -3,
      9632,
      41,
      1,
      9632,
      93,
      1,
      9632,
      95,
      1,
      9632,
      125,
      1,
      9633,
      41,
      1,
      9633,
      93,
      1,
      9633,
      95,
      1,
      9633,
      125,
      1,
      9650,
      34,
      -6,
      9650,
      36,
      -1,
      9650,
      39,
      -6,
      9650,
      42,
      -8,
      9650,
      43,
      -3,
      9650,
      45,
      -3,
      9650,
      47,
      1,
      9650,
      49,
      -4,
      9650,
      60,
      -3,
      9650,
      61,
      -4,
      9650,
      63,
      -5,
      9650,
      64,
      -3,
      9650,
      92,
      -6,
      9650,
      94,
      -8,
      9650,
      126,
      -3,
      9650,
      8216,
      -10,
      9650,
      8217,
      -8,
      9650,
      8220,
      -10,
      9650,
      8221,
      -8,
      9650,
      162,
      -2,
      9650,
      176,
      -8,
      9650,
      215,
      -3,
      9650,
      183,
      -3,
      9650,
      8226,
      -3,
      9650,
      8249,
      -3,
      9650,
      8250,
      -3,
      9650,
      9679,
      -3,
      9650,
      9650,
      1
    ]
  },
  "Inter|regular|italic": {
    emSize: 80,
    commonLineHeight: 97,
    capTop: 20,
    advances: [
      23,
      23,
      37,
      51,
      51,
      79,
      55,
      24,
      29,
      29,
      40,
      53,
      23,
      37,
      23,
      29,
      50,
      33,
      49,
      49,
      52,
      47,
      49,
      45,
      49,
      50,
      23,
      24,
      53,
      53,
      53,
      41,
      77,
      55,
      52,
      58,
      58,
      48,
      47,
      60,
      59,
      21,
      46,
      54,
      45,
      72,
      60,
      61,
      51,
      61,
      51,
      51,
      52,
      59,
      55,
      79,
      55,
      54,
      50,
      29,
      29,
      29,
      38,
      36,
      26,
      49,
      49,
      46,
      49,
      46,
      30,
      49,
      47,
      19,
      19,
      44,
      19,
      70,
      47,
      48,
      49,
      49,
      30,
      42,
      26,
      47,
      45,
      65,
      44,
      45,
      44,
      34,
      27,
      34,
      53
    ],
    extraAdvances: [
      162,
      46,
      163,
      49,
      165,
      44,
      176,
      36,
      183,
      23,
      215,
      53,
      8211,
      40,
      8212,
      80,
      8216,
      24,
      8217,
      24,
      8220,
      38,
      8221,
      38,
      8226,
      45,
      8230,
      69,
      8249,
      31,
      8250,
      31,
      8364,
      53,
      8377,
      43,
      8593,
      67,
      8595,
      67,
      8635,
      76,
      9632,
      73,
      9633,
      73,
      9650,
      81,
      9654,
      73,
      9664,
      73,
      9679,
      73,
      9733,
      84
    ],
    kernings: [
      34,
      38,
      -3,
      34,
      44,
      -7,
      34,
      46,
      -7,
      34,
      52,
      -5,
      38,
      34,
      -3,
      38,
      39,
      -3,
      38,
      92,
      -5,
      39,
      38,
      -3,
      39,
      44,
      -7,
      39,
      46,
      -7,
      39,
      52,
      -5,
      42,
      38,
      -3,
      42,
      44,
      -11,
      42,
      46,
      -11,
      42,
      52,
      -4,
      42,
      64,
      -1,
      42,
      95,
      -5,
      43,
      50,
      -3,
      43,
      51,
      -1,
      43,
      55,
      -2,
      43,
      92,
      -4,
      44,
      34,
      -7,
      44,
      39,
      -7,
      44,
      48,
      -2,
      44,
      49,
      -7,
      44,
      51,
      -2,
      44,
      53,
      -1,
      44,
      54,
      -2,
      44,
      55,
      -1,
      44,
      56,
      -2,
      44,
      57,
      -1,
      44,
      63,
      -7,
      44,
      64,
      -4,
      45,
      50,
      -3,
      45,
      51,
      -1,
      45,
      55,
      -2,
      45,
      92,
      -4,
      46,
      34,
      -7,
      46,
      39,
      -7,
      46,
      48,
      -2,
      46,
      49,
      -7,
      46,
      51,
      -2,
      46,
      53,
      -1,
      46,
      54,
      -2,
      46,
      55,
      -1,
      46,
      56,
      -2,
      46,
      57,
      -1,
      46,
      63,
      -7,
      46,
      64,
      -4,
      47,
      44,
      -3,
      47,
      46,
      -3,
      48,
      44,
      -2,
      48,
      46,
      -2,
      48,
      55,
      -2,
      48,
      92,
      -1,
      48,
      95,
      -4,
      50,
      52,
      -1,
      51,
      42,
      -1,
      51,
      44,
      -2,
      51,
      46,
      -2,
      51,
      94,
      -1,
      52,
      42,
      -2,
      52,
      44,
      -3,
      52,
      46,
      -3,
      52,
      49,
      -2,
      52,
      94,
      -2,
      53,
      44,
      -2,
      53,
      46,
      -2,
      54,
      44,
      -3,
      54,
      46,
      -3,
      54,
      95,
      -4,
      55,
      35,
      -5,
      55,
      38,
      -4,
      55,
      44,
      -10,
      55,
      46,
      -10,
      55,
      48,
      -1,
      55,
      51,
      -1,
      55,
      52,
      -5,
      55,
      53,
      -1,
      55,
      54,
      -1,
      55,
      55,
      2,
      55,
      56,
      -1,
      55,
      57,
      -1,
      55,
      58,
      -3,
      55,
      59,
      -3,
      55,
      60,
      -7,
      55,
      95,
      -13,
      56,
      42,
      -1,
      56,
      44,
      -2,
      56,
      46,
      -2,
      56,
      94,
      -1,
      57,
      44,
      -2,
      57,
      46,
      -2,
      57,
      55,
      -2,
      57,
      92,
      -1,
      57,
      95,
      -4,
      58,
      92,
      -5,
      59,
      92,
      -5,
      61,
      92,
      -5,
      62,
      55,
      -6,
      62,
      92,
      -6,
      64,
      44,
      -4,
      64,
      46,
      -4,
      64,
      47,
      -3,
      64,
      92,
      -3,
      64,
      95,
      -3,
      92,
      34,
      -6,
      92,
      39,
      -6,
      92,
      42,
      -6,
      92,
      43,
      -3,
      92,
      45,
      -3,
      92,
      47,
      2,
      92,
      49,
      -3,
      92,
      61,
      -4,
      92,
      63,
      -5,
      92,
      64,
      -3,
      92,
      92,
      -4,
      92,
      94,
      -6,
      92,
      126,
      -3,
      94,
      38,
      -3,
      94,
      44,
      -11,
      94,
      46,
      -11,
      94,
      52,
      -4,
      94,
      64,
      -1,
      94,
      95,
      -5,
      95,
      42,
      -5,
      95,
      48,
      -4,
      95,
      49,
      -9,
      95,
      51,
      -4,
      95,
      52,
      -5,
      95,
      53,
      -4,
      95,
      54,
      -4,
      95,
      56,
      -4,
      95,
      57,
      -4,
      95,
      64,
      -3,
      95,
      92,
      -6,
      95,
      94,
      -5,
      95,
      124,
      3,
      126,
      50,
      -3,
      126,
      51,
      -1,
      126,
      55,
      -2,
      126,
      92,
      -4,
      34,
      8230,
      -7,
      37,
      8216,
      -5,
      37,
      8217,
      -5,
      37,
      8220,
      -5,
      37,
      8221,
      -5,
      38,
      8216,
      -7,
      38,
      8220,
      -7,
      39,
      8230,
      -7,
      41,
      8216,
      -3,
      41,
      8220,
      -3,
      42,
      8230,
      -11,
      43,
      8216,
      -5,
      43,
      8220,
      -5,
      44,
      8217,
      -5,
      44,
      8221,
      -5,
      45,
      8216,
      -5,
      45,
      8220,
      -5,
      46,
      8217,
      -5,
      46,
      8221,
      -5,
      47,
      8230,
      -3,
      48,
      8216,
      -4,
      48,
      8220,
      -4,
      48,
      8230,
      -2,
      51,
      8230,
      -2,
      52,
      8230,
      -3,
      53,
      8230,
      -2,
      54,
      8230,
      -3,
      55,
      8230,
      -10,
      56,
      8230,
      -2,
      57,
      8216,
      -4,
      57,
      8220,
      -4,
      57,
      8230,
      -2,
      58,
      8216,
      -4,
      58,
      8220,
      -4,
      59,
      8216,
      -4,
      59,
      8220,
      -4,
      61,
      8216,
      -5,
      61,
      8220,
      -5,
      62,
      8216,
      -8,
      62,
      8220,
      -8,
      64,
      8216,
      -3,
      64,
      8220,
      -3,
      64,
      8230,
      -4,
      92,
      8216,
      -3,
      92,
      8217,
      -5,
      92,
      8220,
      -3,
      92,
      8221,
      -5,
      93,
      8216,
      -3,
      93,
      8220,
      -3,
      94,
      8230,
      -11,
      95,
      8216,
      -3,
      95,
      8220,
      -3,
      125,
      8216,
      -3,
      125,
      8220,
      -3,
      126,
      8216,
      -5,
      126,
      8220,
      -5,
      8216,
      38,
      -5,
      8216,
      44,
      -7,
      8216,
      46,
      -7,
      8216,
      47,
      -8,
      8216,
      52,
      -5,
      8216,
      8230,
      -7,
      8217,
      35,
      -10,
      8217,
      38,
      -5,
      8217,
      43,
      -5,
      8217,
      44,
      -8,
      8217,
      45,
      -5,
      8217,
      46,
      -8,
      8217,
      47,
      -11,
      8217,
      48,
      -4,
      8217,
      52,
      -8,
      8217,
      54,
      -4,
      8217,
      55,
      -5,
      8217,
      56,
      -3,
      8217,
      58,
      -5,
      8217,
      59,
      -5,
      8217,
      60,
      -8,
      8217,
      61,
      -5,
      8217,
      64,
      -5,
      8217,
      95,
      -3,
      8217,
      126,
      -4,
      8217,
      8230,
      -8,
      8220,
      38,
      -5,
      8220,
      44,
      -7,
      8220,
      46,
      -7,
      8220,
      47,
      -8,
      8220,
      52,
      -5,
      8220,
      8230,
      -7,
      8221,
      35,
      -10,
      8221,
      38,
      -5,
      8221,
      43,
      -5,
      8221,
      44,
      -8,
      8221,
      45,
      -5,
      8221,
      46,
      -8,
      8221,
      47,
      -11,
      8221,
      48,
      -4,
      8221,
      52,
      -8,
      8221,
      54,
      -4,
      8221,
      55,
      -5,
      8221,
      56,
      -3,
      8221,
      58,
      -5,
      8221,
      59,
      -5,
      8221,
      60,
      -8,
      8221,
      61,
      -5,
      8221,
      64,
      -5,
      8221,
      95,
      -3,
      8221,
      126,
      -4,
      8221,
      8230,
      -8,
      8230,
      34,
      -7,
      8230,
      39,
      -7,
      8230,
      48,
      -2,
      8230,
      49,
      -7,
      8230,
      51,
      -2,
      8230,
      53,
      -1,
      8230,
      54,
      -2,
      8230,
      55,
      -1,
      8230,
      56,
      -2,
      8230,
      57,
      -1,
      8230,
      63,
      -7,
      8230,
      64,
      -4,
      8230,
      8217,
      -5,
      8230,
      8221,
      -5,
      34,
      162,
      -1,
      39,
      162,
      -1,
      40,
      162,
      -1,
      51,
      176,
      -1,
      52,
      176,
      -2,
      55,
      162,
      -4,
      56,
      176,
      -1,
      91,
      162,
      -1,
      92,
      176,
      -6,
      92,
      215,
      -3,
      92,
      183,
      -3,
      95,
      176,
      -5,
      123,
      162,
      -1,
      8216,
      162,
      -3,
      8217,
      162,
      -5,
      8217,
      183,
      -5,
      8220,
      162,
      -3,
      8221,
      162,
      -5,
      8221,
      183,
      -5,
      162,
      34,
      -1,
      162,
      39,
      -1,
      162,
      41,
      -1,
      162,
      49,
      -3,
      162,
      92,
      -4,
      162,
      93,
      -1,
      162,
      125,
      -1,
      162,
      8216,
      -5,
      162,
      8217,
      -2,
      162,
      8220,
      -5,
      162,
      8221,
      -2,
      176,
      38,
      -3,
      176,
      44,
      -11,
      176,
      46,
      -11,
      176,
      52,
      -4,
      176,
      64,
      -1,
      176,
      95,
      -5,
      176,
      8230,
      -11,
      215,
      92,
      -3,
      183,
      50,
      -3,
      183,
      51,
      -1,
      183,
      55,
      -2,
      183,
      92,
      -3,
      183,
      8216,
      -5,
      183,
      8220,
      -5,
      34,
      9650,
      -6,
      39,
      9650,
      -6,
      42,
      9679,
      -1,
      42,
      9650,
      -6,
      43,
      9650,
      -3,
      44,
      9679,
      -4,
      45,
      9650,
      -3,
      46,
      9679,
      -4,
      47,
      9650,
      -2,
      51,
      8249,
      -3,
      55,
      8249,
      -5,
      55,
      9650,
      -9,
      56,
      8249,
      -3,
      61,
      9650,
      -4,
      63,
      9650,
      -5,
      64,
      9650,
      -3,
      92,
      8226,
      -3,
      92,
      8249,
      -3,
      92,
      8250,
      -3,
      92,
      9679,
      -3,
      92,
      9650,
      1,
      94,
      9679,
      -1,
      94,
      9650,
      -6,
      95,
      9679,
      -3,
      95,
      9632,
      3,
      95,
      9633,
      3,
      126,
      9650,
      -3,
      8216,
      9650,
      -8,
      8217,
      8249,
      -7,
      8217,
      9679,
      -5,
      8217,
      9650,
      -11,
      8220,
      9650,
      -8,
      8221,
      8249,
      -7,
      8221,
      9679,
      -5,
      8221,
      9650,
      -11,
      8230,
      9679,
      -4,
      162,
      9650,
      -3,
      176,
      9679,
      -1,
      176,
      9650,
      -6,
      215,
      9650,
      -3,
      183,
      9650,
      -3,
      8226,
      92,
      -3,
      8226,
      9650,
      -3,
      8249,
      9650,
      -3,
      8250,
      49,
      -3,
      8250,
      50,
      -4,
      8250,
      51,
      -4,
      8250,
      55,
      -4,
      8250,
      56,
      -3,
      8250,
      92,
      -5,
      8250,
      8216,
      -7,
      8250,
      8220,
      -7,
      8250,
      9650,
      -3,
      9679,
      44,
      -4,
      9679,
      46,
      -4,
      9679,
      47,
      -3,
      9679,
      92,
      -3,
      9679,
      95,
      -3,
      9679,
      8216,
      -3,
      9679,
      8220,
      -3,
      9679,
      8230,
      -4,
      9679,
      9650,
      -3,
      9650,
      34,
      -6,
      9650,
      39,
      -6,
      9650,
      42,
      -6,
      9650,
      43,
      -3,
      9650,
      45,
      -3,
      9650,
      47,
      2,
      9650,
      49,
      -3,
      9650,
      61,
      -4,
      9650,
      63,
      -5,
      9650,
      64,
      -3,
      9650,
      92,
      -5,
      9650,
      94,
      -6,
      9650,
      126,
      -3,
      9650,
      8216,
      -10,
      9650,
      8217,
      -8,
      9650,
      8220,
      -10,
      9650,
      8221,
      -8,
      9650,
      176,
      -6,
      9650,
      215,
      -3,
      9650,
      183,
      -3,
      9650,
      8226,
      -3,
      9650,
      8249,
      -3,
      9650,
      8250,
      -3,
      9650,
      9679,
      -3,
      9650,
      9650,
      1
    ]
  },
  "Inter|regular|normal": {
    emSize: 80,
    commonLineHeight: 97,
    capTop: 20,
    advances: [
      23,
      23,
      37,
      51,
      51,
      79,
      52,
      24,
      29,
      29,
      40,
      53,
      23,
      37,
      23,
      29,
      50,
      33,
      49,
      49,
      52,
      47,
      50,
      45,
      49,
      50,
      23,
      24,
      53,
      53,
      53,
      41,
      77,
      55,
      52,
      58,
      58,
      48,
      47,
      60,
      59,
      21,
      46,
      54,
      45,
      72,
      60,
      61,
      51,
      61,
      51,
      51,
      52,
      60,
      55,
      79,
      55,
      54,
      50,
      29,
      29,
      29,
      38,
      36,
      26,
      45,
      49,
      46,
      49,
      47,
      30,
      49,
      47,
      19,
      19,
      44,
      19,
      70,
      47,
      48,
      49,
      49,
      30,
      42,
      26,
      47,
      45,
      65,
      44,
      45,
      44,
      34,
      27,
      34,
      53
    ],
    extraAdvances: [
      162,
      46,
      163,
      49,
      165,
      44,
      176,
      36,
      183,
      23,
      215,
      53,
      8211,
      40,
      8212,
      80,
      8216,
      21,
      8217,
      21,
      8220,
      35,
      8221,
      35,
      8226,
      45,
      8230,
      69,
      8249,
      31,
      8250,
      31,
      8364,
      53,
      8377,
      43,
      8593,
      67,
      8595,
      67,
      8635,
      76,
      9632,
      73,
      9633,
      73,
      9650,
      81,
      9654,
      73,
      9664,
      73,
      9679,
      73,
      9733,
      84
    ],
    kernings: [
      34,
      38,
      -3,
      34,
      44,
      -7,
      34,
      46,
      -7,
      34,
      52,
      -5,
      38,
      34,
      -3,
      38,
      39,
      -3,
      38,
      92,
      -5,
      39,
      38,
      -3,
      39,
      44,
      -7,
      39,
      46,
      -7,
      39,
      52,
      -5,
      42,
      38,
      -3,
      42,
      44,
      -11,
      42,
      46,
      -11,
      42,
      52,
      -4,
      42,
      64,
      -1,
      42,
      95,
      -5,
      43,
      50,
      -3,
      43,
      51,
      -1,
      43,
      55,
      -2,
      43,
      92,
      -4,
      44,
      34,
      -7,
      44,
      39,
      -7,
      44,
      48,
      -2,
      44,
      49,
      -7,
      44,
      51,
      -2,
      44,
      53,
      -1,
      44,
      54,
      -2,
      44,
      55,
      -1,
      44,
      56,
      -2,
      44,
      57,
      -1,
      44,
      63,
      -7,
      44,
      64,
      -4,
      45,
      50,
      -3,
      45,
      51,
      -1,
      45,
      55,
      -2,
      45,
      92,
      -4,
      46,
      34,
      -7,
      46,
      39,
      -7,
      46,
      48,
      -2,
      46,
      49,
      -7,
      46,
      51,
      -2,
      46,
      53,
      -1,
      46,
      54,
      -2,
      46,
      55,
      -1,
      46,
      56,
      -2,
      46,
      57,
      -1,
      46,
      63,
      -7,
      46,
      64,
      -4,
      47,
      44,
      -3,
      47,
      46,
      -3,
      48,
      44,
      -2,
      48,
      46,
      -2,
      48,
      55,
      -2,
      48,
      92,
      -1,
      48,
      95,
      -4,
      50,
      52,
      -1,
      51,
      42,
      -1,
      51,
      44,
      -2,
      51,
      46,
      -2,
      51,
      94,
      -1,
      52,
      42,
      -2,
      52,
      44,
      -3,
      52,
      46,
      -3,
      52,
      49,
      -2,
      52,
      94,
      -2,
      53,
      44,
      -2,
      53,
      46,
      -2,
      54,
      44,
      -3,
      54,
      46,
      -3,
      54,
      95,
      -4,
      55,
      35,
      -5,
      55,
      38,
      -4,
      55,
      44,
      -10,
      55,
      46,
      -10,
      55,
      48,
      -1,
      55,
      51,
      -1,
      55,
      52,
      -5,
      55,
      53,
      -1,
      55,
      54,
      -1,
      55,
      55,
      2,
      55,
      56,
      -1,
      55,
      57,
      -1,
      55,
      58,
      -3,
      55,
      59,
      -3,
      55,
      60,
      -7,
      55,
      95,
      -13,
      56,
      42,
      -1,
      56,
      44,
      -2,
      56,
      46,
      -2,
      56,
      94,
      -1,
      57,
      44,
      -2,
      57,
      46,
      -2,
      57,
      55,
      -2,
      57,
      92,
      -1,
      57,
      95,
      -4,
      58,
      92,
      -5,
      59,
      92,
      -5,
      61,
      92,
      -5,
      62,
      55,
      -6,
      62,
      92,
      -6,
      64,
      44,
      -4,
      64,
      46,
      -4,
      64,
      47,
      -3,
      64,
      92,
      -3,
      64,
      95,
      -3,
      92,
      34,
      -6,
      92,
      39,
      -6,
      92,
      42,
      -6,
      92,
      43,
      -3,
      92,
      45,
      -3,
      92,
      47,
      2,
      92,
      49,
      -3,
      92,
      61,
      -4,
      92,
      63,
      -5,
      92,
      64,
      -3,
      92,
      92,
      -4,
      92,
      94,
      -6,
      92,
      126,
      -3,
      94,
      38,
      -3,
      94,
      44,
      -11,
      94,
      46,
      -11,
      94,
      52,
      -4,
      94,
      64,
      -1,
      94,
      95,
      -5,
      95,
      42,
      -5,
      95,
      48,
      -4,
      95,
      49,
      -9,
      95,
      51,
      -4,
      95,
      52,
      -5,
      95,
      53,
      -4,
      95,
      54,
      -4,
      95,
      56,
      -4,
      95,
      57,
      -4,
      95,
      64,
      -3,
      95,
      92,
      -6,
      95,
      94,
      -5,
      95,
      124,
      3,
      126,
      50,
      -3,
      126,
      51,
      -1,
      126,
      55,
      -2,
      126,
      92,
      -4,
      34,
      8230,
      -7,
      37,
      8216,
      -5,
      37,
      8217,
      -5,
      37,
      8220,
      -5,
      37,
      8221,
      -5,
      38,
      8216,
      -7,
      38,
      8220,
      -7,
      39,
      8230,
      -7,
      41,
      8216,
      -3,
      41,
      8220,
      -3,
      42,
      8230,
      -11,
      43,
      8216,
      -5,
      43,
      8220,
      -5,
      44,
      8217,
      -5,
      44,
      8221,
      -5,
      45,
      8216,
      -5,
      45,
      8220,
      -5,
      46,
      8217,
      -5,
      46,
      8221,
      -5,
      47,
      8230,
      -3,
      48,
      8216,
      -4,
      48,
      8220,
      -4,
      48,
      8230,
      -2,
      51,
      8230,
      -2,
      52,
      8230,
      -3,
      53,
      8230,
      -2,
      54,
      8230,
      -3,
      55,
      8230,
      -10,
      56,
      8230,
      -2,
      57,
      8216,
      -4,
      57,
      8220,
      -4,
      57,
      8230,
      -2,
      58,
      8216,
      -4,
      58,
      8220,
      -4,
      59,
      8216,
      -4,
      59,
      8220,
      -4,
      61,
      8216,
      -5,
      61,
      8220,
      -5,
      62,
      8216,
      -8,
      62,
      8220,
      -8,
      64,
      8216,
      -3,
      64,
      8220,
      -3,
      64,
      8230,
      -4,
      92,
      8216,
      -3,
      92,
      8217,
      -5,
      92,
      8220,
      -3,
      92,
      8221,
      -5,
      93,
      8216,
      -3,
      93,
      8220,
      -3,
      94,
      8230,
      -11,
      95,
      8216,
      -3,
      95,
      8220,
      -3,
      125,
      8216,
      -3,
      125,
      8220,
      -3,
      126,
      8216,
      -5,
      126,
      8220,
      -5,
      8216,
      38,
      -5,
      8216,
      44,
      -7,
      8216,
      46,
      -7,
      8216,
      47,
      -8,
      8216,
      52,
      -5,
      8216,
      8230,
      -7,
      8217,
      35,
      -10,
      8217,
      38,
      -5,
      8217,
      43,
      -5,
      8217,
      44,
      -8,
      8217,
      45,
      -5,
      8217,
      46,
      -8,
      8217,
      47,
      -11,
      8217,
      48,
      -4,
      8217,
      52,
      -8,
      8217,
      54,
      -4,
      8217,
      55,
      -5,
      8217,
      56,
      -3,
      8217,
      58,
      -5,
      8217,
      59,
      -5,
      8217,
      60,
      -8,
      8217,
      61,
      -5,
      8217,
      64,
      -5,
      8217,
      95,
      -3,
      8217,
      126,
      -4,
      8217,
      8230,
      -8,
      8220,
      38,
      -5,
      8220,
      44,
      -7,
      8220,
      46,
      -7,
      8220,
      47,
      -8,
      8220,
      52,
      -5,
      8220,
      8230,
      -7,
      8221,
      35,
      -10,
      8221,
      38,
      -5,
      8221,
      43,
      -5,
      8221,
      44,
      -8,
      8221,
      45,
      -5,
      8221,
      46,
      -8,
      8221,
      47,
      -11,
      8221,
      48,
      -4,
      8221,
      52,
      -8,
      8221,
      54,
      -4,
      8221,
      55,
      -5,
      8221,
      56,
      -3,
      8221,
      58,
      -5,
      8221,
      59,
      -5,
      8221,
      60,
      -8,
      8221,
      61,
      -5,
      8221,
      64,
      -5,
      8221,
      95,
      -3,
      8221,
      126,
      -4,
      8221,
      8230,
      -8,
      8230,
      34,
      -7,
      8230,
      39,
      -7,
      8230,
      48,
      -2,
      8230,
      49,
      -7,
      8230,
      51,
      -2,
      8230,
      53,
      -1,
      8230,
      54,
      -2,
      8230,
      55,
      -1,
      8230,
      56,
      -2,
      8230,
      57,
      -1,
      8230,
      63,
      -7,
      8230,
      64,
      -4,
      8230,
      8217,
      -5,
      8230,
      8221,
      -5,
      34,
      162,
      -1,
      39,
      162,
      -1,
      40,
      162,
      -1,
      51,
      176,
      -1,
      52,
      176,
      -2,
      55,
      162,
      -4,
      56,
      176,
      -1,
      91,
      162,
      -1,
      92,
      176,
      -6,
      92,
      215,
      -3,
      92,
      183,
      -3,
      95,
      176,
      -5,
      123,
      162,
      -1,
      8216,
      162,
      -3,
      8217,
      162,
      -5,
      8217,
      183,
      -5,
      8220,
      162,
      -3,
      8221,
      162,
      -5,
      8221,
      183,
      -5,
      162,
      34,
      -1,
      162,
      39,
      -1,
      162,
      41,
      -1,
      162,
      49,
      -3,
      162,
      92,
      -4,
      162,
      93,
      -1,
      162,
      125,
      -1,
      162,
      8216,
      -5,
      162,
      8217,
      -2,
      162,
      8220,
      -5,
      162,
      8221,
      -2,
      176,
      38,
      -3,
      176,
      44,
      -11,
      176,
      46,
      -11,
      176,
      52,
      -4,
      176,
      64,
      -1,
      176,
      95,
      -5,
      176,
      8230,
      -11,
      215,
      92,
      -3,
      183,
      50,
      -3,
      183,
      51,
      -1,
      183,
      55,
      -2,
      183,
      92,
      -3,
      183,
      8216,
      -5,
      183,
      8220,
      -5,
      34,
      9650,
      -6,
      39,
      9650,
      -6,
      42,
      9679,
      -1,
      42,
      9650,
      -6,
      43,
      9650,
      -3,
      44,
      9679,
      -4,
      45,
      9650,
      -3,
      46,
      9679,
      -4,
      47,
      9650,
      -2,
      51,
      8249,
      -3,
      55,
      8249,
      -5,
      55,
      9650,
      -9,
      56,
      8249,
      -3,
      61,
      9650,
      -4,
      63,
      9650,
      -5,
      64,
      9650,
      -3,
      92,
      8226,
      -3,
      92,
      8249,
      -3,
      92,
      8250,
      -3,
      92,
      9679,
      -3,
      92,
      9650,
      1,
      94,
      9679,
      -1,
      94,
      9650,
      -6,
      95,
      9679,
      -3,
      95,
      9632,
      3,
      95,
      9633,
      3,
      126,
      9650,
      -3,
      8216,
      9650,
      -8,
      8217,
      8249,
      -7,
      8217,
      9679,
      -5,
      8217,
      9650,
      -11,
      8220,
      9650,
      -8,
      8221,
      8249,
      -7,
      8221,
      9679,
      -5,
      8221,
      9650,
      -11,
      8230,
      9679,
      -4,
      162,
      9650,
      -3,
      176,
      9679,
      -1,
      176,
      9650,
      -6,
      215,
      9650,
      -3,
      183,
      9650,
      -3,
      8226,
      92,
      -3,
      8226,
      9650,
      -3,
      8249,
      9650,
      -3,
      8250,
      49,
      -3,
      8250,
      50,
      -4,
      8250,
      51,
      -4,
      8250,
      55,
      -4,
      8250,
      56,
      -3,
      8250,
      92,
      -5,
      8250,
      8216,
      -7,
      8250,
      8220,
      -7,
      8250,
      9650,
      -3,
      9679,
      44,
      -4,
      9679,
      46,
      -4,
      9679,
      47,
      -3,
      9679,
      92,
      -3,
      9679,
      95,
      -3,
      9679,
      8216,
      -3,
      9679,
      8220,
      -3,
      9679,
      8230,
      -4,
      9679,
      9650,
      -3,
      9650,
      34,
      -6,
      9650,
      39,
      -6,
      9650,
      42,
      -6,
      9650,
      43,
      -3,
      9650,
      45,
      -3,
      9650,
      47,
      2,
      9650,
      49,
      -3,
      9650,
      61,
      -4,
      9650,
      63,
      -5,
      9650,
      64,
      -3,
      9650,
      92,
      -5,
      9650,
      94,
      -6,
      9650,
      126,
      -3,
      9650,
      8216,
      -10,
      9650,
      8217,
      -8,
      9650,
      8220,
      -10,
      9650,
      8221,
      -8,
      9650,
      176,
      -6,
      9650,
      215,
      -3,
      9650,
      183,
      -3,
      9650,
      8226,
      -3,
      9650,
      8249,
      -3,
      9650,
      8250,
      -3,
      9650,
      9679,
      -3,
      9650,
      9650,
      1
    ]
  },
  "JetBrains Mono|bold|italic": {
    emSize: 80,
    commonLineHeight: 106,
    capTop: 24,
    advances: [
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48
    ],
    extraAdvances: [
      162,
      48,
      163,
      48,
      165,
      48,
      176,
      48,
      183,
      48,
      215,
      48,
      8211,
      48,
      8212,
      48,
      8216,
      48,
      8217,
      48,
      8220,
      48,
      8221,
      48,
      8230,
      48,
      8364,
      48,
      8377,
      48
    ],
    kernings: []
  },
  "JetBrains Mono|bold|normal": {
    emSize: 80,
    commonLineHeight: 106,
    capTop: 24,
    advances: [
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48
    ],
    extraAdvances: [
      162,
      48,
      163,
      48,
      165,
      48,
      176,
      48,
      183,
      48,
      215,
      48,
      8211,
      48,
      8212,
      48,
      8216,
      48,
      8217,
      48,
      8220,
      48,
      8221,
      48,
      8230,
      48,
      8364,
      48,
      8377,
      48
    ],
    kernings: []
  },
  "JetBrains Mono|regular|italic": {
    emSize: 80,
    commonLineHeight: 106,
    capTop: 24,
    advances: [
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48
    ],
    extraAdvances: [
      162,
      48,
      163,
      48,
      165,
      48,
      176,
      48,
      183,
      48,
      215,
      48,
      8211,
      48,
      8212,
      48,
      8216,
      48,
      8217,
      48,
      8220,
      48,
      8221,
      48,
      8230,
      48,
      8364,
      48,
      8377,
      48
    ],
    kernings: []
  },
  "JetBrains Mono|regular|normal": {
    emSize: 80,
    commonLineHeight: 106,
    capTop: 24,
    advances: [
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48
    ],
    extraAdvances: [
      162,
      48,
      163,
      48,
      165,
      48,
      176,
      48,
      183,
      48,
      215,
      48,
      8211,
      48,
      8212,
      48,
      8216,
      48,
      8217,
      48,
      8220,
      48,
      8221,
      48,
      8230,
      48,
      8364,
      48,
      8377,
      48
    ],
    kernings: []
  },
  "Oswald|bold|normal": {
    emSize: 80,
    commonLineHeight: 119,
    capTop: 30,
    advances: [
      20,
      21,
      29,
      43,
      39,
      80,
      46,
      14,
      27,
      26,
      34,
      36,
      19,
      26,
      20,
      34,
      44,
      31,
      41,
      41,
      42,
      41,
      43,
      35,
      42,
      43,
      22,
      23,
      32,
      35,
      32,
      39,
      76,
      44,
      47,
      45,
      47,
      36,
      35,
      47,
      49,
      24,
      28,
      45,
      35,
      56,
      45,
      47,
      46,
      47,
      48,
      41,
      36,
      47,
      42,
      56,
      41,
      39,
      35,
      27,
      34,
      26,
      38,
      29,
      25,
      37,
      40,
      37,
      40,
      38,
      26,
      40,
      41,
      21,
      22,
      41,
      22,
      60,
      41,
      39,
      40,
      40,
      31,
      34,
      28,
      40,
      34,
      48,
      35,
      36,
      31,
      30,
      21,
      30,
      38
    ],
    extraAdvances: [
      162,
      37,
      163,
      39,
      165,
      38,
      176,
      43,
      183,
      18,
      215,
      39,
      8211,
      45,
      8212,
      84,
      8216,
      16,
      8217,
      16,
      8220,
      33,
      8221,
      32,
      8230,
      53,
      8364,
      45,
      8377,
      46
    ],
    kernings: [
      34,
      65,
      -5,
      34,
      67,
      -1,
      34,
      71,
      -1,
      34,
      74,
      -3,
      34,
      79,
      -1,
      34,
      81,
      -1,
      34,
      97,
      -1,
      34,
      99,
      -4,
      34,
      100,
      -4,
      34,
      101,
      -4,
      34,
      103,
      -4,
      34,
      111,
      -4,
      34,
      113,
      -4,
      34,
      115,
      -3,
      38,
      84,
      -3,
      39,
      65,
      -5,
      39,
      67,
      -1,
      39,
      71,
      -1,
      39,
      74,
      -3,
      39,
      79,
      -1,
      39,
      81,
      -1,
      39,
      97,
      -1,
      39,
      99,
      -4,
      39,
      100,
      -4,
      39,
      101,
      -4,
      39,
      103,
      -4,
      39,
      111,
      -4,
      39,
      113,
      -4,
      39,
      115,
      -3,
      42,
      74,
      -2,
      42,
      88,
      -1,
      44,
      66,
      -1,
      44,
      67,
      -1,
      44,
      68,
      -1,
      44,
      69,
      -1,
      44,
      70,
      -1,
      44,
      71,
      -1,
      44,
      72,
      -1,
      44,
      73,
      -1,
      44,
      75,
      -1,
      44,
      76,
      -1,
      44,
      78,
      -1,
      44,
      79,
      -1,
      44,
      80,
      -1,
      44,
      81,
      -1,
      44,
      82,
      -1,
      44,
      84,
      -5,
      44,
      85,
      -1,
      44,
      86,
      -4,
      44,
      87,
      -3,
      44,
      89,
      -4,
      44,
      116,
      -2,
      44,
      119,
      -1,
      44,
      121,
      -2,
      45,
      84,
      -3,
      45,
      86,
      -2,
      45,
      87,
      -1,
      45,
      88,
      -1,
      45,
      89,
      -3,
      46,
      66,
      -1,
      46,
      67,
      -1,
      46,
      68,
      -1,
      46,
      69,
      -1,
      46,
      70,
      -1,
      46,
      71,
      -1,
      46,
      72,
      -1,
      46,
      73,
      -1,
      46,
      75,
      -1,
      46,
      76,
      -1,
      46,
      78,
      -1,
      46,
      79,
      -1,
      46,
      80,
      -1,
      46,
      81,
      -1,
      46,
      82,
      -1,
      46,
      84,
      -5,
      46,
      85,
      -1,
      46,
      86,
      -4,
      46,
      87,
      -3,
      46,
      89,
      -4,
      46,
      116,
      -2,
      46,
      119,
      -1,
      46,
      121,
      -2,
      47,
      67,
      -1,
      47,
      71,
      -1,
      47,
      79,
      -1,
      47,
      81,
      -1,
      47,
      83,
      -2,
      47,
      99,
      -4,
      47,
      100,
      -4,
      47,
      101,
      -4,
      47,
      111,
      -4,
      47,
      113,
      -4,
      48,
      88,
      -1,
      48,
      89,
      -1,
      50,
      52,
      -1,
      52,
      49,
      -1,
      52,
      55,
      -1,
      53,
      55,
      -1,
      54,
      49,
      -1,
      54,
      50,
      -1,
      54,
      55,
      -1,
      54,
      57,
      -1,
      54,
      89,
      -1,
      55,
      52,
      -2,
      56,
      55,
      -1,
      56,
      89,
      -1,
      57,
      55,
      -1,
      58,
      84,
      -5,
      58,
      86,
      -1,
      58,
      87,
      -2,
      58,
      89,
      -4,
      59,
      84,
      -5,
      59,
      86,
      -1,
      59,
      87,
      -2,
      59,
      89,
      -4,
      65,
      34,
      -5,
      65,
      39,
      -5,
      65,
      67,
      -1,
      65,
      71,
      -1,
      65,
      79,
      -1,
      65,
      83,
      -1,
      65,
      84,
      -4,
      65,
      85,
      -1,
      65,
      86,
      -3,
      65,
      87,
      -2,
      65,
      89,
      -4,
      65,
      102,
      -1,
      65,
      116,
      -1,
      65,
      119,
      -2,
      65,
      121,
      -2,
      66,
      34,
      -3,
      66,
      39,
      -3,
      66,
      44,
      -1,
      66,
      46,
      -1,
      66,
      84,
      -2,
      66,
      86,
      -2,
      66,
      88,
      -2,
      66,
      89,
      -2,
      67,
      34,
      -1,
      67,
      39,
      -1,
      67,
      44,
      -1,
      67,
      46,
      -1,
      67,
      88,
      -1,
      68,
      34,
      -2,
      68,
      39,
      -2,
      68,
      44,
      -1,
      68,
      46,
      -1,
      68,
      55,
      -1,
      68,
      65,
      -1,
      68,
      74,
      -1,
      68,
      84,
      -1,
      68,
      86,
      -1,
      68,
      88,
      -1,
      68,
      89,
      -1,
      68,
      90,
      -1,
      68,
      92,
      -3,
      70,
      34,
      -1,
      70,
      39,
      -1,
      70,
      44,
      -7,
      70,
      46,
      -7,
      70,
      58,
      -1,
      70,
      59,
      -1,
      70,
      65,
      -3,
      70,
      74,
      -2,
      70,
      97,
      -2,
      70,
      99,
      -1,
      70,
      100,
      -1,
      70,
      101,
      -1,
      70,
      111,
      -1,
      70,
      113,
      -1,
      70,
      115,
      -1,
      70,
      122,
      -1,
      71,
      34,
      -2,
      71,
      39,
      -2,
      71,
      84,
      -1,
      71,
      86,
      -1,
      71,
      89,
      -1,
      74,
      44,
      -3,
      74,
      46,
      -3,
      75,
      45,
      -2,
      75,
      67,
      -2,
      75,
      71,
      -2,
      75,
      79,
      -2,
      75,
      81,
      -2,
      75,
      83,
      -2,
      75,
      99,
      -1,
      75,
      100,
      -1,
      75,
      101,
      -1,
      75,
      111,
      -1,
      75,
      113,
      -1,
      75,
      116,
      -1,
      75,
      117,
      -1,
      75,
      119,
      -2,
      75,
      121,
      -3,
      76,
      34,
      1,
      76,
      39,
      1,
      76,
      42,
      -9,
      76,
      45,
      -3,
      76,
      49,
      -3,
      76,
      55,
      -1,
      76,
      67,
      -1,
      76,
      71,
      -1,
      76,
      79,
      -1,
      76,
      81,
      -1,
      76,
      83,
      -1,
      76,
      84,
      -6,
      76,
      85,
      -1,
      76,
      86,
      -6,
      76,
      87,
      -4,
      76,
      89,
      -7,
      76,
      92,
      -7,
      76,
      102,
      -1,
      76,
      116,
      -2,
      76,
      119,
      -2,
      76,
      121,
      -5,
      77,
      83,
      -1,
      77,
      86,
      -1,
      77,
      89,
      -1,
      79,
      34,
      -2,
      79,
      39,
      -2,
      79,
      44,
      -1,
      79,
      46,
      -1,
      79,
      55,
      -1,
      79,
      65,
      -1,
      79,
      74,
      -1,
      79,
      84,
      -1,
      79,
      86,
      -1,
      79,
      88,
      -1,
      79,
      89,
      -1,
      79,
      90,
      -1,
      79,
      92,
      -3,
      80,
      44,
      -6,
      80,
      45,
      -4,
      80,
      46,
      -7,
      80,
      47,
      -6,
      80,
      55,
      -1,
      80,
      65,
      -4,
      80,
      74,
      -2,
      80,
      83,
      -1,
      80,
      88,
      -1,
      80,
      92,
      -2,
      80,
      97,
      -3,
      80,
      99,
      -2,
      80,
      100,
      -2,
      80,
      101,
      -2,
      80,
      103,
      -2,
      80,
      111,
      -2,
      80,
      115,
      -2,
      80,
      120,
      -1,
      80,
      122,
      -1,
      81,
      34,
      -2,
      81,
      39,
      -2,
      81,
      44,
      -1,
      81,
      46,
      -1,
      81,
      55,
      -1,
      81,
      65,
      -1,
      81,
      74,
      -1,
      81,
      84,
      -1,
      81,
      86,
      -1,
      81,
      88,
      -1,
      81,
      89,
      -1,
      81,
      90,
      -1,
      81,
      92,
      -3,
      82,
      67,
      -1,
      82,
      71,
      -1,
      82,
      79,
      -1,
      82,
      81,
      -1,
      82,
      84,
      -1,
      82,
      86,
      -1,
      82,
      89,
      -2,
      82,
      92,
      -2,
      82,
      97,
      -1,
      82,
      99,
      -2,
      82,
      100,
      -2,
      82,
      101,
      -2,
      82,
      111,
      -2,
      82,
      113,
      -2,
      82,
      121,
      -1,
      82,
      122,
      -1,
      83,
      47,
      -1,
      83,
      65,
      -1,
      83,
      77,
      -1,
      83,
      83,
      -1,
      83,
      86,
      -1,
      83,
      88,
      -1,
      83,
      89,
      -1,
      83,
      92,
      -3,
      84,
      38,
      -1,
      84,
      44,
      -5,
      84,
      45,
      -3,
      84,
      46,
      -5,
      84,
      47,
      -4,
      84,
      58,
      -5,
      84,
      59,
      -5,
      84,
      65,
      -4,
      84,
      67,
      -1,
      84,
      71,
      -1,
      84,
      74,
      -2,
      84,
      79,
      -1,
      84,
      81,
      -1,
      84,
      97,
      -6,
      84,
      99,
      -4,
      84,
      100,
      -4,
      84,
      101,
      -4,
      84,
      102,
      -2,
      84,
      103,
      -4,
      84,
      109,
      -4,
      84,
      110,
      -4,
      84,
      111,
      -4,
      84,
      112,
      -4,
      84,
      114,
      -4,
      84,
      115,
      -5,
      84,
      116,
      -1,
      84,
      117,
      -3,
      84,
      119,
      -4,
      84,
      120,
      -3,
      84,
      121,
      -4,
      84,
      122,
      -3,
      85,
      44,
      -1,
      85,
      46,
      -1,
      85,
      47,
      -2,
      85,
      65,
      -1,
      86,
      44,
      -5,
      86,
      45,
      -2,
      86,
      46,
      -5,
      86,
      58,
      -2,
      86,
      59,
      -2,
      86,
      65,
      -3,
      86,
      67,
      -1,
      86,
      71,
      -1,
      86,
      77,
      -1,
      86,
      79,
      -1,
      86,
      81,
      -1,
      86,
      83,
      -1,
      86,
      97,
      -4,
      86,
      99,
      -3,
      86,
      100,
      -3,
      86,
      101,
      -3,
      86,
      103,
      -4,
      86,
      109,
      -2,
      86,
      110,
      -2,
      86,
      111,
      -3,
      86,
      112,
      -2,
      86,
      113,
      -2,
      86,
      114,
      -2,
      86,
      115,
      -2,
      86,
      117,
      -2,
      86,
      118,
      -1,
      86,
      119,
      -2,
      86,
      120,
      -2,
      86,
      121,
      -1,
      86,
      122,
      -3,
      87,
      44,
      -3,
      87,
      45,
      -1,
      87,
      46,
      -3,
      87,
      47,
      -3,
      87,
      58,
      -2,
      87,
      59,
      -2,
      87,
      65,
      -2,
      87,
      92,
      -1,
      87,
      97,
      -2,
      87,
      99,
      -1,
      87,
      100,
      -1,
      87,
      101,
      -1,
      87,
      102,
      -1,
      87,
      103,
      -2,
      87,
      109,
      -1,
      87,
      110,
      -1,
      87,
      111,
      -1,
      87,
      112,
      -1,
      87,
      114,
      -1,
      88,
      42,
      -2,
      88,
      45,
      -1,
      88,
      48,
      -1,
      88,
      67,
      -1,
      88,
      71,
      -1,
      88,
      79,
      -1,
      88,
      81,
      -1,
      88,
      83,
      -1,
      88,
      92,
      -1,
      88,
      99,
      -1,
      88,
      100,
      -1,
      88,
      101,
      -1,
      88,
      111,
      -1,
      88,
      113,
      -1,
      88,
      115,
      -1,
      88,
      118,
      -2,
      88,
      119,
      -2,
      88,
      121,
      -2,
      89,
      44,
      -6,
      89,
      45,
      -3,
      89,
      46,
      -6,
      89,
      47,
      -3,
      89,
      48,
      -1,
      89,
      52,
      -2,
      89,
      54,
      -1,
      89,
      56,
      -1,
      89,
      58,
      -5,
      89,
      59,
      -5,
      89,
      65,
      -4,
      89,
      67,
      -1,
      89,
      71,
      -1,
      89,
      77,
      -1,
      89,
      79,
      -1,
      89,
      81,
      -1,
      89,
      83,
      -1,
      89,
      97,
      -5,
      89,
      99,
      -5,
      89,
      100,
      -5,
      89,
      101,
      -5,
      89,
      102,
      -3,
      89,
      103,
      -5,
      89,
      109,
      -5,
      89,
      110,
      -5,
      89,
      111,
      -5,
      89,
      112,
      -4,
      89,
      113,
      -1,
      89,
      114,
      -5,
      89,
      115,
      -4,
      89,
      117,
      -4,
      89,
      119,
      -3,
      89,
      120,
      -3,
      89,
      121,
      -2,
      89,
      122,
      -3,
      90,
      67,
      -1,
      90,
      71,
      -1,
      90,
      79,
      -1,
      90,
      81,
      -1,
      90,
      97,
      -1,
      90,
      99,
      -1,
      90,
      100,
      -1,
      90,
      101,
      -1,
      90,
      111,
      -1,
      90,
      113,
      -1,
      92,
      67,
      -1,
      92,
      71,
      -1,
      92,
      79,
      -1,
      92,
      81,
      -1,
      92,
      83,
      -2,
      92,
      84,
      -4,
      92,
      85,
      -2,
      92,
      87,
      -3,
      92,
      89,
      -4,
      97,
      34,
      -3,
      97,
      39,
      -3,
      97,
      84,
      -4,
      97,
      86,
      -3,
      97,
      87,
      -1,
      97,
      89,
      -5,
      98,
      34,
      -4,
      98,
      39,
      -4,
      98,
      84,
      -4,
      98,
      86,
      -3,
      98,
      87,
      -1,
      98,
      88,
      -1,
      98,
      89,
      -5,
      99,
      34,
      -3,
      99,
      39,
      -3,
      99,
      47,
      -1,
      99,
      84,
      -3,
      99,
      86,
      -2,
      99,
      89,
      -4,
      100,
      84,
      4,
      100,
      86,
      2,
      100,
      87,
      2,
      100,
      89,
      2,
      101,
      84,
      -4,
      101,
      86,
      -2,
      101,
      89,
      -5,
      101,
      120,
      -1,
      102,
      46,
      -2,
      102,
      58,
      -1,
      102,
      59,
      -1,
      102,
      65,
      -1,
      102,
      97,
      -1,
      102,
      102,
      -3,
      103,
      84,
      -1,
      103,
      89,
      -1,
      103,
      97,
      -1,
      103,
      106,
      2,
      103,
      116,
      1,
      103,
      119,
      1,
      103,
      121,
      1,
      104,
      34,
      -4,
      104,
      39,
      -4,
      104,
      84,
      -4,
      104,
      86,
      -2,
      104,
      87,
      -1,
      104,
      89,
      -5,
      107,
      34,
      -1,
      107,
      39,
      -1,
      107,
      84,
      -3,
      107,
      86,
      -1,
      107,
      87,
      -1,
      107,
      89,
      -3,
      107,
      99,
      -1,
      107,
      100,
      -1,
      107,
      101,
      -1,
      107,
      103,
      -1,
      107,
      111,
      -1,
      107,
      113,
      -1,
      107,
      115,
      -1,
      108,
      84,
      2,
      108,
      86,
      1,
      108,
      87,
      1,
      108,
      89,
      2,
      109,
      34,
      -4,
      109,
      39,
      -4,
      109,
      84,
      -4,
      109,
      86,
      -2,
      109,
      87,
      -1,
      109,
      89,
      -5,
      110,
      34,
      -4,
      110,
      39,
      -4,
      110,
      84,
      -4,
      110,
      86,
      -2,
      110,
      87,
      -1,
      110,
      89,
      -5,
      111,
      34,
      -4,
      111,
      39,
      -4,
      111,
      84,
      -4,
      111,
      86,
      -3,
      111,
      87,
      -1,
      111,
      88,
      -1,
      111,
      89,
      -5,
      112,
      34,
      -4,
      112,
      39,
      -4,
      112,
      84,
      -4,
      112,
      86,
      -3,
      112,
      87,
      -1,
      112,
      88,
      -1,
      112,
      89,
      -5,
      113,
      34,
      -1,
      113,
      39,
      -1,
      113,
      84,
      -4,
      113,
      89,
      -3,
      114,
      44,
      -8,
      114,
      46,
      -8,
      114,
      65,
      -2,
      114,
      74,
      -2,
      114,
      84,
      -3,
      114,
      88,
      -2,
      114,
      89,
      -2,
      114,
      90,
      -2,
      114,
      97,
      -1,
      114,
      103,
      -1,
      114,
      113,
      -2,
      115,
      34,
      -3,
      115,
      39,
      -3,
      115,
      84,
      -4,
      115,
      86,
      -2,
      115,
      89,
      -4,
      116,
      34,
      -3,
      116,
      39,
      -3,
      116,
      86,
      -1,
      116,
      89,
      -2,
      116,
      103,
      -1,
      117,
      34,
      -2,
      117,
      39,
      -2,
      117,
      84,
      -4,
      117,
      86,
      -2,
      117,
      87,
      -1,
      117,
      89,
      -4,
      118,
      44,
      -3,
      118,
      46,
      -3,
      118,
      65,
      -2,
      118,
      74,
      -2,
      118,
      84,
      -4,
      118,
      86,
      -2,
      118,
      88,
      -2,
      118,
      89,
      -3,
      118,
      90,
      -2,
      118,
      97,
      -1,
      118,
      103,
      -1,
      119,
      44,
      -2,
      119,
      46,
      -2,
      119,
      65,
      -1,
      119,
      74,
      -2,
      119,
      84,
      -4,
      119,
      86,
      -2,
      119,
      88,
      -2,
      119,
      89,
      -3,
      119,
      90,
      -1,
      119,
      97,
      -1,
      119,
      103,
      -1,
      120,
      84,
      -3,
      120,
      86,
      -2,
      120,
      89,
      -3,
      120,
      99,
      -1,
      120,
      100,
      -1,
      120,
      101,
      -1,
      120,
      111,
      -1,
      120,
      113,
      -1,
      121,
      44,
      -3,
      121,
      46,
      -3,
      121,
      65,
      -2,
      121,
      74,
      -2,
      121,
      84,
      -4,
      121,
      86,
      -2,
      121,
      88,
      -2,
      121,
      89,
      -3,
      121,
      90,
      -2,
      121,
      97,
      -1,
      121,
      103,
      -1,
      122,
      84,
      -3,
      122,
      86,
      -2,
      122,
      89,
      -3,
      122,
      103,
      -1,
      65,
      8216,
      -5,
      65,
      8217,
      -4,
      65,
      8220,
      -5,
      65,
      8221,
      -4,
      66,
      8216,
      -3,
      66,
      8217,
      -3,
      66,
      8220,
      -3,
      66,
      8221,
      -3,
      67,
      8216,
      -1,
      67,
      8217,
      -1,
      67,
      8220,
      -1,
      67,
      8221,
      -1,
      68,
      8216,
      -2,
      68,
      8217,
      -2,
      68,
      8220,
      -2,
      68,
      8221,
      -2,
      70,
      8216,
      -1,
      70,
      8217,
      -1,
      70,
      8220,
      -1,
      70,
      8221,
      -1,
      71,
      8216,
      -2,
      71,
      8217,
      -2,
      71,
      8220,
      -2,
      71,
      8221,
      -2,
      76,
      8216,
      -9,
      76,
      8217,
      -1,
      76,
      8220,
      -9,
      76,
      8221,
      -2,
      79,
      8216,
      -2,
      79,
      8217,
      -2,
      79,
      8220,
      -2,
      79,
      8221,
      -2,
      81,
      8216,
      -2,
      81,
      8217,
      -2,
      81,
      8220,
      -2,
      81,
      8221,
      -2,
      97,
      8216,
      -3,
      97,
      8217,
      -3,
      97,
      8220,
      -3,
      97,
      8221,
      -3,
      98,
      8216,
      -4,
      98,
      8217,
      -4,
      98,
      8220,
      -4,
      98,
      8221,
      -4,
      99,
      8216,
      -3,
      99,
      8217,
      -3,
      99,
      8220,
      -3,
      99,
      8221,
      -3,
      102,
      8217,
      2,
      102,
      8221,
      3,
      104,
      8216,
      -4,
      104,
      8217,
      -4,
      104,
      8220,
      -4,
      104,
      8221,
      -4,
      107,
      8216,
      -1,
      107,
      8217,
      -1,
      107,
      8220,
      -1,
      107,
      8221,
      -1,
      109,
      8216,
      -4,
      109,
      8217,
      -4,
      109,
      8220,
      -4,
      109,
      8221,
      -4,
      110,
      8216,
      -4,
      110,
      8217,
      -4,
      110,
      8220,
      -4,
      110,
      8221,
      -4,
      111,
      8216,
      -4,
      111,
      8217,
      -4,
      111,
      8220,
      -4,
      111,
      8221,
      -4,
      112,
      8216,
      -4,
      112,
      8217,
      -4,
      112,
      8220,
      -4,
      112,
      8221,
      -4,
      113,
      8216,
      -1,
      113,
      8217,
      -1,
      113,
      8220,
      -1,
      113,
      8221,
      -1,
      115,
      8216,
      -3,
      115,
      8217,
      -3,
      115,
      8220,
      -3,
      115,
      8221,
      -3,
      116,
      8216,
      -3,
      116,
      8217,
      -3,
      116,
      8220,
      -3,
      116,
      8221,
      -3,
      117,
      8216,
      -2,
      117,
      8217,
      -2,
      117,
      8220,
      -2,
      117,
      8221,
      -2,
      8216,
      65,
      -4,
      8216,
      67,
      -1,
      8216,
      71,
      -1,
      8216,
      74,
      -3,
      8216,
      79,
      -1,
      8216,
      81,
      -1,
      8216,
      97,
      -1,
      8216,
      99,
      -4,
      8216,
      100,
      -4,
      8216,
      101,
      -4,
      8216,
      103,
      -4,
      8216,
      111,
      -4,
      8216,
      113,
      -4,
      8216,
      115,
      -3,
      8217,
      65,
      -5,
      8217,
      67,
      -1,
      8217,
      71,
      -1,
      8217,
      74,
      -3,
      8217,
      79,
      -1,
      8217,
      81,
      -1,
      8217,
      97,
      -1,
      8217,
      99,
      -4,
      8217,
      100,
      -4,
      8217,
      101,
      -4,
      8217,
      103,
      -4,
      8217,
      111,
      -4,
      8217,
      113,
      -4,
      8217,
      115,
      -3,
      8220,
      65,
      -4,
      8220,
      67,
      -1,
      8220,
      71,
      -1,
      8220,
      74,
      -3,
      8220,
      79,
      -1,
      8220,
      81,
      -1,
      8220,
      97,
      -1,
      8220,
      99,
      -4,
      8220,
      100,
      -4,
      8220,
      101,
      -4,
      8220,
      103,
      -4,
      8220,
      111,
      -4,
      8220,
      113,
      -4,
      8220,
      115,
      -3,
      8221,
      65,
      -5,
      8221,
      67,
      -1,
      8221,
      71,
      -1,
      8221,
      74,
      -3,
      8221,
      79,
      -1,
      8221,
      81,
      -1,
      8221,
      97,
      -1,
      8221,
      99,
      -4,
      8221,
      100,
      -4,
      8221,
      101,
      -4,
      8221,
      103,
      -4,
      8221,
      111,
      -4,
      8221,
      113,
      -4,
      8221,
      115,
      -3,
      76,
      183,
      -6
    ]
  },
  "Oswald|regular|normal": {
    emSize: 80,
    commonLineHeight: 119,
    capTop: 30,
    advances: [
      18,
      17,
      21,
      39,
      39,
      71,
      48,
      10,
      24,
      21,
      32,
      33,
      15,
      24,
      15,
      30,
      41,
      30,
      38,
      38,
      39,
      38,
      40,
      31,
      40,
      40,
      16,
      17,
      30,
      33,
      30,
      39,
      72,
      39,
      42,
      41,
      42,
      33,
      31,
      43,
      45,
      20,
      24,
      40,
      32,
      53,
      42,
      43,
      38,
      43,
      42,
      38,
      33,
      43,
      40,
      58,
      39,
      38,
      33,
      27,
      30,
      25,
      35,
      28,
      22,
      33,
      36,
      33,
      35,
      34,
      23,
      35,
      36,
      18,
      18,
      34,
      18,
      54,
      35,
      34,
      36,
      35,
      26,
      30,
      25,
      35,
      31,
      47,
      31,
      31,
      28,
      24,
      19,
      26,
      36
    ],
    extraAdvances: [
      162,
      31,
      163,
      32,
      165,
      37,
      176,
      36,
      183,
      14,
      215,
      31,
      8211,
      45,
      8212,
      82,
      8216,
      14,
      8217,
      14,
      8220,
      28,
      8221,
      26,
      8230,
      44,
      8364,
      40,
      8377,
      41
    ],
    kernings: [
      34,
      65,
      -5,
      34,
      67,
      -1,
      34,
      71,
      -1,
      34,
      74,
      -3,
      34,
      79,
      -1,
      34,
      81,
      -1,
      34,
      97,
      -1,
      34,
      99,
      -2,
      34,
      100,
      -2,
      34,
      101,
      -2,
      34,
      103,
      -3,
      34,
      111,
      -2,
      34,
      113,
      -2,
      34,
      115,
      -1,
      38,
      84,
      -1,
      39,
      65,
      -5,
      39,
      67,
      -1,
      39,
      71,
      -1,
      39,
      74,
      -3,
      39,
      79,
      -1,
      39,
      81,
      -1,
      39,
      97,
      -1,
      39,
      99,
      -2,
      39,
      100,
      -2,
      39,
      101,
      -2,
      39,
      103,
      -3,
      39,
      111,
      -2,
      39,
      113,
      -2,
      39,
      115,
      -1,
      42,
      74,
      -1,
      42,
      88,
      -1,
      44,
      67,
      -1,
      44,
      71,
      -1,
      44,
      79,
      -1,
      44,
      81,
      -1,
      44,
      84,
      -4,
      44,
      85,
      -1,
      44,
      86,
      -3,
      44,
      87,
      -3,
      44,
      89,
      -5,
      44,
      99,
      -1,
      44,
      100,
      -1,
      44,
      101,
      -1,
      44,
      111,
      -1,
      44,
      113,
      -1,
      44,
      116,
      -1,
      44,
      118,
      -1,
      44,
      119,
      -1,
      44,
      121,
      -1,
      45,
      84,
      -1,
      45,
      86,
      -2,
      45,
      88,
      -1,
      45,
      89,
      -1,
      46,
      67,
      -1,
      46,
      71,
      -1,
      46,
      79,
      -1,
      46,
      81,
      -1,
      46,
      84,
      -4,
      46,
      85,
      -1,
      46,
      86,
      -3,
      46,
      87,
      -3,
      46,
      89,
      -5,
      46,
      99,
      -1,
      46,
      100,
      -1,
      46,
      101,
      -1,
      46,
      111,
      -1,
      46,
      113,
      -1,
      46,
      116,
      -1,
      46,
      118,
      -1,
      46,
      119,
      -1,
      46,
      121,
      -1,
      47,
      67,
      -1,
      47,
      71,
      -1,
      47,
      79,
      -1,
      47,
      81,
      -1,
      47,
      83,
      -1,
      47,
      99,
      -2,
      47,
      100,
      -2,
      47,
      101,
      -2,
      47,
      111,
      -2,
      47,
      113,
      -2,
      48,
      55,
      -1,
      48,
      89,
      -1,
      49,
      55,
      -1,
      50,
      52,
      -1,
      52,
      49,
      -1,
      52,
      55,
      -1,
      53,
      55,
      -1,
      54,
      55,
      -1,
      55,
      52,
      -3,
      56,
      55,
      -1,
      57,
      55,
      -1,
      58,
      84,
      -5,
      58,
      86,
      -1,
      58,
      87,
      -1,
      58,
      89,
      -3,
      59,
      84,
      -5,
      59,
      86,
      -1,
      59,
      87,
      -1,
      59,
      89,
      -3,
      65,
      34,
      -5,
      65,
      39,
      -5,
      65,
      84,
      -3,
      65,
      86,
      -3,
      65,
      87,
      -2,
      65,
      89,
      -3,
      65,
      102,
      -1,
      65,
      116,
      -1,
      65,
      118,
      -1,
      65,
      119,
      -1,
      65,
      121,
      -1,
      66,
      34,
      -1,
      66,
      39,
      -1,
      66,
      44,
      -1,
      66,
      46,
      -1,
      66,
      84,
      -2,
      66,
      86,
      -2,
      66,
      88,
      -2,
      66,
      89,
      -1,
      67,
      34,
      -1,
      67,
      39,
      -1,
      68,
      34,
      -1,
      68,
      39,
      -1,
      68,
      44,
      -1,
      68,
      46,
      -1,
      68,
      88,
      -1,
      68,
      89,
      -1,
      68,
      92,
      -1,
      70,
      44,
      -5,
      70,
      46,
      -5,
      70,
      58,
      -1,
      70,
      59,
      -1,
      70,
      65,
      -3,
      70,
      74,
      -2,
      70,
      97,
      -2,
      70,
      99,
      -1,
      70,
      100,
      -1,
      70,
      101,
      -1,
      70,
      103,
      -1,
      70,
      111,
      -1,
      70,
      113,
      -1,
      70,
      115,
      -1,
      70,
      120,
      -1,
      70,
      121,
      -1,
      70,
      122,
      -1,
      71,
      34,
      -1,
      71,
      39,
      -1,
      71,
      84,
      -1,
      71,
      86,
      -1,
      71,
      89,
      -1,
      74,
      44,
      -2,
      74,
      46,
      -2,
      75,
      45,
      -1,
      75,
      67,
      -1,
      75,
      71,
      -1,
      75,
      79,
      -1,
      75,
      81,
      -1,
      75,
      83,
      -1,
      75,
      99,
      -1,
      75,
      100,
      -1,
      75,
      101,
      -1,
      75,
      111,
      -1,
      75,
      113,
      -1,
      75,
      116,
      -1,
      75,
      119,
      -1,
      75,
      121,
      -2,
      76,
      34,
      -2,
      76,
      39,
      -2,
      76,
      42,
      -3,
      76,
      45,
      -1,
      76,
      49,
      -1,
      76,
      81,
      -1,
      76,
      84,
      -6,
      76,
      85,
      -1,
      76,
      86,
      -6,
      76,
      87,
      -4,
      76,
      89,
      -7,
      76,
      92,
      -3,
      76,
      102,
      -1,
      76,
      116,
      -1,
      76,
      119,
      -3,
      76,
      121,
      -4,
      77,
      84,
      -1,
      79,
      34,
      -1,
      79,
      39,
      -1,
      79,
      44,
      -1,
      79,
      46,
      -1,
      79,
      88,
      -1,
      79,
      89,
      -1,
      79,
      92,
      -1,
      80,
      44,
      -8,
      80,
      45,
      -7,
      80,
      46,
      -9,
      80,
      47,
      -4,
      80,
      52,
      -2,
      80,
      65,
      -4,
      80,
      74,
      -2,
      80,
      88,
      -1,
      80,
      90,
      -2,
      80,
      92,
      -1,
      80,
      97,
      -2,
      80,
      99,
      -2,
      80,
      100,
      -2,
      80,
      101,
      -2,
      80,
      103,
      -1,
      80,
      109,
      -1,
      80,
      110,
      -1,
      80,
      111,
      -2,
      80,
      114,
      -1,
      80,
      115,
      -1,
      80,
      122,
      -1,
      81,
      34,
      -1,
      81,
      39,
      -1,
      81,
      44,
      -1,
      81,
      46,
      -1,
      81,
      88,
      -1,
      81,
      89,
      -1,
      81,
      92,
      -1,
      82,
      84,
      -1,
      82,
      89,
      -1,
      82,
      92,
      -1,
      82,
      97,
      -1,
      82,
      99,
      -1,
      82,
      100,
      -1,
      82,
      101,
      -1,
      82,
      111,
      -1,
      82,
      113,
      -1,
      82,
      119,
      -1,
      82,
      122,
      -1,
      83,
      47,
      -1,
      83,
      83,
      -1,
      83,
      92,
      -1,
      84,
      44,
      -4,
      84,
      45,
      -1,
      84,
      46,
      -4,
      84,
      47,
      -2,
      84,
      58,
      -5,
      84,
      59,
      -5,
      84,
      65,
      -3,
      84,
      74,
      -2,
      84,
      77,
      -1,
      84,
      97,
      -5,
      84,
      99,
      -5,
      84,
      100,
      -5,
      84,
      101,
      -5,
      84,
      102,
      -3,
      84,
      103,
      -5,
      84,
      106,
      -1,
      84,
      109,
      -5,
      84,
      110,
      -5,
      84,
      111,
      -5,
      84,
      112,
      -5,
      84,
      114,
      -5,
      84,
      115,
      -5,
      84,
      116,
      -1,
      84,
      117,
      -4,
      84,
      119,
      -5,
      84,
      120,
      -4,
      84,
      121,
      -5,
      84,
      122,
      -4,
      85,
      44,
      -1,
      85,
      46,
      -1,
      85,
      47,
      -1,
      86,
      44,
      -4,
      86,
      45,
      -2,
      86,
      46,
      -4,
      86,
      47,
      -1,
      86,
      58,
      -1,
      86,
      59,
      -1,
      86,
      65,
      -3,
      86,
      74,
      -2,
      86,
      97,
      -5,
      86,
      99,
      -3,
      86,
      100,
      -3,
      86,
      101,
      -3,
      86,
      103,
      -4,
      86,
      109,
      -2,
      86,
      110,
      -2,
      86,
      111,
      -3,
      86,
      112,
      -2,
      86,
      113,
      -3,
      86,
      114,
      -2,
      86,
      115,
      -3,
      86,
      116,
      -1,
      86,
      117,
      -2,
      86,
      118,
      -2,
      86,
      119,
      -2,
      86,
      120,
      -2,
      86,
      121,
      -2,
      86,
      122,
      -3,
      87,
      44,
      -3,
      87,
      46,
      -3,
      87,
      47,
      -1,
      87,
      58,
      -1,
      87,
      59,
      -1,
      87,
      65,
      -2,
      87,
      92,
      -1,
      87,
      97,
      -3,
      87,
      99,
      -2,
      87,
      100,
      -2,
      87,
      101,
      -2,
      87,
      103,
      -2,
      87,
      109,
      -1,
      87,
      110,
      -1,
      87,
      111,
      -2,
      87,
      112,
      -1,
      87,
      114,
      -1,
      87,
      115,
      -1,
      87,
      118,
      -1,
      87,
      119,
      -1,
      87,
      120,
      -1,
      87,
      122,
      -1,
      88,
      42,
      -1,
      88,
      45,
      -1,
      88,
      67,
      -1,
      88,
      71,
      -1,
      88,
      79,
      -1,
      88,
      81,
      -1,
      88,
      92,
      -1,
      88,
      97,
      -1,
      88,
      99,
      -1,
      88,
      100,
      -1,
      88,
      101,
      -1,
      88,
      102,
      -2,
      88,
      103,
      -1,
      88,
      111,
      -1,
      88,
      113,
      -1,
      88,
      115,
      -2,
      88,
      116,
      -2,
      88,
      118,
      -2,
      88,
      119,
      -2,
      88,
      121,
      -2,
      89,
      44,
      -5,
      89,
      45,
      -1,
      89,
      46,
      -5,
      89,
      47,
      -1,
      89,
      48,
      -1,
      89,
      52,
      -1,
      89,
      58,
      -4,
      89,
      59,
      -4,
      89,
      65,
      -3,
      89,
      67,
      -1,
      89,
      71,
      -1,
      89,
      74,
      -2,
      89,
      79,
      -1,
      89,
      81,
      -1,
      89,
      97,
      -6,
      89,
      99,
      -5,
      89,
      100,
      -5,
      89,
      101,
      -5,
      89,
      102,
      -2,
      89,
      103,
      -5,
      89,
      109,
      -4,
      89,
      110,
      -4,
      89,
      111,
      -5,
      89,
      112,
      -3,
      89,
      113,
      -1,
      89,
      114,
      -4,
      89,
      115,
      -4,
      89,
      117,
      -4,
      89,
      119,
      -3,
      89,
      120,
      -3,
      89,
      121,
      -2,
      89,
      122,
      -2,
      92,
      67,
      -1,
      92,
      71,
      -1,
      92,
      79,
      -1,
      92,
      81,
      -1,
      92,
      83,
      -1,
      92,
      84,
      -2,
      92,
      85,
      -1,
      92,
      86,
      -2,
      92,
      87,
      -1,
      92,
      89,
      -2,
      97,
      34,
      -2,
      97,
      39,
      -2,
      97,
      84,
      -5,
      97,
      86,
      -4,
      97,
      87,
      -2,
      97,
      89,
      -6,
      98,
      34,
      -2,
      98,
      39,
      -2,
      98,
      44,
      -1,
      98,
      46,
      -1,
      98,
      84,
      -5,
      98,
      86,
      -3,
      98,
      87,
      -2,
      98,
      89,
      -5,
      98,
      120,
      -1,
      99,
      34,
      -1,
      99,
      39,
      -1,
      99,
      84,
      -4,
      99,
      89,
      -3,
      100,
      84,
      2,
      100,
      86,
      1,
      100,
      87,
      1,
      100,
      89,
      2,
      101,
      34,
      -1,
      101,
      39,
      -1,
      101,
      84,
      -5,
      101,
      86,
      -2,
      101,
      87,
      -1,
      101,
      89,
      -4,
      101,
      120,
      -1,
      102,
      46,
      -1,
      102,
      97,
      -1,
      102,
      99,
      -2,
      102,
      100,
      -2,
      102,
      101,
      -2,
      102,
      102,
      -3,
      102,
      105,
      -1,
      102,
      106,
      -1,
      102,
      111,
      -2,
      102,
      113,
      -2,
      102,
      117,
      -1,
      103,
      84,
      -3,
      103,
      86,
      -1,
      103,
      88,
      -2,
      103,
      89,
      -1,
      103,
      90,
      -1,
      103,
      103,
      -1,
      103,
      106,
      1,
      104,
      34,
      -2,
      104,
      39,
      -2,
      104,
      84,
      -5,
      104,
      86,
      -2,
      104,
      87,
      -1,
      104,
      89,
      -4,
      107,
      34,
      -1,
      107,
      39,
      -1,
      107,
      84,
      -3,
      107,
      89,
      -2,
      109,
      34,
      -2,
      109,
      39,
      -2,
      109,
      84,
      -5,
      109,
      86,
      -2,
      109,
      87,
      -1,
      109,
      89,
      -4,
      110,
      34,
      -2,
      110,
      39,
      -2,
      110,
      84,
      -5,
      110,
      86,
      -2,
      110,
      87,
      -1,
      110,
      89,
      -4,
      111,
      34,
      -2,
      111,
      39,
      -2,
      111,
      44,
      -1,
      111,
      46,
      -1,
      111,
      84,
      -5,
      111,
      86,
      -3,
      111,
      87,
      -2,
      111,
      89,
      -5,
      111,
      120,
      -1,
      112,
      34,
      -2,
      112,
      39,
      -2,
      112,
      44,
      -1,
      112,
      46,
      -1,
      112,
      84,
      -5,
      112,
      86,
      -3,
      112,
      87,
      -2,
      112,
      89,
      -5,
      112,
      120,
      -1,
      113,
      34,
      -1,
      113,
      39,
      -1,
      113,
      84,
      -4,
      113,
      86,
      -2,
      113,
      89,
      -3,
      114,
      44,
      -6,
      114,
      46,
      -6,
      114,
      65,
      -2,
      114,
      74,
      -1,
      114,
      84,
      -4,
      114,
      88,
      -2,
      114,
      89,
      -1,
      114,
      90,
      -2,
      114,
      97,
      -1,
      114,
      113,
      -1,
      115,
      34,
      -1,
      115,
      39,
      -1,
      115,
      84,
      -5,
      115,
      86,
      -3,
      115,
      87,
      -1,
      115,
      88,
      -1,
      115,
      89,
      -5,
      116,
      34,
      -1,
      116,
      39,
      -1,
      116,
      84,
      -2,
      116,
      86,
      -1,
      116,
      89,
      -1,
      117,
      34,
      -1,
      117,
      39,
      -1,
      117,
      84,
      -4,
      117,
      86,
      -2,
      117,
      89,
      -4,
      118,
      44,
      -1,
      118,
      46,
      -2,
      118,
      65,
      -1,
      118,
      74,
      -1,
      118,
      84,
      -6,
      118,
      86,
      -2,
      118,
      87,
      -1,
      118,
      88,
      -2,
      118,
      89,
      -3,
      118,
      90,
      -2,
      119,
      44,
      -1,
      119,
      46,
      -2,
      119,
      65,
      -1,
      119,
      74,
      -2,
      119,
      84,
      -5,
      119,
      86,
      -2,
      119,
      87,
      -1,
      119,
      88,
      -2,
      119,
      89,
      -3,
      119,
      90,
      -1,
      120,
      84,
      -4,
      120,
      86,
      -2,
      120,
      87,
      -1,
      120,
      89,
      -3,
      120,
      99,
      -1,
      120,
      100,
      -1,
      120,
      101,
      -1,
      120,
      111,
      -1,
      120,
      113,
      -1,
      121,
      44,
      -2,
      121,
      46,
      -2,
      121,
      65,
      -1,
      121,
      74,
      -1,
      121,
      84,
      -6,
      121,
      86,
      -2,
      121,
      87,
      -1,
      121,
      88,
      -2,
      121,
      89,
      -3,
      121,
      90,
      -2,
      122,
      84,
      -4,
      122,
      86,
      -1,
      122,
      87,
      -1,
      122,
      89,
      -2,
      122,
      99,
      -1,
      122,
      100,
      -1,
      122,
      101,
      -1,
      122,
      111,
      -1,
      122,
      113,
      -1,
      65,
      8216,
      -5,
      65,
      8217,
      -5,
      65,
      8220,
      -5,
      65,
      8221,
      -5,
      66,
      8216,
      -1,
      66,
      8217,
      -1,
      66,
      8220,
      -1,
      66,
      8221,
      -1,
      67,
      8216,
      -1,
      67,
      8217,
      -1,
      67,
      8220,
      -1,
      67,
      8221,
      -1,
      68,
      8216,
      -1,
      68,
      8217,
      -1,
      68,
      8220,
      -1,
      68,
      8221,
      -1,
      71,
      8216,
      -1,
      71,
      8217,
      -1,
      71,
      8220,
      -1,
      71,
      8221,
      -1,
      76,
      8216,
      -9,
      76,
      8217,
      -3,
      76,
      8220,
      -9,
      76,
      8221,
      -5,
      79,
      8216,
      -1,
      79,
      8217,
      -1,
      79,
      8220,
      -1,
      79,
      8221,
      -1,
      81,
      8216,
      -1,
      81,
      8217,
      -1,
      81,
      8220,
      -1,
      81,
      8221,
      -1,
      97,
      8216,
      -2,
      97,
      8217,
      -2,
      97,
      8220,
      -2,
      97,
      8221,
      -2,
      98,
      8216,
      -2,
      98,
      8217,
      -2,
      98,
      8220,
      -2,
      98,
      8221,
      -2,
      99,
      8216,
      -1,
      99,
      8217,
      -1,
      99,
      8220,
      -1,
      99,
      8221,
      -1,
      101,
      8216,
      -1,
      101,
      8217,
      -1,
      101,
      8220,
      -1,
      101,
      8221,
      -1,
      102,
      8217,
      3,
      102,
      8221,
      1,
      104,
      8216,
      -2,
      104,
      8217,
      -2,
      104,
      8220,
      -2,
      104,
      8221,
      -2,
      107,
      8216,
      -1,
      107,
      8217,
      -1,
      107,
      8220,
      -1,
      107,
      8221,
      -1,
      109,
      8216,
      -2,
      109,
      8217,
      -2,
      109,
      8220,
      -2,
      109,
      8221,
      -2,
      110,
      8216,
      -2,
      110,
      8217,
      -2,
      110,
      8220,
      -2,
      110,
      8221,
      -2,
      111,
      8216,
      -2,
      111,
      8217,
      -2,
      111,
      8220,
      -2,
      111,
      8221,
      -2,
      112,
      8216,
      -2,
      112,
      8217,
      -2,
      112,
      8220,
      -2,
      112,
      8221,
      -2,
      113,
      8216,
      -1,
      113,
      8217,
      -1,
      113,
      8220,
      -1,
      113,
      8221,
      -1,
      115,
      8216,
      -1,
      115,
      8217,
      -1,
      115,
      8220,
      -1,
      115,
      8221,
      -1,
      116,
      8216,
      -1,
      116,
      8217,
      -1,
      116,
      8220,
      -1,
      116,
      8221,
      -1,
      117,
      8216,
      -1,
      117,
      8217,
      -1,
      117,
      8220,
      -1,
      117,
      8221,
      -1,
      8216,
      65,
      -5,
      8216,
      67,
      -1,
      8216,
      71,
      -1,
      8216,
      74,
      -3,
      8216,
      79,
      -1,
      8216,
      81,
      -1,
      8216,
      97,
      -1,
      8216,
      99,
      -2,
      8216,
      100,
      -2,
      8216,
      101,
      -2,
      8216,
      103,
      -3,
      8216,
      111,
      -2,
      8216,
      113,
      -2,
      8216,
      115,
      -1,
      8217,
      65,
      -5,
      8217,
      67,
      -1,
      8217,
      71,
      -1,
      8217,
      74,
      -3,
      8217,
      79,
      -1,
      8217,
      81,
      -1,
      8217,
      97,
      -1,
      8217,
      99,
      -2,
      8217,
      100,
      -2,
      8217,
      101,
      -2,
      8217,
      103,
      -3,
      8217,
      111,
      -2,
      8217,
      113,
      -2,
      8217,
      115,
      -1,
      8220,
      65,
      -5,
      8220,
      67,
      -1,
      8220,
      71,
      -1,
      8220,
      74,
      -3,
      8220,
      79,
      -1,
      8220,
      81,
      -1,
      8220,
      97,
      -1,
      8220,
      99,
      -2,
      8220,
      100,
      -2,
      8220,
      101,
      -2,
      8220,
      103,
      -3,
      8220,
      111,
      -2,
      8220,
      113,
      -2,
      8220,
      115,
      -1,
      8221,
      65,
      -5,
      8221,
      67,
      -1,
      8221,
      71,
      -1,
      8221,
      74,
      -3,
      8221,
      79,
      -1,
      8221,
      81,
      -1,
      8221,
      97,
      -1,
      8221,
      99,
      -2,
      8221,
      100,
      -2,
      8221,
      101,
      -2,
      8221,
      103,
      -3,
      8221,
      111,
      -2,
      8221,
      113,
      -2,
      8221,
      115,
      -1,
      76,
      183,
      -2
    ]
  },
  "Roboto|bold|italic": {
    emSize: 80,
    commonLineHeight: 106,
    capTop: 27,
    advances: [
      20,
      21,
      25,
      47,
      45,
      58,
      51,
      13,
      28,
      28,
      36,
      43,
      19,
      30,
      23,
      29,
      45,
      45,
      45,
      45,
      45,
      45,
      45,
      45,
      45,
      45,
      22,
      21,
      40,
      45,
      40,
      39,
      70,
      53,
      50,
      51,
      51,
      44,
      43,
      53,
      55,
      23,
      44,
      50,
      42,
      68,
      55,
      54,
      50,
      54,
      50,
      48,
      48,
      51,
      51,
      68,
      50,
      48,
      47,
      22,
      33,
      22,
      34,
      35,
      26,
      42,
      44,
      41,
      44,
      42,
      28,
      45,
      44,
      21,
      21,
      42,
      21,
      68,
      44,
      44,
      44,
      44,
      29,
      40,
      27,
      44,
      40,
      57,
      40,
      39,
      40,
      26,
      20,
      26,
      51
    ],
    extraAdvances: [
      162,
      45,
      163,
      46,
      165,
      42,
      176,
      31,
      183,
      24,
      215,
      42,
      8211,
      49,
      8212,
      60,
      8216,
      19,
      8217,
      18,
      8220,
      32,
      8221,
      32,
      8226,
      28,
      8230,
      58,
      8249,
      25,
      8250,
      24,
      8364,
      45,
      8377,
      41,
      8593,
      26,
      8595,
      26
    ],
    kernings: [
      32,
      84,
      -2,
      34,
      34,
      -1,
      34,
      39,
      -1,
      34,
      65,
      -5,
      34,
      97,
      -2,
      34,
      99,
      -2,
      34,
      110,
      -1,
      34,
      111,
      -4,
      34,
      115,
      -4,
      39,
      34,
      -1,
      39,
      39,
      -1,
      39,
      65,
      -5,
      39,
      97,
      -2,
      39,
      99,
      -2,
      39,
      110,
      -1,
      39,
      111,
      -4,
      39,
      115,
      -4,
      40,
      86,
      1,
      40,
      87,
      1,
      40,
      89,
      1,
      44,
      34,
      -11,
      44,
      39,
      -11,
      46,
      34,
      -11,
      46,
      39,
      -11,
      47,
      47,
      -10,
      65,
      34,
      -5,
      65,
      39,
      -5,
      65,
      63,
      -3,
      65,
      79,
      -1,
      65,
      84,
      -5,
      65,
      85,
      -1,
      65,
      86,
      -3,
      65,
      87,
      -2,
      65,
      89,
      -6,
      65,
      110,
      -2,
      65,
      116,
      -1,
      65,
      118,
      -2,
      65,
      119,
      -1,
      66,
      84,
      -1,
      66,
      86,
      -1,
      66,
      89,
      -2,
      67,
      41,
      -1,
      67,
      84,
      -1,
      67,
      125,
      -1,
      69,
      84,
      1,
      69,
      99,
      -1,
      69,
      102,
      -1,
      69,
      111,
      -1,
      69,
      117,
      -1,
      69,
      118,
      -1,
      69,
      119,
      -1,
      70,
      44,
      -11,
      70,
      46,
      -11,
      70,
      65,
      -7,
      70,
      74,
      -8,
      70,
      84,
      1,
      70,
      97,
      -1,
      70,
      99,
      -1,
      70,
      111,
      -1,
      70,
      114,
      -1,
      70,
      117,
      -1,
      70,
      118,
      -1,
      72,
      65,
      1,
      72,
      84,
      -1,
      72,
      88,
      1,
      72,
      89,
      -1,
      75,
      45,
      -6,
      75,
      79,
      -1,
      75,
      99,
      -1,
      75,
      111,
      -1,
      75,
      117,
      -1,
      75,
      118,
      -2,
      75,
      119,
      -2,
      76,
      34,
      -11,
      76,
      39,
      -11,
      76,
      65,
      1,
      76,
      79,
      -2,
      76,
      84,
      -8,
      76,
      85,
      -1,
      76,
      86,
      -8,
      76,
      87,
      -4,
      76,
      89,
      -11,
      76,
      117,
      -1,
      76,
      118,
      -5,
      76,
      119,
      -2,
      79,
      44,
      -5,
      79,
      46,
      -5,
      79,
      65,
      -1,
      79,
      84,
      -3,
      79,
      86,
      -1,
      79,
      88,
      -1,
      79,
      89,
      -2,
      79,
      90,
      -1,
      80,
      44,
      -16,
      80,
      46,
      -16,
      80,
      65,
      -7,
      80,
      74,
      -7,
      80,
      88,
      -2,
      80,
      90,
      -1,
      80,
      99,
      -1,
      80,
      111,
      -1,
      80,
      116,
      1,
      80,
      118,
      1,
      81,
      84,
      -1,
      81,
      86,
      -1,
      81,
      87,
      -1,
      81,
      89,
      -1,
      82,
      84,
      -2,
      82,
      86,
      -1,
      82,
      89,
      -2,
      84,
      32,
      -2,
      84,
      44,
      -10,
      84,
      45,
      -11,
      84,
      46,
      -10,
      84,
      65,
      -5,
      84,
      74,
      -8,
      84,
      79,
      -1,
      84,
      83,
      -1,
      84,
      84,
      1,
      84,
      86,
      1,
      84,
      87,
      1,
      84,
      89,
      1,
      84,
      97,
      -7,
      84,
      99,
      -3,
      84,
      110,
      -3,
      84,
      111,
      -8,
      84,
      114,
      -3,
      84,
      115,
      -3,
      84,
      117,
      -3,
      84,
      118,
      -3,
      84,
      119,
      -2,
      84,
      120,
      -3,
      84,
      122,
      -2,
      85,
      65,
      -1,
      86,
      41,
      1,
      86,
      44,
      -8,
      86,
      45,
      -6,
      86,
      46,
      -8,
      86,
      65,
      -3,
      86,
      79,
      -1,
      86,
      93,
      1,
      86,
      97,
      -2,
      86,
      99,
      -2,
      86,
      111,
      -2,
      86,
      114,
      -1,
      86,
      117,
      -1,
      86,
      125,
      1,
      87,
      41,
      1,
      87,
      44,
      -6,
      87,
      45,
      -2,
      87,
      46,
      -6,
      87,
      65,
      -2,
      87,
      84,
      1,
      87,
      97,
      -1,
      87,
      99,
      -1,
      87,
      111,
      -1,
      87,
      114,
      -1,
      87,
      117,
      -1,
      87,
      125,
      1,
      88,
      45,
      -6,
      88,
      79,
      -1,
      88,
      86,
      1,
      88,
      99,
      -1,
      88,
      111,
      -1,
      88,
      117,
      -1,
      88,
      118,
      -1,
      89,
      38,
      -1,
      89,
      41,
      1,
      89,
      42,
      -2,
      89,
      44,
      -9,
      89,
      45,
      -6,
      89,
      46,
      -9,
      89,
      65,
      -6,
      89,
      74,
      -4,
      89,
      79,
      -1,
      89,
      83,
      -1,
      89,
      84,
      1,
      89,
      85,
      -4,
      89,
      86,
      1,
      89,
      87,
      1,
      89,
      88,
      1,
      89,
      89,
      1,
      89,
      93,
      1,
      89,
      97,
      -2,
      89,
      99,
      -3,
      89,
      102,
      -1,
      89,
      110,
      -2,
      89,
      111,
      -3,
      89,
      114,
      -2,
      89,
      115,
      -2,
      89,
      116,
      -1,
      89,
      117,
      -2,
      89,
      118,
      -1,
      89,
      120,
      -1,
      89,
      122,
      -1,
      89,
      125,
      1,
      90,
      65,
      1,
      90,
      79,
      -1,
      90,
      99,
      -1,
      90,
      111,
      -1,
      90,
      117,
      -1,
      90,
      118,
      -1,
      90,
      119,
      -1,
      91,
      74,
      -1,
      91,
      85,
      -1,
      97,
      34,
      -1,
      97,
      39,
      -1,
      97,
      118,
      -1,
      98,
      34,
      -1,
      98,
      39,
      -1,
      98,
      120,
      -1,
      98,
      122,
      -1,
      101,
      34,
      -1,
      101,
      39,
      -1,
      101,
      118,
      -1,
      102,
      34,
      1,
      102,
      39,
      1,
      102,
      41,
      1,
      102,
      93,
      1,
      102,
      99,
      -1,
      102,
      125,
      1,
      107,
      99,
      -1,
      110,
      34,
      -3,
      110,
      39,
      -3,
      111,
      34,
      -3,
      111,
      39,
      -3,
      111,
      118,
      -1,
      111,
      120,
      -1,
      111,
      122,
      -1,
      114,
      34,
      1,
      114,
      39,
      1,
      114,
      44,
      -7,
      114,
      46,
      -7,
      114,
      97,
      -1,
      114,
      99,
      -1,
      114,
      102,
      1,
      114,
      111,
      -1,
      114,
      116,
      2,
      114,
      118,
      1,
      114,
      119,
      1,
      116,
      111,
      -1,
      118,
      34,
      1,
      118,
      39,
      1,
      118,
      44,
      -7,
      118,
      46,
      -7,
      118,
      97,
      -1,
      118,
      99,
      -1,
      118,
      102,
      1,
      118,
      111,
      -1,
      119,
      44,
      -5,
      119,
      46,
      -5,
      120,
      99,
      -1,
      120,
      111,
      -2,
      122,
      99,
      -1,
      122,
      111,
      -1,
      123,
      74,
      -1,
      123,
      85,
      -1,
      34,
      8216,
      -1,
      34,
      8217,
      -1,
      34,
      8220,
      -1,
      34,
      8221,
      -1,
      39,
      8216,
      -1,
      39,
      8217,
      -1,
      39,
      8220,
      -1,
      39,
      8221,
      -1,
      44,
      8216,
      -11,
      44,
      8217,
      -11,
      44,
      8220,
      -11,
      44,
      8221,
      -11,
      46,
      8216,
      -11,
      46,
      8217,
      -11,
      46,
      8220,
      -11,
      46,
      8221,
      -11,
      65,
      8216,
      -5,
      65,
      8217,
      -5,
      65,
      8220,
      -5,
      65,
      8221,
      -5,
      68,
      8230,
      -5,
      70,
      8230,
      -11,
      75,
      8211,
      -6,
      75,
      8212,
      -6,
      76,
      8216,
      -11,
      76,
      8217,
      -11,
      76,
      8220,
      -11,
      76,
      8221,
      -11,
      79,
      8230,
      -5,
      80,
      8230,
      -16,
      84,
      8230,
      -10,
      84,
      8211,
      -11,
      84,
      8212,
      -11,
      86,
      8230,
      -8,
      86,
      8211,
      -6,
      86,
      8212,
      -6,
      87,
      8230,
      -6,
      87,
      8211,
      -2,
      87,
      8212,
      -2,
      88,
      8211,
      -6,
      88,
      8212,
      -6,
      89,
      8230,
      -9,
      89,
      8211,
      -6,
      89,
      8212,
      -6,
      97,
      8216,
      -1,
      97,
      8217,
      -1,
      97,
      8220,
      -1,
      97,
      8221,
      -1,
      98,
      8216,
      -1,
      98,
      8217,
      -1,
      98,
      8220,
      -1,
      98,
      8221,
      -1,
      101,
      8216,
      -1,
      101,
      8217,
      -2,
      101,
      8220,
      -1,
      101,
      8221,
      -1,
      102,
      8216,
      1,
      102,
      8217,
      1,
      102,
      8220,
      1,
      102,
      8221,
      1,
      104,
      8216,
      -3,
      104,
      8217,
      -4,
      104,
      8220,
      -3,
      104,
      8221,
      -3,
      109,
      8216,
      -3,
      109,
      8217,
      -5,
      109,
      8220,
      -3,
      109,
      8221,
      -3,
      110,
      8216,
      -3,
      110,
      8217,
      -5,
      110,
      8220,
      -3,
      110,
      8221,
      -3,
      111,
      8216,
      -3,
      111,
      8217,
      -4,
      111,
      8220,
      -3,
      111,
      8221,
      -3,
      112,
      8216,
      -1,
      112,
      8217,
      -1,
      112,
      8220,
      -1,
      112,
      8221,
      -1,
      114,
      8216,
      1,
      114,
      8217,
      1,
      114,
      8220,
      1,
      114,
      8221,
      1,
      114,
      8230,
      -7,
      116,
      8217,
      1,
      118,
      8216,
      1,
      118,
      8217,
      1,
      118,
      8220,
      1,
      118,
      8221,
      1,
      118,
      8230,
      -7,
      119,
      8230,
      -5,
      121,
      8216,
      1,
      121,
      8217,
      1,
      121,
      8220,
      1,
      121,
      8221,
      1,
      121,
      8230,
      -7,
      8216,
      34,
      -1,
      8216,
      39,
      -1,
      8216,
      65,
      -5,
      8216,
      97,
      -2,
      8216,
      99,
      -2,
      8216,
      100,
      -2,
      8216,
      101,
      -2,
      8216,
      103,
      -2,
      8216,
      109,
      -1,
      8216,
      110,
      -1,
      8216,
      111,
      -4,
      8216,
      112,
      -1,
      8216,
      113,
      -2,
      8216,
      115,
      -4,
      8216,
      8216,
      -1,
      8216,
      8217,
      -1,
      8216,
      8220,
      -1,
      8216,
      8221,
      -1,
      8217,
      34,
      -1,
      8217,
      39,
      -1,
      8217,
      65,
      -5,
      8217,
      97,
      -2,
      8217,
      99,
      -4,
      8217,
      100,
      -4,
      8217,
      101,
      -4,
      8217,
      103,
      -4,
      8217,
      109,
      -1,
      8217,
      110,
      -1,
      8217,
      111,
      -6,
      8217,
      112,
      -1,
      8217,
      113,
      -4,
      8217,
      115,
      -9,
      8217,
      8216,
      -1,
      8217,
      8217,
      -1,
      8217,
      8220,
      -1,
      8217,
      8221,
      -1,
      8220,
      34,
      -1,
      8220,
      39,
      -1,
      8220,
      65,
      -5,
      8220,
      97,
      -2,
      8220,
      99,
      -2,
      8220,
      100,
      -2,
      8220,
      101,
      -2,
      8220,
      103,
      -2,
      8220,
      109,
      -1,
      8220,
      110,
      -1,
      8220,
      111,
      -4,
      8220,
      112,
      -1,
      8220,
      113,
      -2,
      8220,
      115,
      -4,
      8220,
      8216,
      -1,
      8220,
      8217,
      -1,
      8220,
      8220,
      -1,
      8220,
      8221,
      -1,
      8221,
      34,
      -1,
      8221,
      39,
      -1,
      8221,
      65,
      -5,
      8221,
      97,
      -2,
      8221,
      99,
      -2,
      8221,
      100,
      -2,
      8221,
      101,
      -2,
      8221,
      103,
      -2,
      8221,
      109,
      -1,
      8221,
      110,
      -1,
      8221,
      111,
      -4,
      8221,
      112,
      -1,
      8221,
      113,
      -2,
      8221,
      115,
      -4,
      8221,
      8216,
      -1,
      8221,
      8217,
      -1,
      8221,
      8220,
      -1,
      8221,
      8221,
      -1,
      8230,
      34,
      -11,
      8230,
      39,
      -11,
      8230,
      8216,
      -11,
      8230,
      8217,
      -11,
      8230,
      8220,
      -11,
      8230,
      8221,
      -11,
      89,
      8226,
      -2
    ]
  },
  "Roboto|bold|normal": {
    emSize: 80,
    commonLineHeight: 106,
    capTop: 27,
    advances: [
      20,
      22,
      26,
      48,
      46,
      59,
      53,
      13,
      28,
      28,
      36,
      44,
      20,
      31,
      23,
      30,
      46,
      46,
      46,
      46,
      46,
      46,
      46,
      46,
      46,
      46,
      23,
      21,
      41,
      46,
      41,
      40,
      72,
      54,
      51,
      52,
      52,
      45,
      44,
      54,
      57,
      23,
      45,
      51,
      43,
      70,
      56,
      55,
      52,
      55,
      51,
      49,
      49,
      53,
      52,
      70,
      51,
      49,
      48,
      22,
      34,
      22,
      35,
      36,
      26,
      43,
      45,
      42,
      45,
      43,
      29,
      46,
      45,
      21,
      21,
      43,
      21,
      69,
      45,
      45,
      45,
      45,
      29,
      41,
      27,
      45,
      40,
      59,
      41,
      40,
      41,
      26,
      20,
      26,
      52
    ],
    extraAdvances: [
      162,
      46,
      163,
      48,
      165,
      43,
      176,
      31,
      183,
      24,
      215,
      43,
      8211,
      51,
      8212,
      61,
      8216,
      19,
      8217,
      18,
      8220,
      32,
      8221,
      33,
      8226,
      29,
      8230,
      59,
      8249,
      25,
      8250,
      24,
      8364,
      46,
      8377,
      42,
      8593,
      26,
      8595,
      26
    ],
    kernings: [
      32,
      84,
      -2,
      34,
      34,
      -1,
      34,
      39,
      -1,
      34,
      65,
      -5,
      34,
      97,
      -2,
      34,
      99,
      -2,
      34,
      110,
      -1,
      34,
      111,
      -4,
      34,
      115,
      -4,
      39,
      34,
      -1,
      39,
      39,
      -1,
      39,
      65,
      -5,
      39,
      97,
      -2,
      39,
      99,
      -2,
      39,
      110,
      -1,
      39,
      111,
      -4,
      39,
      115,
      -4,
      40,
      86,
      1,
      40,
      87,
      1,
      40,
      89,
      1,
      44,
      34,
      -11,
      44,
      39,
      -11,
      46,
      34,
      -11,
      46,
      39,
      -11,
      47,
      47,
      -10,
      65,
      34,
      -5,
      65,
      39,
      -5,
      65,
      63,
      -3,
      65,
      79,
      -1,
      65,
      84,
      -5,
      65,
      85,
      -1,
      65,
      86,
      -3,
      65,
      87,
      -2,
      65,
      89,
      -6,
      65,
      110,
      -2,
      65,
      116,
      -1,
      65,
      118,
      -2,
      65,
      119,
      -1,
      66,
      84,
      -1,
      66,
      86,
      -1,
      66,
      89,
      -2,
      67,
      41,
      -1,
      67,
      84,
      -1,
      67,
      125,
      -1,
      69,
      84,
      1,
      69,
      99,
      -1,
      69,
      102,
      -1,
      69,
      111,
      -1,
      69,
      117,
      -1,
      69,
      118,
      -1,
      69,
      119,
      -1,
      70,
      44,
      -11,
      70,
      46,
      -11,
      70,
      65,
      -7,
      70,
      74,
      -8,
      70,
      84,
      1,
      70,
      97,
      -1,
      70,
      99,
      -1,
      70,
      111,
      -1,
      70,
      114,
      -1,
      70,
      117,
      -1,
      70,
      118,
      -1,
      72,
      65,
      1,
      72,
      84,
      -1,
      72,
      88,
      1,
      72,
      89,
      -1,
      75,
      45,
      -6,
      75,
      79,
      -1,
      75,
      99,
      -1,
      75,
      111,
      -1,
      75,
      117,
      -1,
      75,
      118,
      -2,
      75,
      119,
      -2,
      76,
      34,
      -11,
      76,
      39,
      -11,
      76,
      65,
      1,
      76,
      79,
      -2,
      76,
      84,
      -8,
      76,
      85,
      -1,
      76,
      86,
      -8,
      76,
      87,
      -4,
      76,
      89,
      -11,
      76,
      117,
      -1,
      76,
      118,
      -5,
      76,
      119,
      -2,
      79,
      44,
      -5,
      79,
      46,
      -5,
      79,
      65,
      -1,
      79,
      84,
      -3,
      79,
      86,
      -1,
      79,
      88,
      -1,
      79,
      89,
      -2,
      79,
      90,
      -1,
      80,
      44,
      -16,
      80,
      46,
      -16,
      80,
      65,
      -7,
      80,
      74,
      -7,
      80,
      88,
      -2,
      80,
      90,
      -1,
      80,
      99,
      -1,
      80,
      111,
      -1,
      80,
      116,
      1,
      80,
      118,
      1,
      81,
      84,
      -1,
      81,
      86,
      -1,
      81,
      87,
      -1,
      81,
      89,
      -1,
      82,
      84,
      -2,
      82,
      86,
      -1,
      82,
      89,
      -2,
      84,
      32,
      -2,
      84,
      44,
      -10,
      84,
      45,
      -11,
      84,
      46,
      -10,
      84,
      65,
      -5,
      84,
      74,
      -8,
      84,
      79,
      -1,
      84,
      83,
      -1,
      84,
      84,
      1,
      84,
      86,
      1,
      84,
      87,
      1,
      84,
      89,
      1,
      84,
      97,
      -7,
      84,
      99,
      -3,
      84,
      110,
      -3,
      84,
      111,
      -8,
      84,
      114,
      -3,
      84,
      115,
      -3,
      84,
      117,
      -3,
      84,
      118,
      -3,
      84,
      119,
      -2,
      84,
      120,
      -3,
      84,
      122,
      -2,
      85,
      65,
      -1,
      86,
      41,
      1,
      86,
      44,
      -8,
      86,
      45,
      -6,
      86,
      46,
      -8,
      86,
      65,
      -3,
      86,
      79,
      -1,
      86,
      93,
      1,
      86,
      97,
      -2,
      86,
      99,
      -2,
      86,
      111,
      -2,
      86,
      114,
      -1,
      86,
      117,
      -1,
      86,
      125,
      1,
      87,
      41,
      1,
      87,
      44,
      -6,
      87,
      45,
      -2,
      87,
      46,
      -6,
      87,
      65,
      -2,
      87,
      84,
      1,
      87,
      97,
      -1,
      87,
      99,
      -1,
      87,
      111,
      -1,
      87,
      114,
      -1,
      87,
      117,
      -1,
      87,
      125,
      1,
      88,
      45,
      -6,
      88,
      79,
      -1,
      88,
      86,
      1,
      88,
      99,
      -1,
      88,
      111,
      -1,
      88,
      117,
      -1,
      88,
      118,
      -1,
      89,
      38,
      -1,
      89,
      41,
      1,
      89,
      42,
      -2,
      89,
      44,
      -9,
      89,
      45,
      -6,
      89,
      46,
      -9,
      89,
      65,
      -6,
      89,
      74,
      -4,
      89,
      79,
      -1,
      89,
      83,
      -1,
      89,
      84,
      1,
      89,
      85,
      -4,
      89,
      86,
      1,
      89,
      87,
      1,
      89,
      88,
      1,
      89,
      89,
      1,
      89,
      93,
      1,
      89,
      97,
      -2,
      89,
      99,
      -3,
      89,
      102,
      -1,
      89,
      110,
      -2,
      89,
      111,
      -3,
      89,
      114,
      -2,
      89,
      115,
      -2,
      89,
      116,
      -1,
      89,
      117,
      -2,
      89,
      118,
      -1,
      89,
      120,
      -1,
      89,
      122,
      -1,
      89,
      125,
      1,
      90,
      65,
      1,
      90,
      79,
      -1,
      90,
      99,
      -1,
      90,
      111,
      -1,
      90,
      117,
      -1,
      90,
      118,
      -1,
      90,
      119,
      -1,
      91,
      74,
      -1,
      91,
      85,
      -1,
      97,
      34,
      -1,
      97,
      39,
      -1,
      97,
      118,
      -1,
      98,
      34,
      -1,
      98,
      39,
      -1,
      98,
      120,
      -1,
      98,
      122,
      -1,
      101,
      34,
      -1,
      101,
      39,
      -1,
      101,
      118,
      -1,
      102,
      34,
      1,
      102,
      39,
      1,
      102,
      41,
      1,
      102,
      93,
      1,
      102,
      99,
      -1,
      102,
      125,
      1,
      107,
      99,
      -1,
      110,
      34,
      -3,
      110,
      39,
      -3,
      111,
      34,
      -3,
      111,
      39,
      -3,
      111,
      118,
      -1,
      111,
      120,
      -1,
      111,
      122,
      -1,
      114,
      34,
      1,
      114,
      39,
      1,
      114,
      44,
      -7,
      114,
      46,
      -7,
      114,
      97,
      -1,
      114,
      99,
      -1,
      114,
      102,
      1,
      114,
      111,
      -1,
      114,
      116,
      2,
      114,
      118,
      1,
      114,
      119,
      1,
      116,
      111,
      -1,
      118,
      34,
      1,
      118,
      39,
      1,
      118,
      44,
      -7,
      118,
      46,
      -7,
      118,
      97,
      -1,
      118,
      99,
      -1,
      118,
      102,
      1,
      118,
      111,
      -1,
      119,
      44,
      -5,
      119,
      46,
      -5,
      120,
      99,
      -1,
      120,
      111,
      -2,
      122,
      99,
      -1,
      122,
      111,
      -1,
      123,
      74,
      -1,
      123,
      85,
      -1,
      34,
      8216,
      -1,
      34,
      8217,
      -1,
      34,
      8220,
      -1,
      34,
      8221,
      -1,
      39,
      8216,
      -1,
      39,
      8217,
      -1,
      39,
      8220,
      -1,
      39,
      8221,
      -1,
      44,
      8216,
      -11,
      44,
      8217,
      -11,
      44,
      8220,
      -11,
      44,
      8221,
      -11,
      46,
      8216,
      -11,
      46,
      8217,
      -11,
      46,
      8220,
      -11,
      46,
      8221,
      -11,
      65,
      8216,
      -5,
      65,
      8217,
      -5,
      65,
      8220,
      -5,
      65,
      8221,
      -5,
      68,
      8230,
      -5,
      70,
      8230,
      -11,
      75,
      8211,
      -6,
      75,
      8212,
      -6,
      76,
      8216,
      -11,
      76,
      8217,
      -11,
      76,
      8220,
      -11,
      76,
      8221,
      -11,
      79,
      8230,
      -5,
      80,
      8230,
      -16,
      84,
      8230,
      -10,
      84,
      8211,
      -11,
      84,
      8212,
      -11,
      86,
      8230,
      -8,
      86,
      8211,
      -6,
      86,
      8212,
      -6,
      87,
      8230,
      -6,
      87,
      8211,
      -2,
      87,
      8212,
      -2,
      88,
      8211,
      -6,
      88,
      8212,
      -6,
      89,
      8230,
      -9,
      89,
      8211,
      -6,
      89,
      8212,
      -6,
      97,
      8216,
      -1,
      97,
      8217,
      -1,
      97,
      8220,
      -1,
      97,
      8221,
      -1,
      98,
      8216,
      -1,
      98,
      8217,
      -1,
      98,
      8220,
      -1,
      98,
      8221,
      -1,
      101,
      8216,
      -1,
      101,
      8217,
      -2,
      101,
      8220,
      -1,
      101,
      8221,
      -1,
      102,
      8216,
      1,
      102,
      8217,
      1,
      102,
      8220,
      1,
      102,
      8221,
      1,
      104,
      8216,
      -3,
      104,
      8217,
      -4,
      104,
      8220,
      -3,
      104,
      8221,
      -3,
      109,
      8216,
      -3,
      109,
      8217,
      -5,
      109,
      8220,
      -3,
      109,
      8221,
      -3,
      110,
      8216,
      -3,
      110,
      8217,
      -5,
      110,
      8220,
      -3,
      110,
      8221,
      -3,
      111,
      8216,
      -3,
      111,
      8217,
      -4,
      111,
      8220,
      -3,
      111,
      8221,
      -3,
      112,
      8216,
      -1,
      112,
      8217,
      -1,
      112,
      8220,
      -1,
      112,
      8221,
      -1,
      114,
      8216,
      1,
      114,
      8217,
      1,
      114,
      8220,
      1,
      114,
      8221,
      1,
      114,
      8230,
      -7,
      116,
      8217,
      1,
      118,
      8216,
      1,
      118,
      8217,
      1,
      118,
      8220,
      1,
      118,
      8221,
      1,
      118,
      8230,
      -7,
      119,
      8230,
      -5,
      121,
      8216,
      1,
      121,
      8217,
      1,
      121,
      8220,
      1,
      121,
      8221,
      1,
      121,
      8230,
      -7,
      8216,
      34,
      -1,
      8216,
      39,
      -1,
      8216,
      65,
      -5,
      8216,
      97,
      -2,
      8216,
      99,
      -2,
      8216,
      100,
      -2,
      8216,
      101,
      -2,
      8216,
      103,
      -2,
      8216,
      109,
      -1,
      8216,
      110,
      -1,
      8216,
      111,
      -4,
      8216,
      112,
      -1,
      8216,
      113,
      -2,
      8216,
      115,
      -4,
      8216,
      8216,
      -1,
      8216,
      8217,
      -1,
      8216,
      8220,
      -1,
      8216,
      8221,
      -1,
      8217,
      34,
      -1,
      8217,
      39,
      -1,
      8217,
      65,
      -5,
      8217,
      97,
      -2,
      8217,
      99,
      -4,
      8217,
      100,
      -4,
      8217,
      101,
      -4,
      8217,
      103,
      -4,
      8217,
      109,
      -1,
      8217,
      110,
      -1,
      8217,
      111,
      -6,
      8217,
      112,
      -1,
      8217,
      113,
      -4,
      8217,
      115,
      -9,
      8217,
      8216,
      -1,
      8217,
      8217,
      -1,
      8217,
      8220,
      -1,
      8217,
      8221,
      -1,
      8220,
      34,
      -1,
      8220,
      39,
      -1,
      8220,
      65,
      -5,
      8220,
      97,
      -2,
      8220,
      99,
      -2,
      8220,
      100,
      -2,
      8220,
      101,
      -2,
      8220,
      103,
      -2,
      8220,
      109,
      -1,
      8220,
      110,
      -1,
      8220,
      111,
      -4,
      8220,
      112,
      -1,
      8220,
      113,
      -2,
      8220,
      115,
      -4,
      8220,
      8216,
      -1,
      8220,
      8217,
      -1,
      8220,
      8220,
      -1,
      8220,
      8221,
      -1,
      8221,
      34,
      -1,
      8221,
      39,
      -1,
      8221,
      65,
      -5,
      8221,
      97,
      -2,
      8221,
      99,
      -2,
      8221,
      100,
      -2,
      8221,
      101,
      -2,
      8221,
      103,
      -2,
      8221,
      109,
      -1,
      8221,
      110,
      -1,
      8221,
      111,
      -4,
      8221,
      112,
      -1,
      8221,
      113,
      -2,
      8221,
      115,
      -4,
      8221,
      8216,
      -1,
      8221,
      8217,
      -1,
      8221,
      8220,
      -1,
      8221,
      8221,
      -1,
      8230,
      34,
      -11,
      8230,
      39,
      -11,
      8230,
      8216,
      -11,
      8230,
      8217,
      -11,
      8230,
      8220,
      -11,
      8230,
      8221,
      -11,
      89,
      8226,
      -2
    ]
  },
  "Roboto|regular|italic": {
    emSize: 80,
    commonLineHeight: 106,
    capTop: 27,
    advances: [
      20,
      20,
      25,
      48,
      44,
      57,
      49,
      14,
      27,
      27,
      34,
      44,
      16,
      22,
      21,
      32,
      44,
      44,
      44,
      44,
      44,
      44,
      44,
      44,
      44,
      44,
      19,
      17,
      40,
      43,
      41,
      37,
      70,
      51,
      49,
      51,
      51,
      44,
      43,
      53,
      56,
      21,
      43,
      49,
      42,
      68,
      56,
      54,
      49,
      54,
      48,
      46,
      47,
      51,
      50,
      69,
      49,
      47,
      47,
      21,
      32,
      21,
      33,
      35,
      24,
      43,
      44,
      41,
      44,
      41,
      27,
      44,
      43,
      19,
      19,
      40,
      19,
      68,
      43,
      45,
      44,
      44,
      27,
      40,
      26,
      43,
      38,
      59,
      39,
      37,
      39,
      27,
      19,
      27,
      53
    ],
    extraAdvances: [
      162,
      43,
      163,
      45,
      165,
      41,
      176,
      29,
      183,
      21,
      215,
      42,
      8211,
      51,
      8212,
      61,
      8216,
      16,
      8217,
      16,
      8220,
      28,
      8221,
      28,
      8226,
      27,
      8230,
      52,
      8249,
      24,
      8250,
      24,
      8364,
      44,
      8377,
      40,
      8593,
      25,
      8595,
      25
    ],
    kernings: [
      32,
      84,
      -2,
      34,
      34,
      -4,
      34,
      39,
      -4,
      34,
      65,
      -5,
      34,
      97,
      -2,
      34,
      99,
      -2,
      34,
      110,
      -1,
      34,
      111,
      -2,
      34,
      115,
      -3,
      39,
      34,
      -4,
      39,
      39,
      -4,
      39,
      65,
      -5,
      39,
      97,
      -2,
      39,
      99,
      -2,
      39,
      110,
      -1,
      39,
      111,
      -2,
      39,
      115,
      -3,
      40,
      86,
      1,
      40,
      87,
      1,
      40,
      89,
      1,
      44,
      34,
      -7,
      44,
      39,
      -7,
      46,
      34,
      -7,
      46,
      39,
      -7,
      47,
      47,
      -9,
      65,
      34,
      -5,
      65,
      39,
      -5,
      65,
      63,
      -2,
      65,
      84,
      -5,
      65,
      85,
      -1,
      65,
      86,
      -3,
      65,
      87,
      -3,
      65,
      89,
      -4,
      65,
      116,
      -1,
      65,
      118,
      -2,
      65,
      119,
      -1,
      66,
      84,
      -1,
      66,
      86,
      -1,
      66,
      89,
      -2,
      67,
      41,
      -1,
      67,
      84,
      -1,
      67,
      125,
      -1,
      69,
      84,
      1,
      69,
      99,
      -1,
      69,
      102,
      -1,
      69,
      111,
      -1,
      69,
      117,
      -1,
      69,
      118,
      -1,
      69,
      119,
      -1,
      70,
      44,
      -9,
      70,
      46,
      -9,
      70,
      65,
      -7,
      70,
      74,
      -10,
      70,
      84,
      1,
      70,
      97,
      -1,
      70,
      99,
      -1,
      70,
      111,
      -1,
      70,
      114,
      -1,
      70,
      117,
      -1,
      70,
      118,
      -1,
      72,
      65,
      1,
      72,
      84,
      -1,
      72,
      88,
      1,
      72,
      89,
      -1,
      75,
      45,
      -2,
      75,
      79,
      -1,
      75,
      99,
      -1,
      75,
      110,
      -1,
      75,
      111,
      -1,
      75,
      117,
      -1,
      75,
      118,
      -2,
      75,
      119,
      -2,
      76,
      34,
      -13,
      76,
      39,
      -13,
      76,
      65,
      1,
      76,
      79,
      -3,
      76,
      84,
      -11,
      76,
      85,
      -2,
      76,
      86,
      -7,
      76,
      87,
      -6,
      76,
      89,
      -9,
      76,
      117,
      -2,
      76,
      118,
      -5,
      76,
      119,
      -4,
      79,
      44,
      -4,
      79,
      46,
      -4,
      79,
      65,
      -1,
      79,
      84,
      -1,
      79,
      86,
      -1,
      79,
      88,
      -1,
      79,
      89,
      -2,
      79,
      90,
      -1,
      80,
      44,
      -13,
      80,
      46,
      -13,
      80,
      65,
      -5,
      80,
      74,
      -8,
      80,
      88,
      -1,
      80,
      90,
      -1,
      80,
      99,
      -1,
      80,
      111,
      -1,
      80,
      116,
      1,
      80,
      118,
      1,
      81,
      84,
      -2,
      81,
      86,
      -1,
      81,
      87,
      -1,
      81,
      89,
      -1,
      82,
      84,
      -3,
      82,
      86,
      -1,
      82,
      89,
      -2,
      84,
      32,
      -2,
      84,
      44,
      -9,
      84,
      45,
      -9,
      84,
      46,
      -9,
      84,
      65,
      -3,
      84,
      74,
      -9,
      84,
      79,
      -1,
      84,
      83,
      -1,
      84,
      84,
      1,
      84,
      86,
      1,
      84,
      87,
      1,
      84,
      89,
      1,
      84,
      97,
      -4,
      84,
      99,
      -4,
      84,
      110,
      -4,
      84,
      111,
      -4,
      84,
      114,
      -3,
      84,
      115,
      -5,
      84,
      117,
      -4,
      84,
      118,
      -3,
      84,
      119,
      -2,
      84,
      120,
      -3,
      84,
      122,
      -2,
      85,
      65,
      -1,
      86,
      41,
      1,
      86,
      44,
      -9,
      86,
      45,
      -1,
      86,
      46,
      -9,
      86,
      65,
      -3,
      86,
      79,
      -1,
      86,
      93,
      1,
      86,
      97,
      -2,
      86,
      99,
      -2,
      86,
      111,
      -2,
      86,
      114,
      -1,
      86,
      117,
      -1,
      86,
      125,
      1,
      87,
      41,
      1,
      87,
      44,
      -5,
      87,
      45,
      -2,
      87,
      46,
      -5,
      87,
      65,
      -2,
      87,
      84,
      1,
      87,
      97,
      -1,
      87,
      99,
      -1,
      87,
      111,
      -1,
      87,
      114,
      -1,
      87,
      117,
      -1,
      87,
      125,
      1,
      88,
      45,
      -2,
      88,
      79,
      -1,
      88,
      86,
      1,
      88,
      99,
      -1,
      88,
      111,
      -1,
      88,
      117,
      -1,
      88,
      118,
      -1,
      89,
      38,
      -1,
      89,
      41,
      1,
      89,
      42,
      -2,
      89,
      44,
      -8,
      89,
      45,
      -2,
      89,
      46,
      -8,
      89,
      65,
      -4,
      89,
      74,
      -4,
      89,
      79,
      -1,
      89,
      83,
      -1,
      89,
      84,
      1,
      89,
      85,
      -4,
      89,
      86,
      1,
      89,
      87,
      1,
      89,
      88,
      1,
      89,
      89,
      1,
      89,
      93,
      1,
      89,
      97,
      -3,
      89,
      99,
      -3,
      89,
      102,
      -1,
      89,
      110,
      -2,
      89,
      111,
      -3,
      89,
      114,
      -2,
      89,
      115,
      -2,
      89,
      116,
      -1,
      89,
      117,
      -2,
      89,
      118,
      -1,
      89,
      120,
      -1,
      89,
      122,
      -1,
      89,
      125,
      1,
      90,
      65,
      1,
      90,
      79,
      -1,
      90,
      99,
      -1,
      90,
      111,
      -1,
      90,
      117,
      -1,
      90,
      118,
      -1,
      90,
      119,
      -1,
      91,
      74,
      -1,
      91,
      85,
      -1,
      97,
      34,
      -3,
      97,
      39,
      -3,
      97,
      118,
      -1,
      98,
      34,
      -1,
      98,
      39,
      -1,
      98,
      120,
      -1,
      98,
      122,
      -1,
      101,
      34,
      -1,
      101,
      39,
      -1,
      101,
      118,
      -1,
      102,
      34,
      1,
      102,
      39,
      1,
      102,
      41,
      1,
      102,
      93,
      1,
      102,
      99,
      -1,
      102,
      125,
      1,
      107,
      99,
      -1,
      110,
      34,
      -4,
      110,
      39,
      -4,
      111,
      34,
      -5,
      111,
      39,
      -5,
      111,
      118,
      -1,
      111,
      120,
      -1,
      111,
      122,
      -1,
      114,
      34,
      1,
      114,
      39,
      1,
      114,
      44,
      -5,
      114,
      46,
      -5,
      114,
      97,
      -2,
      114,
      99,
      -1,
      114,
      102,
      1,
      114,
      111,
      -1,
      114,
      116,
      2,
      114,
      118,
      1,
      114,
      119,
      1,
      116,
      111,
      -1,
      118,
      34,
      1,
      118,
      39,
      1,
      118,
      44,
      -4,
      118,
      46,
      -4,
      118,
      97,
      -1,
      118,
      99,
      -1,
      118,
      102,
      1,
      118,
      111,
      -1,
      119,
      44,
      -5,
      119,
      46,
      -5,
      120,
      99,
      -1,
      120,
      111,
      -1,
      122,
      99,
      -1,
      122,
      111,
      -1,
      123,
      74,
      -1,
      123,
      85,
      -1,
      34,
      8216,
      -4,
      34,
      8217,
      -4,
      34,
      8220,
      -4,
      34,
      8221,
      -4,
      39,
      8216,
      -4,
      39,
      8217,
      -4,
      39,
      8220,
      -4,
      39,
      8221,
      -4,
      44,
      8216,
      -7,
      44,
      8217,
      -7,
      44,
      8220,
      -7,
      44,
      8221,
      -7,
      46,
      8216,
      -7,
      46,
      8217,
      -7,
      46,
      8220,
      -7,
      46,
      8221,
      -7,
      65,
      8216,
      -5,
      65,
      8217,
      -5,
      65,
      8220,
      -5,
      65,
      8221,
      -5,
      68,
      8230,
      -4,
      70,
      8230,
      -9,
      75,
      8211,
      -2,
      75,
      8212,
      -2,
      76,
      8216,
      -13,
      76,
      8217,
      -13,
      76,
      8220,
      -13,
      76,
      8221,
      -13,
      79,
      8230,
      -4,
      80,
      8230,
      -13,
      84,
      8230,
      -9,
      84,
      8211,
      -9,
      84,
      8212,
      -9,
      86,
      8230,
      -9,
      86,
      8211,
      -1,
      86,
      8212,
      -1,
      87,
      8230,
      -5,
      87,
      8211,
      -2,
      87,
      8212,
      -2,
      88,
      8211,
      -2,
      88,
      8212,
      -2,
      89,
      8230,
      -8,
      89,
      8211,
      -2,
      89,
      8212,
      -2,
      97,
      8216,
      -3,
      97,
      8217,
      -3,
      97,
      8220,
      -3,
      97,
      8221,
      -3,
      98,
      8216,
      -1,
      98,
      8217,
      -1,
      98,
      8220,
      -1,
      98,
      8221,
      -1,
      101,
      8216,
      -1,
      101,
      8217,
      -3,
      101,
      8220,
      -1,
      101,
      8221,
      -1,
      102,
      8216,
      1,
      102,
      8217,
      1,
      102,
      8220,
      1,
      102,
      8221,
      1,
      104,
      8216,
      -4,
      104,
      8217,
      -3,
      104,
      8220,
      -4,
      104,
      8221,
      -4,
      109,
      8216,
      -4,
      109,
      8217,
      -3,
      109,
      8220,
      -4,
      109,
      8221,
      -4,
      110,
      8216,
      -4,
      110,
      8217,
      -3,
      110,
      8220,
      -4,
      110,
      8221,
      -4,
      111,
      8216,
      -5,
      111,
      8217,
      -3,
      111,
      8220,
      -5,
      111,
      8221,
      -5,
      112,
      8216,
      -1,
      112,
      8217,
      -1,
      112,
      8220,
      -1,
      112,
      8221,
      -1,
      114,
      8216,
      1,
      114,
      8217,
      1,
      114,
      8220,
      1,
      114,
      8221,
      1,
      114,
      8230,
      -5,
      118,
      8216,
      1,
      118,
      8217,
      1,
      118,
      8220,
      1,
      118,
      8221,
      1,
      118,
      8230,
      -4,
      119,
      8230,
      -5,
      121,
      8216,
      1,
      121,
      8217,
      1,
      121,
      8220,
      1,
      121,
      8221,
      1,
      121,
      8230,
      -4,
      8216,
      34,
      -4,
      8216,
      39,
      -4,
      8216,
      65,
      -5,
      8216,
      97,
      -2,
      8216,
      99,
      -2,
      8216,
      100,
      -2,
      8216,
      101,
      -2,
      8216,
      103,
      -2,
      8216,
      109,
      -1,
      8216,
      110,
      -1,
      8216,
      111,
      -2,
      8216,
      112,
      -1,
      8216,
      113,
      -2,
      8216,
      115,
      -3,
      8216,
      8216,
      -4,
      8216,
      8217,
      -4,
      8216,
      8220,
      -4,
      8216,
      8221,
      -4,
      8217,
      34,
      -4,
      8217,
      39,
      -4,
      8217,
      65,
      -5,
      8217,
      97,
      -2,
      8217,
      99,
      -2,
      8217,
      100,
      -2,
      8217,
      101,
      -2,
      8217,
      103,
      -2,
      8217,
      104,
      1,
      8217,
      107,
      1,
      8217,
      108,
      1,
      8217,
      109,
      -1,
      8217,
      110,
      -1,
      8217,
      111,
      -5,
      8217,
      112,
      -1,
      8217,
      113,
      -2,
      8217,
      115,
      -4,
      8217,
      8216,
      -4,
      8217,
      8217,
      -4,
      8217,
      8220,
      -4,
      8217,
      8221,
      -4,
      8220,
      34,
      -4,
      8220,
      39,
      -4,
      8220,
      65,
      -5,
      8220,
      97,
      -2,
      8220,
      99,
      -2,
      8220,
      100,
      -2,
      8220,
      101,
      -2,
      8220,
      103,
      -2,
      8220,
      109,
      -1,
      8220,
      110,
      -1,
      8220,
      111,
      -2,
      8220,
      112,
      -1,
      8220,
      113,
      -2,
      8220,
      115,
      -3,
      8220,
      8216,
      -4,
      8220,
      8217,
      -4,
      8220,
      8220,
      -4,
      8220,
      8221,
      -4,
      8221,
      34,
      -4,
      8221,
      39,
      -4,
      8221,
      65,
      -5,
      8221,
      97,
      -2,
      8221,
      99,
      -2,
      8221,
      100,
      -2,
      8221,
      101,
      -2,
      8221,
      103,
      -2,
      8221,
      109,
      -1,
      8221,
      110,
      -1,
      8221,
      111,
      -2,
      8221,
      112,
      -1,
      8221,
      113,
      -2,
      8221,
      115,
      -3,
      8221,
      8216,
      -4,
      8221,
      8217,
      -4,
      8221,
      8220,
      -4,
      8221,
      8221,
      -4,
      8230,
      34,
      -7,
      8230,
      39,
      -7,
      8230,
      8216,
      -7,
      8230,
      8217,
      -7,
      8230,
      8220,
      -7,
      8230,
      8221,
      -7,
      89,
      8226,
      -2
    ]
  },
  "Roboto|regular|normal": {
    emSize: 80,
    commonLineHeight: 106,
    capTop: 27,
    advances: [
      20,
      21,
      26,
      49,
      45,
      59,
      50,
      14,
      27,
      28,
      34,
      45,
      16,
      22,
      21,
      33,
      45,
      45,
      45,
      45,
      45,
      45,
      45,
      45,
      45,
      45,
      19,
      17,
      41,
      44,
      42,
      38,
      72,
      52,
      50,
      52,
      52,
      45,
      44,
      54,
      57,
      22,
      44,
      50,
      43,
      70,
      57,
      55,
      50,
      55,
      49,
      47,
      48,
      52,
      51,
      71,
      50,
      48,
      48,
      21,
      33,
      21,
      33,
      36,
      25,
      44,
      45,
      42,
      45,
      42,
      28,
      45,
      44,
      19,
      19,
      41,
      19,
      70,
      44,
      46,
      45,
      45,
      27,
      41,
      26,
      44,
      39,
      60,
      40,
      38,
      40,
      27,
      19,
      27,
      54
    ],
    extraAdvances: [
      162,
      44,
      163,
      46,
      165,
      42,
      176,
      30,
      183,
      21,
      215,
      43,
      8211,
      53,
      8212,
      62,
      8216,
      16,
      8217,
      16,
      8220,
      28,
      8221,
      29,
      8226,
      27,
      8230,
      54,
      8249,
      24,
      8250,
      24,
      8364,
      45,
      8377,
      41,
      8593,
      25,
      8595,
      25
    ],
    kernings: [
      32,
      84,
      -2,
      34,
      34,
      -4,
      34,
      39,
      -4,
      34,
      65,
      -5,
      34,
      97,
      -2,
      34,
      99,
      -2,
      34,
      110,
      -1,
      34,
      111,
      -2,
      34,
      115,
      -3,
      39,
      34,
      -4,
      39,
      39,
      -4,
      39,
      65,
      -5,
      39,
      97,
      -2,
      39,
      99,
      -2,
      39,
      110,
      -1,
      39,
      111,
      -2,
      39,
      115,
      -3,
      40,
      86,
      1,
      40,
      87,
      1,
      40,
      89,
      1,
      44,
      34,
      -7,
      44,
      39,
      -7,
      46,
      34,
      -7,
      46,
      39,
      -7,
      47,
      47,
      -9,
      65,
      34,
      -5,
      65,
      39,
      -5,
      65,
      63,
      -2,
      65,
      84,
      -5,
      65,
      85,
      -1,
      65,
      86,
      -3,
      65,
      87,
      -3,
      65,
      89,
      -4,
      65,
      116,
      -1,
      65,
      118,
      -2,
      65,
      119,
      -1,
      66,
      84,
      -1,
      66,
      86,
      -1,
      66,
      89,
      -2,
      67,
      41,
      -1,
      67,
      84,
      -1,
      67,
      125,
      -1,
      69,
      84,
      1,
      69,
      99,
      -1,
      69,
      102,
      -1,
      69,
      111,
      -1,
      69,
      117,
      -1,
      69,
      118,
      -1,
      69,
      119,
      -1,
      70,
      44,
      -9,
      70,
      46,
      -9,
      70,
      65,
      -7,
      70,
      74,
      -10,
      70,
      84,
      1,
      70,
      97,
      -1,
      70,
      99,
      -1,
      70,
      111,
      -1,
      70,
      114,
      -1,
      70,
      117,
      -1,
      70,
      118,
      -1,
      72,
      65,
      1,
      72,
      84,
      -1,
      72,
      88,
      1,
      72,
      89,
      -1,
      75,
      45,
      -2,
      75,
      79,
      -1,
      75,
      99,
      -1,
      75,
      110,
      -1,
      75,
      111,
      -1,
      75,
      117,
      -1,
      75,
      118,
      -2,
      75,
      119,
      -2,
      76,
      34,
      -13,
      76,
      39,
      -13,
      76,
      65,
      1,
      76,
      79,
      -3,
      76,
      84,
      -11,
      76,
      85,
      -2,
      76,
      86,
      -7,
      76,
      87,
      -6,
      76,
      89,
      -9,
      76,
      117,
      -2,
      76,
      118,
      -5,
      76,
      119,
      -4,
      79,
      44,
      -4,
      79,
      46,
      -4,
      79,
      65,
      -1,
      79,
      84,
      -1,
      79,
      86,
      -1,
      79,
      88,
      -1,
      79,
      89,
      -2,
      79,
      90,
      -1,
      80,
      44,
      -13,
      80,
      46,
      -13,
      80,
      65,
      -5,
      80,
      74,
      -8,
      80,
      88,
      -1,
      80,
      90,
      -1,
      80,
      99,
      -1,
      80,
      111,
      -1,
      80,
      116,
      1,
      80,
      118,
      1,
      81,
      84,
      -2,
      81,
      86,
      -1,
      81,
      87,
      -1,
      81,
      89,
      -1,
      82,
      84,
      -3,
      82,
      86,
      -1,
      82,
      89,
      -2,
      84,
      32,
      -2,
      84,
      44,
      -9,
      84,
      45,
      -9,
      84,
      46,
      -9,
      84,
      65,
      -3,
      84,
      74,
      -9,
      84,
      79,
      -1,
      84,
      83,
      -1,
      84,
      84,
      1,
      84,
      86,
      1,
      84,
      87,
      1,
      84,
      89,
      1,
      84,
      97,
      -4,
      84,
      99,
      -4,
      84,
      110,
      -4,
      84,
      111,
      -4,
      84,
      114,
      -3,
      84,
      115,
      -5,
      84,
      117,
      -4,
      84,
      118,
      -3,
      84,
      119,
      -2,
      84,
      120,
      -3,
      84,
      122,
      -2,
      85,
      65,
      -1,
      86,
      41,
      1,
      86,
      44,
      -9,
      86,
      45,
      -1,
      86,
      46,
      -9,
      86,
      65,
      -3,
      86,
      79,
      -1,
      86,
      93,
      1,
      86,
      97,
      -2,
      86,
      99,
      -2,
      86,
      111,
      -2,
      86,
      114,
      -1,
      86,
      117,
      -1,
      86,
      125,
      1,
      87,
      41,
      1,
      87,
      44,
      -5,
      87,
      45,
      -2,
      87,
      46,
      -5,
      87,
      65,
      -2,
      87,
      84,
      1,
      87,
      97,
      -1,
      87,
      99,
      -1,
      87,
      111,
      -1,
      87,
      114,
      -1,
      87,
      117,
      -1,
      87,
      125,
      1,
      88,
      45,
      -2,
      88,
      79,
      -1,
      88,
      86,
      1,
      88,
      99,
      -1,
      88,
      111,
      -1,
      88,
      117,
      -1,
      88,
      118,
      -1,
      89,
      38,
      -1,
      89,
      41,
      1,
      89,
      42,
      -2,
      89,
      44,
      -8,
      89,
      45,
      -2,
      89,
      46,
      -8,
      89,
      65,
      -4,
      89,
      74,
      -4,
      89,
      79,
      -1,
      89,
      83,
      -1,
      89,
      84,
      1,
      89,
      85,
      -4,
      89,
      86,
      1,
      89,
      87,
      1,
      89,
      88,
      1,
      89,
      89,
      1,
      89,
      93,
      1,
      89,
      97,
      -3,
      89,
      99,
      -3,
      89,
      102,
      -1,
      89,
      110,
      -2,
      89,
      111,
      -3,
      89,
      114,
      -2,
      89,
      115,
      -2,
      89,
      116,
      -1,
      89,
      117,
      -2,
      89,
      118,
      -1,
      89,
      120,
      -1,
      89,
      122,
      -1,
      89,
      125,
      1,
      90,
      65,
      1,
      90,
      79,
      -1,
      90,
      99,
      -1,
      90,
      111,
      -1,
      90,
      117,
      -1,
      90,
      118,
      -1,
      90,
      119,
      -1,
      91,
      74,
      -1,
      91,
      85,
      -1,
      97,
      34,
      -3,
      97,
      39,
      -3,
      97,
      118,
      -1,
      98,
      34,
      -1,
      98,
      39,
      -1,
      98,
      120,
      -1,
      98,
      122,
      -1,
      101,
      34,
      -1,
      101,
      39,
      -1,
      101,
      118,
      -1,
      102,
      34,
      1,
      102,
      39,
      1,
      102,
      41,
      1,
      102,
      93,
      1,
      102,
      99,
      -1,
      102,
      125,
      1,
      107,
      99,
      -1,
      110,
      34,
      -4,
      110,
      39,
      -4,
      111,
      34,
      -5,
      111,
      39,
      -5,
      111,
      118,
      -1,
      111,
      120,
      -1,
      111,
      122,
      -1,
      114,
      34,
      1,
      114,
      39,
      1,
      114,
      44,
      -5,
      114,
      46,
      -5,
      114,
      97,
      -2,
      114,
      99,
      -1,
      114,
      102,
      1,
      114,
      111,
      -1,
      114,
      116,
      2,
      114,
      118,
      1,
      114,
      119,
      1,
      116,
      111,
      -1,
      118,
      34,
      1,
      118,
      39,
      1,
      118,
      44,
      -4,
      118,
      46,
      -4,
      118,
      97,
      -1,
      118,
      99,
      -1,
      118,
      102,
      1,
      118,
      111,
      -1,
      119,
      44,
      -5,
      119,
      46,
      -5,
      120,
      99,
      -1,
      120,
      111,
      -1,
      122,
      99,
      -1,
      122,
      111,
      -1,
      123,
      74,
      -1,
      123,
      85,
      -1,
      34,
      8216,
      -4,
      34,
      8217,
      -4,
      34,
      8220,
      -4,
      34,
      8221,
      -4,
      39,
      8216,
      -4,
      39,
      8217,
      -4,
      39,
      8220,
      -4,
      39,
      8221,
      -4,
      44,
      8216,
      -7,
      44,
      8217,
      -7,
      44,
      8220,
      -7,
      44,
      8221,
      -7,
      46,
      8216,
      -7,
      46,
      8217,
      -7,
      46,
      8220,
      -7,
      46,
      8221,
      -7,
      65,
      8216,
      -5,
      65,
      8217,
      -5,
      65,
      8220,
      -5,
      65,
      8221,
      -5,
      68,
      8230,
      -4,
      70,
      8230,
      -9,
      75,
      8211,
      -2,
      75,
      8212,
      -2,
      76,
      8216,
      -13,
      76,
      8217,
      -13,
      76,
      8220,
      -13,
      76,
      8221,
      -13,
      79,
      8230,
      -4,
      80,
      8230,
      -13,
      84,
      8230,
      -9,
      84,
      8211,
      -9,
      84,
      8212,
      -9,
      86,
      8230,
      -9,
      86,
      8211,
      -1,
      86,
      8212,
      -1,
      87,
      8230,
      -5,
      87,
      8211,
      -2,
      87,
      8212,
      -2,
      88,
      8211,
      -2,
      88,
      8212,
      -2,
      89,
      8230,
      -8,
      89,
      8211,
      -2,
      89,
      8212,
      -2,
      97,
      8216,
      -3,
      97,
      8217,
      -3,
      97,
      8220,
      -3,
      97,
      8221,
      -3,
      98,
      8216,
      -1,
      98,
      8217,
      -1,
      98,
      8220,
      -1,
      98,
      8221,
      -1,
      101,
      8216,
      -1,
      101,
      8217,
      -3,
      101,
      8220,
      -1,
      101,
      8221,
      -1,
      102,
      8216,
      1,
      102,
      8217,
      1,
      102,
      8220,
      1,
      102,
      8221,
      1,
      104,
      8216,
      -4,
      104,
      8217,
      -3,
      104,
      8220,
      -4,
      104,
      8221,
      -4,
      109,
      8216,
      -4,
      109,
      8217,
      -3,
      109,
      8220,
      -4,
      109,
      8221,
      -4,
      110,
      8216,
      -4,
      110,
      8217,
      -3,
      110,
      8220,
      -4,
      110,
      8221,
      -4,
      111,
      8216,
      -5,
      111,
      8217,
      -3,
      111,
      8220,
      -5,
      111,
      8221,
      -5,
      112,
      8216,
      -1,
      112,
      8217,
      -1,
      112,
      8220,
      -1,
      112,
      8221,
      -1,
      114,
      8216,
      1,
      114,
      8217,
      1,
      114,
      8220,
      1,
      114,
      8221,
      1,
      114,
      8230,
      -5,
      118,
      8216,
      1,
      118,
      8217,
      1,
      118,
      8220,
      1,
      118,
      8221,
      1,
      118,
      8230,
      -4,
      119,
      8230,
      -5,
      121,
      8216,
      1,
      121,
      8217,
      1,
      121,
      8220,
      1,
      121,
      8221,
      1,
      121,
      8230,
      -4,
      8216,
      34,
      -4,
      8216,
      39,
      -4,
      8216,
      65,
      -5,
      8216,
      97,
      -2,
      8216,
      99,
      -2,
      8216,
      100,
      -2,
      8216,
      101,
      -2,
      8216,
      103,
      -2,
      8216,
      109,
      -1,
      8216,
      110,
      -1,
      8216,
      111,
      -2,
      8216,
      112,
      -1,
      8216,
      113,
      -2,
      8216,
      115,
      -3,
      8216,
      8216,
      -4,
      8216,
      8217,
      -4,
      8216,
      8220,
      -4,
      8216,
      8221,
      -4,
      8217,
      34,
      -4,
      8217,
      39,
      -4,
      8217,
      65,
      -5,
      8217,
      97,
      -2,
      8217,
      99,
      -2,
      8217,
      100,
      -2,
      8217,
      101,
      -2,
      8217,
      103,
      -2,
      8217,
      104,
      1,
      8217,
      107,
      1,
      8217,
      108,
      1,
      8217,
      109,
      -1,
      8217,
      110,
      -1,
      8217,
      111,
      -5,
      8217,
      112,
      -1,
      8217,
      113,
      -2,
      8217,
      115,
      -4,
      8217,
      8216,
      -4,
      8217,
      8217,
      -4,
      8217,
      8220,
      -4,
      8217,
      8221,
      -4,
      8220,
      34,
      -4,
      8220,
      39,
      -4,
      8220,
      65,
      -5,
      8220,
      97,
      -2,
      8220,
      99,
      -2,
      8220,
      100,
      -2,
      8220,
      101,
      -2,
      8220,
      103,
      -2,
      8220,
      109,
      -1,
      8220,
      110,
      -1,
      8220,
      111,
      -2,
      8220,
      112,
      -1,
      8220,
      113,
      -2,
      8220,
      115,
      -3,
      8220,
      8216,
      -4,
      8220,
      8217,
      -4,
      8220,
      8220,
      -4,
      8220,
      8221,
      -4,
      8221,
      34,
      -4,
      8221,
      39,
      -4,
      8221,
      65,
      -5,
      8221,
      97,
      -2,
      8221,
      99,
      -2,
      8221,
      100,
      -2,
      8221,
      101,
      -2,
      8221,
      103,
      -2,
      8221,
      109,
      -1,
      8221,
      110,
      -1,
      8221,
      111,
      -2,
      8221,
      112,
      -1,
      8221,
      113,
      -2,
      8221,
      115,
      -3,
      8221,
      8216,
      -4,
      8221,
      8217,
      -4,
      8221,
      8220,
      -4,
      8221,
      8221,
      -4,
      8230,
      34,
      -7,
      8230,
      39,
      -7,
      8230,
      8216,
      -7,
      8230,
      8217,
      -7,
      8230,
      8220,
      -7,
      8230,
      8221,
      -7,
      89,
      8226,
      -2
    ]
  },
  "Source Serif 4|bold|italic": {
    emSize: 80,
    commonLineHeight: 110,
    capTop: 30,
    advances: [
      17,
      24,
      38,
      47,
      44,
      73,
      59,
      22,
      31,
      31,
      38,
      44,
      25,
      28,
      25,
      31,
      44,
      44,
      44,
      44,
      44,
      44,
      44,
      44,
      44,
      44,
      25,
      25,
      44,
      44,
      44,
      37,
      69,
      55,
      51,
      48,
      55,
      47,
      45,
      53,
      60,
      30,
      29,
      54,
      45,
      73,
      56,
      54,
      48,
      54,
      53,
      40,
      49,
      55,
      48,
      71,
      52,
      46,
      44,
      28,
      30,
      28,
      44,
      44,
      32,
      46,
      43,
      38,
      46,
      38,
      27,
      43,
      46,
      26,
      23,
      42,
      25,
      69,
      47,
      43,
      44,
      44,
      37,
      34,
      28,
      47,
      42,
      64,
      46,
      43,
      40,
      28,
      25,
      28,
      44
    ],
    extraAdvances: [
      162,
      44,
      163,
      44,
      165,
      44,
      176,
      26,
      183,
      25,
      215,
      44,
      8211,
      44,
      8212,
      68,
      8216,
      22,
      8217,
      22,
      8220,
      40,
      8221,
      40,
      8230,
      70,
      8364,
      44,
      8377,
      44
    ],
    kernings: []
  },
  "Source Serif 4|bold|normal": {
    emSize: 80,
    commonLineHeight: 110,
    capTop: 30,
    advances: [
      17,
      28,
      36,
      45,
      43,
      71,
      58,
      19,
      30,
      30,
      34,
      44,
      24,
      27,
      24,
      31,
      43,
      43,
      43,
      43,
      43,
      43,
      43,
      43,
      43,
      43,
      24,
      24,
      44,
      44,
      44,
      36,
      71,
      54,
      52,
      50,
      56,
      48,
      46,
      54,
      61,
      31,
      32,
      56,
      46,
      72,
      58,
      56,
      49,
      56,
      55,
      43,
      51,
      58,
      53,
      78,
      52,
      50,
      45,
      28,
      31,
      28,
      44,
      43,
      32,
      42,
      49,
      41,
      48,
      42,
      29,
      43,
      49,
      25,
      25,
      48,
      26,
      73,
      49,
      45,
      49,
      47,
      37,
      36,
      29,
      49,
      42,
      63,
      44,
      43,
      37,
      27,
      25,
      27,
      44
    ],
    extraAdvances: [
      162,
      43,
      163,
      43,
      165,
      43,
      176,
      26,
      183,
      24,
      215,
      44,
      8211,
      43,
      8212,
      67,
      8216,
      18,
      8217,
      18,
      8220,
      35,
      8221,
      35,
      8230,
      68,
      8364,
      43,
      8377,
      43
    ],
    kernings: []
  },
  "Source Serif 4|regular|italic": {
    emSize: 80,
    commonLineHeight: 110,
    capTop: 29,
    advances: [
      19,
      23,
      34,
      44,
      41,
      68,
      56,
      21,
      30,
      30,
      38,
      42,
      24,
      25,
      24,
      26,
      41,
      41,
      41,
      41,
      41,
      41,
      41,
      41,
      41,
      41,
      24,
      24,
      42,
      42,
      42,
      36,
      70,
      54,
      50,
      47,
      56,
      47,
      44,
      52,
      61,
      29,
      28,
      53,
      45,
      74,
      58,
      53,
      45,
      53,
      52,
      40,
      46,
      57,
      48,
      70,
      53,
      44,
      43,
      26,
      25,
      26,
      42,
      41,
      32,
      42,
      40,
      33,
      42,
      33,
      24,
      39,
      44,
      24,
      20,
      38,
      22,
      65,
      45,
      39,
      41,
      39,
      32,
      29,
      26,
      46,
      38,
      58,
      42,
      38,
      37,
      30,
      23,
      30,
      42
    ],
    extraAdvances: [
      162,
      41,
      163,
      41,
      165,
      41,
      176,
      26,
      183,
      24,
      215,
      42,
      8211,
      41,
      8212,
      65,
      8216,
      22,
      8217,
      22,
      8220,
      38,
      8221,
      38,
      8230,
      66,
      8364,
      41,
      8377,
      41
    ],
    kernings: []
  },
  "Source Serif 4|regular|normal": {
    emSize: 80,
    commonLineHeight: 110,
    capTop: 29,
    advances: [
      19,
      23,
      28,
      42,
      40,
      70,
      58,
      15,
      27,
      27,
      35,
      42,
      24,
      25,
      24,
      26,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      24,
      24,
      42,
      42,
      42,
      33,
      67,
      53,
      50,
      50,
      57,
      48,
      46,
      55,
      63,
      30,
      30,
      53,
      48,
      72,
      59,
      57,
      47,
      57,
      52,
      41,
      48,
      58,
      54,
      77,
      52,
      51,
      44,
      26,
      26,
      26,
      42,
      41,
      32,
      41,
      46,
      39,
      45,
      41,
      28,
      41,
      48,
      24,
      22,
      44,
      24,
      72,
      48,
      44,
      47,
      45,
      34,
      35,
      26,
      47,
      40,
      61,
      42,
      41,
      36,
      28,
      23,
      28,
      42
    ],
    extraAdvances: [
      162,
      40,
      163,
      40,
      165,
      40,
      176,
      26,
      183,
      24,
      215,
      42,
      8211,
      41,
      8212,
      65,
      8216,
      17,
      8217,
      17,
      8220,
      33,
      8221,
      33,
      8230,
      66,
      8364,
      40,
      8377,
      40
    ],
    kernings: []
  }
}, N = 65532, y = (() => {
  const e = /* @__PURE__ */ new Map();
  for (const [t, n] of Object.entries(_)) e.set(t, C(n));
  return e;
})();
function n1(e, t) {
  if (_[e] !== void 0) return null;
  const n = y.get(e);
  return y.set(e, C(t)), () => {
    n ? y.set(e, n) : y.delete(e);
  };
}
function R(e, t) {
  return e * 65536 + t;
}
function C(e) {
  const t = /* @__PURE__ */ new Map();
  for (let o = 0; o + 2 < e.kernings.length; o += 3) t.set(R(e.kernings[o], e.kernings[o + 1]), e.kernings[o + 2]);
  const n = /* @__PURE__ */ new Map();
  for (let o = 0; o + 1 < e.extraAdvances.length; o += 2) n.set(e.extraAdvances[o], e.extraAdvances[o + 1]);
  const s = /* @__PURE__ */ new Map(), i = e.emSize, r = {
    id: N,
    width: i,
    height: i,
    xoffset: 0,
    yoffset: 0,
    xadvance: i * 0.5,
    page: -1
  }, a = (o) => {
    const c = s.get(o);
    if (c) return c;
    const g = o - 32, f = g >= 0 && g < e.advances.length ? e.advances[g] : n.get(o) ?? -1, l = f >= 0 ? {
      id: o,
      width: 0,
      height: 0,
      xoffset: 0,
      yoffset: 0,
      xadvance: f,
      page: -1
    } : r;
    return s.set(o, l), l;
  };
  return {
    emSize: i,
    commonLineHeight: e.commonLineHeight,
    capTop: e.capTop,
    fontApi: {
      getChar: a,
      getKerning: (o, c) => t.get(R(o, c)) ?? 0
    }
  };
}
function Y(e, t, n) {
  return D(y, {
    family: e,
    weight: t,
    style: n
  });
}
function $(e) {
  return e / 100;
}
function o1(e, t) {
  return e * t.emSize;
}
function a1(e, t, n) {
  return n <= 0 ? e : e * t.emSize / n;
}
function s1(e, t) {
  return t.distanceRange <= 0 ? 0 : 2 * e * t.emSize / t.distanceRange;
}
function E(e) {
  switch (e) {
    case "left":
      return 0;
    case "center":
      return 0.5;
    case "right":
      return 1;
  }
}
function K(e, t, n, s) {
  switch (e) {
    case "top":
      return -t * s;
    case "middle":
      return -((t + n) / 2) * s;
    case "bottom":
      return -n * s;
  }
}
var S = 32, P = 1e-6;
function k(e, t, n, s) {
  for (let i = 0; i < t.length; i++) {
    let r = t.charCodeAt(i);
    if (r === 9 && (r = S), r === 13) continue;
    const a = n.getChar(r);
    e.lastId !== void 0 && (e.cursor += n.getKerning(e.lastId, a.id)), e.cursor += a.xadvance + s, e.lastId = a.id, e.glyphs++;
  }
}
function W(e, t) {
  return Math.max(0, e.cursor - (e.glyphs > 0 ? t : 0));
}
function G(e, t, n, s, i, r) {
  const a = Math.max(n * (1 + P), n + r), o = {
    cursor: 0,
    lastId: void 0,
    glyphs: 0
  };
  if (k(o, e, s, i), W(o, i) <= a) return [{
    text: e,
    start: t,
    softBreak: !1
  }];
  const c = [];
  let g = 0, f = -1, l = {
    cursor: 0,
    lastId: void 0,
    glyphs: 0
  };
  for (let h = 0; h < e.length; ) {
    if (e.charCodeAt(h) === S) {
      h++;
      continue;
    }
    const m = h;
    for (; h < e.length && e.charCodeAt(h) !== S; ) h++;
    const p = h, d = { ...l };
    k(d, e.slice(f < 0 ? g : f, p), s, i), f > g && W(d, i) > n ? (c.push({
      text: e.slice(g, m),
      start: t + g,
      softBreak: !0
    }), g = m, l = {
      cursor: 0,
      lastId: void 0,
      glyphs: 0
    }, k(l, e.slice(m, p), s, i)) : l = d, f = p;
  }
  return c.push({
    text: e.slice(g),
    start: t + g,
    softBreak: !1
  }), c;
}
function J(e, t, n) {
  const { lineHeightUnits: s, letterSpacingUnits: i, anchorXFraction: r, maxWidthUnits: a } = t, o = t.wrapEpsilonUnits ?? 0, c = [], g = [];
  {
    let l = 0;
    for (const h of e.split(`
`))
      a !== void 0 && a > 0 ? g.push(...G(h, l, a, n, i, o)) : g.push({
        text: h,
        start: l,
        softBreak: !1
      }), l += h.length + 1;
  }
  for (let l = 0; l < g.length; l++) {
    const h = g[l], m = h.text, p = [], d = [0], U = l * s;
    let v = 0, M, A = -1, H = 0;
    for (let x = 0; x < m.length; x++) {
      let u = m.charCodeAt(x);
      if (u === 9 && (u = S), u === 13) {
        d.push(v);
        continue;
      }
      const w = n.getChar(u), O = M !== void 0 ? n.getKerning(M, w.id) : 0;
      v += O, p.push({
        char: w,
        line: l,
        position: p.length,
        x: v,
        y: U,
        sourceIndex: h.start + x
      }), v += w.xadvance + i, u !== S && (H = v - i), M = w.id, d.push(v), A = d.length - 1;
    }
    const X = h.softBreak ? Math.max(0, H) : Math.max(0, v - (p.length > 0 ? i : 0));
    if (A >= 0 && !h.softBreak) {
      const x = Math.max(d[A - 1] ?? 0, X);
      for (let u = A; u < d.length; u++) d[u] = x;
    }
    c.push({
      text: m,
      glyphs: p,
      start: h.start,
      end: h.start + m.length,
      width: X,
      caretXs: d,
      softBreak: h.softBreak
    });
  }
  const f = Math.max(0, ...c.map((l) => l.width));
  for (const l of c) {
    const h = (f - l.width) * r - r * f;
    for (const m of l.glyphs) m.x += h;
    for (let m = 0; m < l.caretXs.length; m++) l.caretXs[m] += h;
  }
  return {
    text: e,
    lines: c,
    glyphs: c.flatMap((l) => l.glyphs),
    width: f,
    height: c.length * s,
    params: t
  };
}
function j(e, t, n) {
  const s = e.lines.length, i = 1 - (t === "top" ? n : 0);
  return {
    width: e.width,
    yTop: i,
    yBot: i - s * e.params.lineHeightUnits,
    lineCount: s
  };
}
function i1(e, t, n, s) {
  const i = e.params.lineHeightUnits, r = e.lines.map((c, g) => {
    const f = 1 - g * i;
    return {
      start: c.start,
      end: c.end,
      yTop: f * t + n,
      yBottom: (f - i) * t + n,
      xMin: c.caretXs[0] * t,
      xMax: c.caretXs[c.caretXs.length - 1] * t,
      caretXs: c.caretXs.map((l) => l * t),
      softBreak: c.softBreak
    };
  });
  let a = 1 / 0, o = -1 / 0;
  for (const c of r)
    c.xMin < a && (a = c.xMin), c.xMax > o && (o = c.xMax);
  return a === 1 / 0 && (a = 0, o = 0), {
    text: e.text,
    em: s * t,
    lines: r,
    bounds: {
      xMin: a,
      xMax: o,
      yTop: r[0]?.yTop ?? 0,
      yBottom: r[r.length - 1]?.yBottom ?? 0
    }
  };
}
function r1(e, t) {
  const n = Math.max(0, Math.min(t, e.text.length));
  for (let i = 0; i < e.lines.length; i++) {
    const r = e.lines[i];
    if (!(r.softBreak && n === r.end && i + 1 < e.lines.length) && n <= r.end) {
      const a = Math.max(0, n - r.start);
      return {
        line: i,
        x: r.caretXs[Math.min(a, r.caretXs.length - 1)],
        yTop: r.yTop,
        yBottom: r.yBottom
      };
    }
  }
  const s = e.lines[e.lines.length - 1];
  return {
    line: e.lines.length - 1,
    x: s.caretXs[s.caretXs.length - 1],
    yTop: s.yTop,
    yBottom: s.yBottom
  };
}
function c1(e, t, n) {
  let s = e.lines.length - 1;
  for (let o = 0; o < e.lines.length; o++) if (n >= e.lines[o].yBottom) {
    s = o;
    break;
  }
  const i = e.lines[s];
  let r = 0, a = 1 / 0;
  for (let o = 0; o < i.caretXs.length; o++) {
    const c = Math.abs(i.caretXs[o] - t);
    c < a && (a = c, r = o);
  }
  return i.start + r;
}
function l1(e, t) {
  if (e.length === 0) return [0, 0];
  const n = (c) => /[\p{L}\p{N}_]/u.test(c);
  let s = Math.min(t, e.length - 1);
  if ((t >= e.length || !n(e[t])) && t > 0 && n(e[t - 1]) && (s = t - 1), e[s] === `
`) return [t, t];
  const i = n(e[s]), r = (c) => i ? n(c) : !n(c) && c !== `
`;
  let a = s;
  for (; a > 0 && r(e[a - 1]); ) a--;
  let o = s + 1;
  for (; o < e.length && r(e[o]); ) o++;
  return [a, o];
}
function h1(e, t, n) {
  n < t && ([t, n] = [n, t]);
  const s = [], i = e.em * 0.25;
  for (let r = 0; r < e.lines.length; r++) {
    const a = e.lines[r];
    if (n < a.start) break;
    const o = Math.max(t, a.start), c = Math.min(n, a.end);
    if (o > c) continue;
    const g = !a.softBreak && t <= a.end && n > a.end;
    if (o === c && !g) continue;
    const f = a.caretXs[o - a.start];
    let l = a.caretXs[c - a.start];
    g && (l += i), s.push({
      line: r,
      xMin: f,
      xMax: l,
      yTop: a.yTop,
      yBottom: a.yBottom
    });
  }
  return s;
}
var I = 1e-3, Q = 1e-6, V = "Roboto", g1 = "regular", f1 = "normal";
function B(e) {
  return Y(e.fontFamily ?? "Roboto", e.fontWeight ?? "regular", e.fontStyle ?? "normal");
}
function m1(e, t) {
  const n = B(t), s = t.fontFamily ?? "Roboto", i = (a, o) => n === B({
    fontFamily: V,
    fontWeight: a,
    fontStyle: o
  });
  if (s !== "Roboto" && (i(t.fontWeight, t.fontStyle) || i(void 0, void 0))) return [];
  const r = /* @__PURE__ */ new Set();
  for (const a of e) {
    const o = a.codePointAt(0);
    o <= 32 || o >= 127 && o <= 160 || /\s/u.test(a) || n.fontApi.getChar(o).id === 65532 && r.add(o);
  }
  return [...r];
}
function Z(e) {
  const t = Math.ceil(e / I - Q);
  return Math.max(1, t) * I;
}
function q(e, t, n, s) {
  if (s !== !1 && !(e == null || !(e > 0) || !(n > 0)))
    return Z(e) / n * t;
}
function e1(e, t) {
  return t > 0 ? I / t * e : 0;
}
function z(e, t) {
  return typeof e == "number" && Number.isFinite(e) ? e : t;
}
function t1(e, t) {
  const n = t ?? B(e), s = e.text ?? "Text", i = typeof s == "string" ? s : String(s), r = z(e.fontSize, 14), a = z(e.lineHeight, 1.2), o = z(e.letterSpacing, 0), c = e.anchorX ?? "center", g = e.anchorY ?? "middle", f = $(r), l = J(i, {
    lineHeightUnits: a * n.emSize,
    letterSpacingUnits: o * n.emSize,
    anchorXFraction: E(c),
    maxWidthUnits: q(e.wrapWidth, n.emSize, f, e.wrap),
    wrapEpsilonUnits: e1(n.emSize, f)
  }, n.fontApi), h = j(l, g, n.capTop), m = 1 / n.emSize, p = K(g, h.yTop * m, h.yBot * m, f);
  return {
    layout: l,
    box: h,
    scale: f,
    fontScale: m,
    unitScale: m * f,
    yWorldOffset: p
  };
}
function d1(e, t) {
  const { box: n, scale: s, fontScale: i, unitScale: r, yWorldOffset: a } = t1(e, t), o = e.anchorX ?? "center", c = n.yTop * i, g = n.yBot * i, f = n.width * r, l = (c - g) * s, h = e.slotWidth !== void 0 ? e.slotWidth : e.wrapWidth, m = h != null && h > 0 ? h : f;
  return {
    width: f,
    height: l,
    centerX: (0.5 - E(o)) * f,
    centerY: a + (c + g) / 2 * s,
    layoutCenterX: (0.5 - E(o)) * m,
    lineCount: n.lineCount
  };
}
function p1(e) {
  return [
    e.text,
    "\0",
    e.fontSize,
    "|",
    e.lineHeight,
    "|",
    e.letterSpacing,
    "|",
    e.anchorX,
    "|",
    e.anchorY,
    "|",
    e.fontFamily,
    "|",
    e.fontWeight,
    "|",
    e.fontStyle,
    "|",
    e.wrap === !1 ? "nowrap" : "",
    "|",
    e.wrapWidth ?? "",
    "|",
    e.slotWidth === void 0 ? "same" : e.slotWidth ?? "none"
  ].join("");
}
export {
  b as A,
  o1 as C,
  Y as D,
  n1 as E,
  D as M,
  L as O,
  $ as S,
  s1 as T,
  h1 as _,
  t1 as a,
  E as b,
  Z as c,
  e1 as d,
  q as f,
  c1 as g,
  J as h,
  I as i,
  F as j,
  T as k,
  B as l,
  j as m,
  f1 as n,
  d1 as o,
  r1 as p,
  g1 as r,
  m1 as s,
  V as t,
  p1 as u,
  i1 as v,
  a1 as w,
  K as x,
  l1 as y
};

//# sourceMappingURL=measure-Dkg-XulW.js.map